<template>
  <div>
    <nav-menu />
    <div class="w3-row w3-container">
      <div 
        v-if="modalTelefone"
        style="display:block"
        class="w3-modal w2-margin-top">     
        <div 
          class="w3-modal-content">
          <span 
            @click="modalTelefone = false" 
            class="w3-btn w3-display-topright w3-margin-bottom">
            &times;
          </span>
          
          <h5 class="titulo w3-text-theme">Usar telefones</h5>
          
          <div class="w3-center  w3-margin-top" style="font-size: 50px">
            <div
              class="w3-btn w3-text-white w3-green w3-margin" 
              @click="abrirTelefone(numero_telefone_atual, false, true)">
              <i class="fab fa-whatsapp"></i>
            </div>
            
            <div 
              class="w3-btn w3-text-white w3-brown w3-margin" 
              @click="abrirTelefone(numero_telefone_atual, true, false)">
              <i class="fas fa-phone-alt"></i>
            </div>
          </div>
        </div>
      </div>
      
      <div 
        class="w3-block" 
        style="padding: 5px; margin: 6px 0;">
        <h3>
          <i class="fa fa-user-tag"></i> Vida do Cliente
        </h3>
      </div>
        
      <div id="analitico-modelo-dois">
        <button
          class="w3-button w3-blue"
          v-if="!editando"
          @click="pesquisarCliente()">
          <i class="fas fa-search"></i>
          <span>Pesquisar</span>
        </button>

        <button
          class="w3-button w3-theme botao-opcoes"
          v-if="editando"
          @click="limparDadosCliente()">
          <i class="fas fa-times-circle"></i>
          <span>Cancelar</span>
        </button>
        
        <div class="uppercase titulo w3-text-theme w3-col" v-if="dados_cliente && mostrar_accordion" style="margin-top:10px; font-size:16px!important;">
          <span v-if="dados_cliente">
            <span class="w3-col">
              <legenda>
                <label>Razão social</label>
                <i slot="referencia" class="fas fa-user-tag w3-text-theme"></i>&nbsp;
              </legenda>
              {{dados_cliente.cadastro_id}} - {{dados_cliente.nome_razao_social}}
            </span>
            
            <span class="w3-col">
              <legenda>
                <label>Nome fantasia</label>
                <i slot="referencia" class="fas fa-building w3-text-theme"></i>&nbsp;
              </legenda>
              &nbsp;{{dados_cliente.nome_fantasia}}
            </span>
            
            <span class="w3-col">
              <legenda>
                <label><span v-if="dados_cliente.cnpj">CNPJ </span>
                <span v-if="dados_cliente.cpf">CPF </span></label>
                <i slot="referencia" class="fas fa-id-card w3-text-theme"></i>&nbsp;
              </legenda>
              
              <label v-if="dados_cliente.cnpj" >
                {{dados_cliente.cnpj}}
              </label>
              <label v-if="dados_cliente.cpf">
                {{dados_cliente.cpf}}
              </label>
            </span>
          </span>
        </div>
        
        <div class="w3-col s12" style="padding-left: 0px!important; padding-right: 0px!important;">
          <div class="w3-margin-top" v-if="mostrar_accordion">
            <div 
              :key="index" 
              v-show="!item.inativo" 
              v-for="(item, index) in listaAbas"
              class="w3-col s12 w3-margin-bottom"  
              :class="{'card-ativo': item.mostrar}" 
              @click="toogleCard(item.slug, !item.mostrar); verificarCliente()">
              
              <div :class="item.inativo ? 'inativo' : ''">
                <div>
                  <div style="border-radius:5px;" class="card-titulo w3-text-white w3-theme">
                    <span 
                      style="margin-left:3px;"
                      class="w3-left" >
                      <i :class="item.mostrar ? 'fas fa-sort-down' : 'fas fa-caret-right'"></i>
                    </span>
                    <label 
                      style="margin-left:3px; font-size: 16px!important;" 
                      class="w3-text-white" >
                      <i class="fas fa-book-reader" v-if="item.nome === 'Cadastro'"></i>
                      <i class="fas fa-clipboard-list" v-if="item.nome === 'Resumo'"></i>
                      <i class="fas fa-funnel-dollar" v-if="item.nome === 'Financeiro'"></i>
                      <i class="fas fa-book-dead" v-if="item.nome === 'Lista negra'"></i>
                      <i class="fas fa-cart-arrow-down" v-if="item.nome === 'Pedidos'"></i>
                      <i class="fas fa-lock-open" v-if="item.nome === 'Acumulativos em aberto'"></i>
                      <i class="fas fa-credit-card" v-if="item.nome === 'Créditos'"></i>
                      <i class="fas fa-backspace" v-if="item.nome === 'Devoluções pendentes'"></i>
                      <i class="fas fa-truck-loading" v-if="item.nome === 'Rec. na entrega não recebidos'"></i>
                      <i class="fas fa-address-book" v-if="item.nome === 'Notas do cliente'"></i>
                      <i class="fas fa-cog" v-if="item.nome === 'Ocorrências'"></i>
                      <i class="fas fa-share-alt" v-if="item.nome === 'Redes sociais'"></i>
                      &nbsp;<label style="text-decoration: underline;">{{item.nome}}</label>
                    </label>
                  </div>
                  
                  <div @click.stop.prevent>
                    <div v-if="item.mostrar">
                      <!--Inicio cadastro-->
                      
                      <div 
                        style="cursor: default; border-bottom-style: none" 
                        v-cloak
                        v-if="Object.keys(dados_cliente) && item.slug === 'cadastro'">
                        
                        <div id="tab_cadastro">
                          <div style="padding:0px" >
                            <div class="w3-bar w3-white " style="margin-top: 10px;">
                              <div :class="getClassPrincipal()">
                                <div
                                  class="tablink w3-center" 
                                  style="margin-top:5px; text-decoration:underline;" 
                                  @click="setTab('tabCadastroPrincipais')" 
                                  :class="getClasseTabAtiva('tabCadastroPrincipais')">
                                  Principais
                                </div>
                              </div>
                            
                              <div :class="getClassPrincipal()">
                                <div
                                  class="tablink w3-center" 
                                  style="margin-top:5px; text-decoration:underline;" 
                                  @click="setTab('tabCadastroReferencia')"
                                  :class="getClasseTabAtiva('tabCadastroReferencia')">
                                  Referências
                                </div>
                              </div>
                              
                              <div :class="getClassPrincipal()">
                                <div
                                  class="tablink w3-center" 
                                  style="margin-top:5px; text-decoration:underline;" 
                                  @click="setTab('tabCadastroObservacoes')" 
                                  :class="getClasseTabAtiva('tabCadastroObservacoes')">
                                  Observações
                                </div>
                              </div>
                              
                              <div 
                                :class="getClassPrincipal()"
                                v-show="pessoa_juridica">
                                <div
                                  class="tablink w3-center" 
                                  style="margin-top:5px; text-decoration:underline;" 
                                  @click="setTab('tabCadastroSocios')"
                                  :class="getClasseTabAtiva('tabCadastroSocios')">
                                  Sócios
                                </div>
                              </div>
                              
                              <div :class="getClassPrincipal()">
                                <div
                                  class="tablink w3-center" 
                                  style="margin-top:5px; text-decoration:underline;" 
                                  @click="setTab('tabCadastroSpcSerasa')" 
                                  :class="getClasseTabAtiva('tabCadastroSpcSerasa')">
                                  SPC/SERASA
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <!-- Principal -->
                          <div 
                            id="tabCadastroPrincipais"
                            class="w3-container aba w3-animate-left cards-dados w3-border w3-margin-top w3-margin-bottom">

                            <div class="w3-col s12 m12 l12" v-show="processando_cadastro_principais">
                              <div class="w3-panel w3-theme w3-card-2">
                                <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                              </div>
                            </div>

                            <div class="w3-col s12 m12 l12 w3-quarter" v-show="!processando_cadastro_principais">
                              <div class="w3-quarter" v-if="dados_cliente.nome_grupo">
                                <legenda>
                                  <label>Grupo de cliente</label>
                                  <i slot="referencia" class="fas fa-users w3-text-theme"></i>&nbsp;
                                </legenda>
                                <label>{{dados_cliente.nome_grupo}}</label>
                              </div>
                              
                              <div class="w3-quarter" v-if="dados_cliente.inscricao_estadual">
                                <legenda>
                                  <label>Inscrição Estadual</label>
                                  <i slot="referencia" class="fas fa-file-invoice w3-text-theme"></i>&nbsp;
                                </legenda>
                                <label>{{dados_cliente.inscricao_estadual}}</label>
                              </div>
                              
                              <div class="w3-quarter" v-if="dados_cliente.data_cadastro">
                                <legenda>
                                  <label>Data de cadastro</label>
                                  <i slot="referencia" class="fas fa-calendar-check w3-text-theme"></i>&nbsp;
                                </legenda>
                                <label v-if="dados_cliente.data_cadastro">
                                  {{dados_cliente.data_cadastro}}
                                </label>
                              </div>
                              
                              <div class="w3-quarter" v-if="dados_cliente.data_nascimento">
                                <legenda>
                                  <label>
                                    <span v-if="dados_cliente.tipo_pessoa === 'J'">Data fundação </span>
                                    <span v-else>Data nascimento</span>
                                  </label>
                                  <i slot="referencia" class="fas fa-birthday-cake w3-text-theme"></i>&nbsp;
                                </legenda>
                                <label
                                  readonly 
                                  v-mask="'##/##/####'"
                                  v-if="dados_cliente.data_nascimento">
                                  {{dados_cliente.data_nascimento}}
                                </label>
                              </div>
                              
                              <div class="w3-quarter">
                                <legenda>
                                  <label>Endereço</label>
                                  <i slot="referencia" class="fas fa-map-marker-alt w3-text-theme"></i>&nbsp;
                                </legenda>
                                
                                <label 
                                  readonly
                                  class="uppercase"
                                  v-if="dados_cliente.logradouro">
                                  {{dados_cliente.logradouro}}
                                </label>
                                <label class=" uppercase" readonly v-if="dados_cliente.complemento" >
                                  {{dados_cliente.complemento}}
                                </label>
                                <label 
                                  readonly
                                  class="uppercase"
                                  v-if="dados_cliente.ponto_referencia">
                                  {{dados_cliente.ponto_referencia}}
                                </label>
                                <label class="uppercase" readonly v-if="dados_cliente.nome_bairro" >
                                  {{dados_cliente.nome_bairro}}
                                </label>
                                <label class="uppercase" readonly v-if="dados_cliente.nome_cidade" >
                                  {{dados_cliente.nome_cidade}}
                                </label>
                                <label class="uppercase" readonly v-if="dados_cliente.cep" >
                                  {{dados_cliente.cep}}
                                </label>
                                <label class="uppercase" readonly v-if="dados_cliente.estado_id" >
                                  {{dados_cliente.estado_id}}
                                </label>
                              </div>
                              
                              <div class="w3-quarter" v-if="dados_cliente.orgao_publico == 'S'">
                                <label>Órgão público: </label>
                                <label class=" uppercase" readonly 
                                  v-if="dados_cliente.orgao_publico == 'N'">
                                  Nã<option value=""></option>
                                </label>
                                <label class="uppercase" readonly 
                                  v-if="dados_cliente.orgao_publico == 'S'">
                                  Sim
                                </label>
                              </div>
                            </div>
                            
                            <div class="w3-third" v-show="!processando_cadastro_principais">
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_telefone"
                                @click="mostrar_detalhes_telefone = true">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Telefones</label>
                              </p>
                                
                              <p
                                class="fundo-cabecalho"  
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_telefone"
                                @click="mostrar_detalhes_telefone = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Telefones</label>
                              </p>

                              <div v-show="mostrar_detalhes_telefone">
                                <div 
                                  :key="index"
                                  class="card-item w3-border w3-container" 
                                  v-for="(telefone, index) in telefone_cadastro">
                                    
                                  <div class="w3-col" v-if="telefone.telefone" @click="abrirTelefone(telefone.telefone, false, false)">
                                    <legenda>
                                      <label>{{ telefone.tipo_telefone_analitico }}</label>
                                      <i slot="referencia" class="fas fa-phone"></i>
                                    </legenda>
                                    <label style="text-decoration: underline;">&nbsp;{{ telefone.telefone }} </label>
                                    <label v-if="telefone.tipo_telefone_analitico">&nbsp; - {{ telefone.tipo_telefone_analitico }}</label>
                                  </div>
                                    
                                  <div class="w3-third" v-if="telefone.ramal != '0' ? telefone.ramal : '' ">
                                    <label>Ramal: </label>
                                    <label>{{ telefone.ramal != '0' ? telefone.ramal : '' }}</label>
                                  </div>
                                    
                                  <div class="w3-third" v-if="telefone.observacao">
                                    <label>Observação: </label>
                                    <label>{{ telefone.observacao }}</label>
                                  </div>
                                </div>

                                <div class="w3-animate-left w3-center" v-show="Object.keys(telefone_cadastro).length == 0">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>
                            </div>
                              
                            <div class="w3-third" v-show="!processando_cadastro_principais">

                              <p  
                                class="fundo-cabecalho" 
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_limite_credito"
                                @click="mostrar_detalhes_limite_credito = true">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Limite de crédito</label>
                              </p>
                                
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_limite_credito"
                                @click="mostrar_detalhes_limite_credito = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Limite de crédito</label>
                              </p>

                              <div v-if="mostrar_detalhes_limite_credito" >
                                <div
                                  v-show="(
                                    npz(limite_credito.limite_credito_mensal) ||
                                    npz(limite_credito.limite_credito_aprovado) ||
                                    npz(limite_credito.limite_credito_disponivel)
                                  )"
                                  style="margin:5px;"
                                  class="card-item w3-border w3-container">
                                  
                                  <div v-if="npz(limite_credito.limite_credito_mensal)" class="w3-col">
                                    <label>Mensal: </label>
                                    <label class="uppercase" readonly >R$ {{limite_credito.limite_credito_mensal}}</label>
                                  </div>
                                  
                                  <div v-if="npz(limite_credito.limite_credito_aprovado)" class="w3-col">
                                    <label>Aprovado: </label>
                                    <label class="uppercase" readonly>R$ {{limite_credito.limite_credito_aprovado}}</label>
                                  </div>
                                  
                                  <div v-if="npz(limite_credito.limite_credito_disponivel)" class="w3-col">
                                    <label>Disponivel: </label>
                                    
                                    <strong v-if="strPadraoToNumber(limite_credito.limite_credito_disponivel) > 0" class="uppercase w3-text-green" readonly>
                                      R$ {{limite_credito.limite_credito_disponivel}}
                                    </strong>

                                    <strong v-if="strPadraoToNumber(limite_credito.limite_credito_disponivel) < 0" class="uppercase w3-text-red" readonly >
                                      R$ {{limite_credito.limite_credito_disponivel}}
                                    </strong>
                                  </div>
                                </div>

                                <div 
                                  class="w3-animate-left w3-center"
                                  v-show="(
                                    !npz(limite_credito.limite_credito_mensal) &&
                                    !npz(limite_credito.limite_credito_aprovado) &&
                                    !npz(limite_credito.limite_credito_disponivel)  
                                  )">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>
                            </div>
                            
                            <div v-show="!processando_cadastro_principais && (contatos)" class="w3-third">
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_contato"
                                @click="mostrar_detalhes_contato = true">
                                 &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                 <label>Contatos</label>
                              </p>
                                
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_contato"
                                @click="mostrar_detalhes_contato = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Contatos</label>
                              </p>

                              <div v-if="mostrar_detalhes_contato">
                                <div
                                  style="margin:5px;"
                                  :key="index_contatos"
                                  class="card-item w3-border w3-container"
                                  v-for="(contato, index_contatos) in contatos">
                                  
                                  <div class="w3-col w3-left">
                                    <label>Nome: </label>
                                    <strong>{{ contato.nome }}</strong>
                                  </div>
                                  
                                  <div class="w3-col w3-left" v-if="contato.celular">
                                    <label>Celular: </label>
                                    <label>{{ contato.celular }}</label>
                                  </div>
                                  
                                  <div class="w3-col w3-left" v-if="contato.telefone">
                                    <label>Telefone: </label>
                                    <label>{{ contato.telefone }}</label>
                                  </div>
                                  
                                  <div class="w3-col w3-left" v-if="contato.funcao">
                                    <label>Função: </label>
                                    <label>{{ contato.funcao }}</label>
                                  </div>
                                  
                                  <div class="w3-col w3-left" v-if="contato.observacao">
                                    <label>Observação: </label>
                                    <label>{{ contato.observacao }}</label>
                                  </div>
                                  
                                  <div class="w3-col w3-left" v-if="contato.e_mail">
                                    <label>E-Mail: </label>
                                    <label>{{ contato.e_mail }}</label>
                                  </div>
                                  
                                  <div class="w3-col w3-left" v-if="contato.data_nascimento">
                                    <label>Data nascimento: </label>
                                    <label >{{ contato.data_nascimento }}</label>
                                  </div>
                                  
                                  <div class="w3-col w3-left">
                                    <label>Gênero: </label>
                                    <label>{{ contato.genero_analitico }}</label>
                                  </div>
                                </div>

                                <div class="w3-animate-left w3-center" v-show="(Object.keys(contatos).length == 0)">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Fim Principal -->
                      
                          <!-- Referências -->
                          <div id="tabCadastroReferencia" class="aba w3-animate-left cards-dados w3-container" style="display:none; font-size: 14px;">
                            <!-- mobile-->
                            <div class="w3-col s12 m12 l12 no-padding-mobile">
                              
                              <p 
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_referencia_pessoal"
                                @click="mostrar_detalhes_referencia_pessoal = true">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Referências pessoais</label>
                              </p>
                                    
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_referencia_pessoal"
                                @click="mostrar_detalhes_referencia_pessoal = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Referências pessoais</label>
                              </p>
                            
                              <div 
                                v-cloak
                                class="w3-col s12 w3-responsive"
                                v-if="mostrar_detalhes_referencia_pessoal">
                                
                                <div v-for="(pessoa, index) in referencias_pessoais" :key="index" class="card-item w3-container">
                                  <div v-if="pessoa.nome">
                                    <label>Nome: </label>
                                    <label >{{ pessoa.nome }}</label>
                                  </div>
                                  
                                  <div v-if="pessoa.telefone">
                                    <label>Telefone: </label>
                                    <label>{{ pessoa.telefone }}</label>
                                  </div>
                                  
                                  <div v-if="pessoa.grau_ligacao">
                                    <label>Grau de Ligação: </label>
                                    <label>{{ pessoa.grau_ligacao }}</label>
                                  </div>
                                  
                                  <div v-if="pessoa.observacao" >
                                    <label>Observação: </label>
                                    <label>{{ pessoa.observacao }}</label>
                                  </div>
                                </div>

                                <div class="w3-animate-left w3-center" v-show="(Object.keys(referencias_pessoais).length == 0)">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>
                            </div>
                         
                            <!--mobile-->
                            <div class="w3-col s12 m12 l12 no-padding-mobile">
                            
                              <p 
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_referencia_comercial"
                                @click="mostrar_detalhes_referencia_comercial = true">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Referências comerciais</label>
                              </p>
                                    
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_referencia_comercial"
                                @click="mostrar_detalhes_referencia_comercial = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Referências comerciais</label>
                              </p>
                              
                              <div 
                                class="w3-col s12 w3-responsive"
                                v-if="mostrar_detalhes_referencia_comercial">
                                
                                <div v-for="(comercial, index) in referencias_comerciais" :key="index" class="card-item w3-container">
                                  <div v-if="comercial.nome_empresa">
                                    <label>Empresa: </label>
                                    <label>{{ comercial.nome_empresa }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.telefone">
                                    <label>Telefone: </label>
                                    <label>{{ comercial.telefone }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.contato">
                                    <label>Contato: </label>
                                    <label>{{ comercial.contato }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.cliente_desde">
                                    <label>Cliente Desde: </label>
                                    <label>{{ comercial.cliente_desde }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.valor_maior_fatura">
                                    <label class="alinhamento-numero">Valor Maior Fatura: </label>
                                    <label class="alinhamento-numero">R$ {{ comercial.valor_maior_fatura }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.data_maior_fatura">
                                    <label>Dt. Maior Fatura: </label>
                                    <label>R$ {{ comercial.data_maior_fatura }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.valor_ultima_fatura">
                                    <label class="alinhamento-numero">Valor Últ. Fatura: </label>
                                    <label class="alinhamento-numero">R$ {{ comercial.valor_ultima_fatura }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.forma_pagamento">
                                    <label>Forma de Pagamento: </label>
                                    <label>{{ comercial.forma_pagamento }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.conceito_ref_comercial">
                                    <label>Conceito: </label>
                                    <label>{{ comercial.conceito_ref_comercial }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.valor_acumulado">
                                    <label class="alinhamento-numero">Valor Acumulado: </label>
                                    <label class="alinhamento-numero">R$ {{ comercial.valor_acumulado }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.limite_credito">
                                    <label class="alinhamento-numero">Limite Crédito: </label>
                                    <label class="alinhamento-numero">R$ {{ comercial.limite_credito }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.data_hora_ult_verificacao">
                                    <label>Data/Hora últ verificação: </label>
                                    <label>{{ comercial.data_hora_ult_verificacao }}</label>
                                  </div>
                                  
                                  <div v-if="comercial.nome_usuario_ult_verificacao">
                                    <label>Usuário últ. verificação: </label>
                                    <label>
                                      {{ comercial.nome_usuario_ult_verificacao != undefined ? 
                                      `${comercial.usuario_ult_verificacao} - ${comercial.nome_usuario_ult_verificacao}` : '' }}
                                    </label>
                                  </div>
                                </div>

                                <div class="w3-animate-left w3-center" v-show="(Object.keys(referencias_comerciais).length == 0)">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>
                            </div>
                           
                            <div class="w3-col s12 m12 l12 no-padding-mobile">
                              
                              <p 
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_referencia_bancarias"
                                @click="mostrar_detalhes_referencia_bancarias = true">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Referências bancárias</label>
                              </p>
                                    
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_referencia_bancarias"
                                @click="mostrar_detalhes_referencia_bancarias = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Referências bancárias</label>
                              </p>
                              
                              <div 
                                class="w3-col s12"
                                v-if="mostrar_detalhes_referencia_bancarias">
                                
                                <div v-for="(banco, index) in referencias_bancarias" :key="index" class="card-item w3-container">
                                  <div v-if="banco.conta_principal_analitico">
                                    <label class="alinhamento-geral">Contato principal: </label>
                                    <strong class="alinhamento-geral" :style="getStyleAzulVermelho(banco.conta_principal_analitico, false)">
                                      {{ banco.conta_principal_analitico }}
                                    </strong>
                                  </div>
                                  
                                  <div v-if="banco.nome_portador">
                                    <label>Portador: </label>
                                    <label>{{ `${banco.portador_id} - ${banco.nome_portador}` }}</label>
                                  </div>
                                  
                                  <div v-if="banco.agencia">
                                    <label>Agência: </label>
                                    <label>{{ banco.agencia }}</label>
                                  </div>
                                  
                                  <div v-if="banco.digito_verificador_conta">
                                    <label>Dígito: </label>
                                    <label>{{ banco.digito_verificador_conta }}</label>
                                  </div>
                                  
                                  <div v-if="banco.tipo_conta_analitico">
                                    <label>Tipo conta: </label>
                                    <label>
                                      {{ banco.tipo_conta_analitico }}
                                    </label>
                                  </div>
                                  
                                  <div v-if="banco.cliente_desde">
                                    <label>Cliente desde: </label>
                                    <label>{{ banco.cliente_desde }}</label>
                                  </div>
                                  
                                  <div v-if="banco.conceito">
                                    <label>Conceito: </label>
                                    <label>{{ banco.conceito }}</label>
                                  </div>
                                  
                                  <div v-if="banco.contato">
                                    <label>Contato: </label>
                                    <label>{{ banco.contato }}</label>
                                  </div>
                                  
                                  <div v-if="banco.telefone">
                                    <label>Telefone: </label>
                                    <label>{{ banco.telefone }}</label>
                                  </div>
                                  
                                  <div v-if="banco.ramal">
                                    <label>Ramal: </label>
                                    <label>{{ banco.ramal }}</label>
                                  </div>
                                  
                                  <div v-if="banco.cpf_cnpj">
                                    <label>CPF/CNPJ: </label>
                                    <label>{{ banco.cpf_cnpj }}</label>
                                  </div>
                                  
                                  <div v-if="banco.data_hora_ult_verificacao">
                                    <label>Data/Hora últ verificação: </label>
                                    <label>{{ banco.data_hora_ult_verificacao }}</label>
                                  </div>
                                  
                                  <div  v-if="banco.nome_usuario_ult_verificacao != undefined">
                                    <label>Usuário últ. verificação: </label>
                                    <label>
                                      {{ banco.nome_usuario_ult_verificacao != undefined ? 
                                      `${banco.usuario_ult_verificacao} - ${banco.nome_usuario_ult_verificacao}` : '' }}
                                    </label>
                                  </div>
                                </div>

                                <div class="w3-animate-left w3-center" v-show="(Object.keys(referencias_bancarias).length == 0)">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>
                            </div>

                          </div>
                          <!-- Fim Referências -->
                      
                          <!-- Observações -->
                          <div id="tabCadastroObservacoes" class="aba w3-animate-left w3-row-padding" style="display: none; font-size: 14px;">

                            <div class="w3-col s12 m12 l12" v-show="processando_cadastro_observacoes">
                              <div class="w3-panel w3-theme w3-card-2">
                                <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                              </div>
                            </div>
                            
                            <div v-show="!processando_cadastro_observacoes" class="w3-container cards-dados">
                              <p 
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_obs_nota_fiscal"
                                @click="mostrar_detalhes_obs_nota_fiscal = true">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Observação da nota fiscal</label>
                              </p>
                                    
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_obs_nota_fiscal"
                                @click="mostrar_detalhes_obs_nota_fiscal = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Observação da nota fiscal</label>
                              </p>

                              <div class="w3-row margin" v-show="mostrar_detalhes_obs_nota_fiscal">
                                <div 
                                  v-if="(dados_cliente) && (dados_cliente.observacao_nota_fiscal) && (autorizacoes.visualizar_observacoes_cadastro_dados_cliente == 'S')"
                                  class="w3-col s12 m12 l12 card-item w3-border">
                                  <label>{{dados_cliente.observacao_nota_fiscal}}</label>
                                </div>

                                <div class="w3-animate-left w3-center" v-if="(!dados_cliente) || (!dados_cliente.observacao_nota_fiscal) || (autorizacoes.visualizar_observacoes_cadastro_dados_cliente != 'S')">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>

                              <p 
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="!mostrar_detalhes_obs_cadastro"
                                @click="mostrar_detalhes_obs_cadastro = true">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Observação</label>
                              </p>
                                    
                              <p  
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;"
                                v-if="mostrar_detalhes_obs_cadastro"
                                @click="mostrar_detalhes_obs_cadastro = false">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Observação</label>
                              </p>
                              
                              <div class="w3-row margin" v-if="mostrar_detalhes_obs_cadastro">
                                <div 
                                  v-if="(observacoes_cadastro) && (autorizacoes.visualizar_observacoes_cadastro_dados_cliente == 'S')"
                                  class="w3-col s12 m12 l12 card-item w3-border">
                                  <label>{{observacoes_cadastro}}</label>
                                </div>

                                <div class="w3-animate-left w3-center" v-if="(!observacoes_cadastro) || (autorizacoes.visualizar_observacoes_cadastro_dados_cliente != 'S')">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Fim Observações -->
                      
                          <!-- Sócios -->
                          <div id="tabCadastroSocios" class="aba" style="display: none; font-size: 14px;">

                            <div class="w3-col s12 m12 l12" v-show="processando_cadastro_socios">
                              <div class="w3-panel w3-theme w3-card-2">
                                <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                              </div>
                            </div>
                        
                            <!--mobile-->
                            <div class="w3-col s12 w3-responsive w3-animate-left cards-dados w3-container" v-show="!processando_cadastro_socios">
                              <p 
                                v-if="!mostrar_detalhes_socios"
                                @click="mostrar_detalhes_socios = true"
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;">
                                &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                <label>Sócios</label>
                              </p>
                                    
                              <p  
                                v-if="mostrar_detalhes_socios"
                                @click="mostrar_detalhes_socios = false"
                                class="fundo-cabecalho"
                                style="margin-top: 5px; margin-bottom: 5px;">
                                &nbsp;<i class="fas fa-sort-down"></i>&nbsp;
                                <label>Sócios</label>
                              </p>

                              <div v-show="mostrar_detalhes_socios">
                              
                                <div v-show="(Object.keys(socios).length > 0)" v-for="(socio, index) in socios" :key="index" class="card-item w3-container" style="margin-bottom: 5px;">
                                  <div>
                                    <label>Nome: </label>
                                    <label>{{ socio.nome }}</label>
                                  </div>
                                  
                                  <div>
                                    <label class="alinhamento-numero">Percentual participação: </label>
                                    <strong class="alinhamento-numero" style="color: rgb(11, 202, 87); font-weight: bold">
                                      {{ socio.perc_participacao_empresa }}%
                                    </strong>
                                  </div>
                                  
                                  <div v-if="socio.cpf">
                                    <label>CPF/CNPJ: </label>
                                    <label>{{ socio.cpf }}</label>
                                  </div>
                                  
                                  <div v-if="socio.rg">
                                    <label>RG: </label>
                                    <label>{{ socio.rg }}</label>
                                  </div>
                                  
                                  <div v-if="socio.logradouro">
                                    <label>Logradouro: </label>
                                    <label>{{ socio.logradouro }}</label>
                                  </div>
                                  
                                  <div v-if="socio.complemento">
                                    <label>Complemento: </label>
                                    <label>{{ socio.complemento }}</label>
                                  </div>
                                  
                                  <div v-if="socio.nome_bairro">
                                    <label>Bairro: </label>
                                    <label>{{ socio.nome_bairro }}</label>
                                  </div>
                                  
                                  <div v-if="socio.cep">
                                    <label>Cep: </label>
                                    <label>{{ socio.cep }}</label>
                                  </div>
                                  
                                  <div v-if="socio.data_nascimento">
                                    <label>Data Nascimento: </label>
                                    <label>{{ socio.data_nascimento }}</label>
                                  </div>
                                  
                                  <div v-if="socio.telefone">
                                    <label>Telefone: </label>
                                    <label>{{ socio.telefone }}</label>
                                  </div>
                                  
                                  <div v-if="socio.e_mail">
                                    <label>E-Mail: </label>
                                    <label>{{ socio.e_mail }}</label>
                                  </div>
                                  
                                  <div v-if="socio.nome_mae">
                                    <label>Nome da Mãe: </label>
                                    <label>{{ socio.nome_mae }}</label>
                                  </div>
                                  
                                  <div v-if="socio.observacao">
                                    <label>Observação: </label>
                                    <label>{{ socio.observacao }}</label>
                                  </div>
                                </div>  

                                <div class="w3-animate-left w3-center" v-show="(Object.keys(socios).length == 0)">
                                  <label style="font-size:13px!important; font-style: italic;">
                                    Não há dados a serem exibidos.
                                  </label>
                                </div>

                                <div class="w3-row card-item w3-container" v-show="npz(dados_cliente.capital_social)">
                                  <div class="w3-col s12 m6 l3">
                                    <label>Capital social da empresa: </label>
                                    <strong>{{dados_cliente.capital_social}}</strong>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Fim Sócios -->
                      
                        <!-- SPC/SERASA -->
                        <div id="tabCadastroSpcSerasa" class="aba w3-animate-left" style="display: none; font-size: 14px;">
                          
                          <div class="w3-col s12 m12 l12" v-show="processando_cadastro_spc_serasa">
                            <div class="w3-panel w3-theme w3-card-2">
                              <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                            </div>
                          </div>

                          <div v-show="!processando_cadastro_spc_serasa" class="cards-dados w3-container">
                            <div v-if="dados_cliente.data_pesquisa_spc" >
                              <label>SPC - Data da última consulta: </label>
                              <strong>{{ dados_cliente.data_pesquisa_spc }}</strong>
                            </div>
                            
                            <div v-if="dados_cliente.restricao_spc" >
                              <label>Restrição SPC: </label>
                              <strong :style="getStyleAzulVermelho(dados_cliente.restricao_spc, true)">
                                {{ dados_cliente.restricao_spc }}
                              </strong>
                            </div>
                            
                            <div v-if="dados_cliente.data_pesquisa_serasa">
                              <label>SERASA - Data da última consulta: </label>
                              <label>{{ cliente.data_pesquisa_serasa }}</label>
                            </div>
                            
                            <div v-if="dados_cliente.restricao_serasa">
                              <label>Restrição SERASA: </label>
                              <strong :style="getStyleAzulVermelho(dados_cliente.restricao_serasa, true)">{{ dados_cliente.restricao_serasa }}</strong>
                            </div>
                          
                            <div class="w3-row">
                            
                              <!-- mobile-->
                              <div class="w3-half">
                                <p 
                                  v-if="!mostrar_detalhes_spc"
                                  @click="mostrar_detalhes_spc = true"
                                  class="fundo-cabecalho"
                                  style="margin-top: 5px; margin-bottom: 5px;">
                                  &nbsp;<i class="fas fa-caret-right"></i>&nbsp;<label>SPC</label>
                                </p>
                                      
                                <p  
                                  v-if="mostrar_detalhes_spc"
                                  @click="mostrar_detalhes_spc = false"
                                  class="fundo-cabecalho"
                                  style="margin-top: 5px; margin-bottom: 5px;">
                                  &nbsp;<i class="fas fa-sort-down"></i>&nbsp;<label>SPC</label>
                                </p>
                                
                                <div
                                  class="w3-col s12 w3-responsive" 
                                  v-if="mostrar_detalhes_spc">

                                  <div class="w3-container card-item w3-border w3-animate-left" v-for="(spc, index) in consultas_spc" :key="index">
                                    <div>
                                      <label>Restrição: </label>
                                      <strong
                                        class="w3-center" 
                                        :style="getStyleAzulVermelho(spc.restricao, true)">
                                        {{ spc.restricao_analitico }}
                                      </strong>
                                    </div>
                                    
                                    <div v-if="spc.codigo_spc_serasa">
                                      <label>Código: </label>
                                      <label>{{ spc.codigo_spc_serasa }}</label>
                                    </div>
                                    
                                    <div v-if="spc.data_pesquisa">
                                      <label>Data pesquisa: </label>
                                      <label>{{ spc.data_pesquisa }}</label>
                                    </div>
                                    
                                    <div v-if="spc.atendente">
                                      <label>Atendente: </label>
                                      <label>{{ spc.atendente }}</label>
                                    </div>
                                    
                                    <div v-if="spc.data_restricao">
                                      <label>Data restrição: </label>
                                      <label>{{ spc.data_restricao }}</label>
                                    </div>
                                    
                                    <div v-if="spc.local_restricao">
                                      <label>Local: </label>
                                      <label>{{ spc.local_restricao }}</label>
                                    </div>
                                  </div>

                                  <div class="w3-animate-left w3-center" v-show="(Object.keys(consultas_spc).length == 0)">
                                    <label style="font-size:13px!important; font-style: italic;">
                                      Não há dados a serem exibidos.
                                    </label>
                                  </div>
                                </div>
                              </div>
                            
                              <!-- mobile-->
                              <div class="w3-half">
                                <p 
                                  v-if="!mostrar_detalhes_serasa"
                                  @click="mostrar_detalhes_serasa = true"
                                  class="fundo-cabecalho"
                                  style="margin-top: 5px; margin-bottom: 5px;">
                                  &nbsp;<i class="fas fa-caret-right"></i>&nbsp;<label>SERASA</label>
                                </p>
                                      
                                <p  
                                  v-if="mostrar_detalhes_serasa"
                                  @click="mostrar_detalhes_serasa = false"
                                  class="fundo-cabecalho"
                                  style="margin-top: 5px; margin-bottom: 5px;">
                                  &nbsp;<i class="fas fa-sort-down"></i>&nbsp;<label>SERASA</label>
                                </p>
                                
                                <div 
                                  class="w3-col s12 w3-responsive"
                                  v-if="mostrar_detalhes_serasa">

                                  <div 
                                    class="w3-container card-item w3-border w3-animate-left" 
                                    v-for="(serasa, index) in consultas_serasa" :key="index">

                                    <div>
                                      <label>Restrição: </label>
                                      <strong 
                                        class="w3-center"
                                        :style="getStyleAzulVermelho(serasa.restricao, true)">
                                        {{ serasa.restricao_analitico }}
                                      </strong>
                                    </div>
                                    
                                    <div v-if="serasa.codigo_spc_serasa">
                                      <label>Código: </label>
                                      <label class="w3-center">{{ serasa.codigo_spc_serasa }}</label>
                                    </div>
                                    
                                    <div v-if="serasa.data_pesquisa">
                                      <label>Data pesquisa: </label>
                                      <label>{{ serasa.data_pesquisa }}</label>
                                    </div>
                                    
                                    <div v-if="serasa.atendente">
                                      <label>Atendente: </label>
                                      <label>{{ serasa.atendente }}</label>
                                    </div>
                                    
                                    <div v-if="serasa.data_restricao">
                                      <label>Data restrição: </label>
                                      <label>{{ serasa.data_restricao }}</label>
                                    </div>
                                    
                                    <div v-if="serasa.local_restricao">
                                      <label>Local: </label>
                                      <label>{{ serasa.local_restricao }}</label>
                                    </div>
                                  </div>

                                  <div class="w3-animate-left w3-center" v-show="(Object.keys(consultas_serasa).length == 0)">
                                    <label style="font-size:13px!important; font-style: italic;">
                                      Não há dados a serem exibidos.
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Fim SPC/SERASA -->
                      </div>
                      
                      <!--Inicio Resumo-->
                      <div v-if="item.slug === 'resumo'" style="cursor: default; border-bottom-style: none;">
                        <div id="tab_cadastro">
                        
                          <div class="w3-bar" style="margin-top: 10px;">
                            <div class="w3-col s6 m6 l6">
                              <div
                                class="tablink w3-center"
                                style="width: 98%; text-decoration: underline;"
                                enable
                                @click="setTab('tabResumoVendas')" 
                                :class="getClasseTabAtiva('tabResumoVendas')">
                                <b>Vendas</b>
                              </div>
                            </div>
                            
                            <div class="w3-col s6 m6 l6 border-accordion">
                              <div
                                class="tablink w3-center"
                                style="width: 98%; text-decoration: underline;" @click="setTab('tabResumoFinanceiro')" 
                                :class="getClasseTabAtiva('tabResumoFinanceiro')">
                                <b>Financeiro</b>
                              </div>
                            </div>
                          </div>
                      
                          <!-- Observações -->
                          <div 
                            id="tabResumoVendas"
                            class="w3-row aba w3-animate-left">

                            <div class="w3-col s12 m12 l12" v-show="processando_resumo_vendas">
                              <div class="w3-panel w3-theme w3-card-2">
                                <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                              </div>
                            </div>
                        
                            <div
                              v-show="!processando_resumo_vendas"
			                        class="cards-dados w3-border w3-container"
                              v-if="npz(resumo_vendas.quant_pedido)">

                              <div class="w3-third" v-if="npz(resumo_vendas.total_movimento_pedido)">
                                <label>Pedidos: </label>
                                <strong style="color: #175aa6;">R$ {{ resumo_vendas.total_movimento_pedido }}</strong>
                              </div>
                                
                              <div class="w3-third" v-if="npz(resumo_vendas.total_movimento_acumulativo)">
                                <label>Acumulativos: </label>
                                <strong style="color: #17a644;">R$ {{ resumo_vendas.total_movimento_acumulativo }}</strong>
                              </div>
                                
                              <div class="w3-third" v-if="npz(resumo_vendas.total_movimento_devolucao)">
                                <label>Devolução: </label>
                                <strong style="color: #b33030;"> R$ {{ resumo_vendas.total_movimento_devolucao }}</strong>
                              </div>
                                  
                              <div class="w3-third" v-if="npz(resumo_vendas.tot_ger_valor_liquido)">
                                <label>Vendas realizadas: </label>
                                <label>R$ {{ resumo_vendas.tot_ger_valor_liquido }}</label>
                              </div>
                          
                              <div class="w3-third" v-if="npz(resumo_vendas.tot_ger_valor_rentabilidade)">
                                <label>Percentual lucro presente: </label>
                                <strong class="alinhamento-numero" 
                                  :class="getLabelLucroPresente(resumo_vendas.tot_ger_valor_rentabilidade)">
                                  {{ resumo_vendas.tot_ger_valor_rentabilidade }}%
                                </strong>
                              </div>
                                
                              <div class="w3-third" v-if="npz(resumo_vendas.quant_pedido)">
                                <label>Quantidade de pedidos: </label>
                                <label> {{ resumo_vendas.quant_pedido }} </label>
                              </div>
                              
                              <div class="w3-third" v-if="npz(ticketMedio(resumo_vendas))">
                                <label>Ticket médio: </label>
                                <label>R$ {{ticketMedio(resumo_vendas)}}</label>
                              </div>
                              
                              <div class="w3-third" v-if="npz(resumo_vendas.tot_acumulativo_aberto)">
                                <label>Acumulativos em aberto: </label>
                                <label>R$ {{ resumo_vendas.tot_acumulativo_aberto }}</label>
                              </div>
                                
                              <div class="w3-third" v-if="npz(resumo_vendas.tot_valor_credito_aberto)">
                                <label>Créditos em aberto: </label>
                                <label>R$ {{ resumo_vendas.tot_valor_credito_aberto}}</label>
                              </div>
                                
                              <div class="w3-third" v-if="npz(resumo_vendas.tot_valor_cheque_devolvido)">
                                <label>Cheques devolvido: </label>
                                <label>R$ {{ resumo_vendas.tot_valor_cheque_devolvido }}</label>
                              </div>
                                
                              <div 
                                class="w3-third" 
                                v-if="npz(resumo_vendas.tot_qtd_cheque_devolvido)">
                                <label>Quantidade de cheques devolvidos: </label>
                                <label>R$ {{ resumo_vendas.tot_qtd_cheque_devolvido }}</label>
                              </div>
                              
                              <div class="w3-row">
                                <div 
                                  class="w3-col s12 m6 l3"
                                  v-if="(
                                    npz(resumo_vendas.tot_emp_valor_dinheiro) || 
                                    npz(resumo_vendas.tot_emp_valor_cheque_vista) ||
                                    npz(resumo_vendas.tot_emp_valor_cheque_prazo) ||
                                    npz(resumo_vendas.tot_emp_valor_cartao_cr)  || 
                                    npz(resumo_vendas.tot_emp_valor_cartao_db) ||
                                    npz(resumo_vendas.tot_emp_valor_duplicata) ||
                                    npz(resumo_vendas.tot_emp_valor_boleta) ||
                                    npz(resumo_vendas.tot_valor_financeira) ||
                                    npz(resumo_vendas.tot_valor_credito_utilizado)
                                  )">

                                  <div  
                                    class="fundo-cabecalho"
                                    v-if="!mostrar_detalhes_formaspgto"
                                    @click="mostrar_detalhes_formaspgto = true"
                                    style="margin-bottom: 5px;">
                                    &nbsp;<i class="fas fa-caret-right"></i>
                                    &nbsp;<label>Formas de pagamento</label>
                                  </div>
                                  
                                  <div  
                                    class="fundo-cabecalho"
                                    v-if="mostrar_detalhes_formaspgto"
                                    @click="mostrar_detalhes_formaspgto = false"
                                    style="margin-bottom: 5px;">
                                    &nbsp;<i class="fas fa-sort-down"></i>
                                    &nbsp;<label>Formas de pagamento</label>
                                  </div>
                                    
                                  <div v-if="mostrar_detalhes_formaspgto" class="card-item">
                                    
                                    <div>
                                      <div v-if="npz(resumo_vendas.tot_emp_valor_dinheiro)">
                                        <span>Dinheiro: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_dinheiro }}</label>
                                      </div>

                                      <div v-if="npz(resumo_vendas.tot_emp_valor_pix)">
                                        <span>Pix: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_pix }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_emp_valor_cheque_vista)">
                                        <span>Cheque à vista: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_cheque_vista }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_emp_valor_cheque_prazo)">
                                        <span>Cheque a prazo: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_cheque_prazo }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_emp_valor_cartao_cr)">
                                        <span>Cartão de crédito: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_cartao_cr }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_emp_valor_cartao_db)">
                                        <span>Cartão de débito: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_cartao_db }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_emp_valor_duplicata)">
                                        <span>Duplicata: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_duplicata }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_emp_valor_boleta)">
                                        <span>Boleto: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_emp_valor_boleta }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_valor_financeira)">
                                        <span>Financeira: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_valor_financeira }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_valor_credito_utilizado)">
                                        <span>Crédito utilizado: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_valor_credito_utilizado }}</label>
                                      </div>
                                      
                                    </div>
                                  </div>
                                </div>
                                <!-- Fim Formas de pagamento -->
                        
                                <!-- Últimos 90 dias -->
                                <div 
                                  class="w3-col s12 m6 l3"
                                  v-if="npz(resumo_vendas.tot_pedido_03meses)">
                                  
                                  <div  
                                    class="fundo-cabecalho"
                                    style="margin-bottom: 5px;"
                                    v-if="!mostrar_detalhes_ultimos90"
                                    @click="mostrar_detalhes_ultimos90 = true">
                                    &nbsp;<i class="fas fa-caret-right"></i>
                                    &nbsp;<label>Últimos 90 dias</label>
                                  </div>
                                  
                                  <div  
                                    class="fundo-cabecalho"
                                    style="margin-bottom: 5px;"
                                    v-if="mostrar_detalhes_ultimos90"
                                    @click="mostrar_detalhes_ultimos90 = false">
                                    &nbsp;<i class="fas fa-sort-down"></i>
                                    &nbsp;<label>Últimos 90 dias</label>
                                  </div>
                                
                                  <div v-if="mostrar_detalhes_ultimos90" class="card-item">
                                  
                                    <div>
                                      <div v-if="npz(resumo_vendas.tot_pedido_03meses) ">
                                        <span>Vendas: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_pedido_03meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_dev_pedido_03meses)">
                                        <span>Devoluções: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_dev_pedido_03meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.valor_liquido_ultimos_03meses)">
                                        <span>Valor líquido: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.valor_liquido_ultimos_03meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.quant_pedido_03meses)">
                                        <span>Qtd. de pedidos: </span>
                                        <label class="alinhamento-numero">
                                          {{ resumo_vendas.quant_pedido_03meses }}
                                        </label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.ticket_medio_ultimos_03meses)">
                                        <span>Ticket médio: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.ticket_medio_ultimos_03meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.rentabilidade_ultimos_03meses)">
                                        <span>Lucro presente: </span>
                                        <strong class="alinhamento-numero" 
                                          :class="getLabelLucroPresente(resumo_vendas.rentabilidade_ultimos_03meses)">
                                          {{ resumo_vendas.rentabilidade_ultimos_03meses }}%
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Fim Últimos 90 dias -->
                        
                                <!-- Últimos 180 dias -->
                                <div 
                                  class="w3-col s12 m6 l3"
                                  v-if="npz(resumo_vendas.tot_pedido_06meses)">

                                  <div  
                                    class="fundo-cabecalho"
                                    style="margin-bottom: 5px;"
                                    v-if="!mostrar_detalhes_ultimos180"
                                    @click="mostrar_detalhes_ultimos180 = true">
                                    &nbsp;<i class="fas fa-caret-right"></i>
                                    &nbsp;<label>Últimos 180 dias</label>
                                  </div>
                                    
                                  <div  
                                    class="fundo-cabecalho"
                                    style="margin-bottom: 5px;"
                                    v-if="mostrar_detalhes_ultimos180"
                                    @click="mostrar_detalhes_ultimos180 = false">
                                    &nbsp;<i class="fas fa-sort-down"></i>
                                    &nbsp;<label>Últimos 180 dias</label>
                                  </div>
                                  
                                  <div v-if="mostrar_detalhes_ultimos180" class="card-item">
                                    <div>
                                      <div v-if="npz(resumo_vendas.tot_pedido_06meses) ">
                                        <span>Vendas: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_pedido_06meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_dev_pedido_06meses)">
                                        <span>Devoluções: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_dev_pedido_06meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.valor_liquido_ultimos_06meses) ">
                                        <span>Valor líquido: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.valor_liquido_ultimos_06meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.quant_pedido_06meses)">
                                        <span>Qtd. de pedidos: </span>
                                        <label class="alinhamento-numero">
                                          {{ resumo_vendas.quant_pedido_06meses }}
                                        </label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.ticket_medio_ultimos_06meses)">
                                        <span>Ticket médio: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.ticket_medio_ultimos_06meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.rentabilidade_ultimos_06meses)">
                                        <span>Lucro presente: </span>
                                        <strong 
                                          class="alinhamento-numero" 
                                          :class="getLabelLucroPresente(resumo_vendas.rentabilidade_ultimos_06meses)">
                                          {{ resumo_vendas.rentabilidade_ultimos_06meses }}%
                                        </strong>
                                      </div>
                                      
                                    </div>
                                  </div>
                                </div>
                                <!-- Últimos 180 dias -->
                        
                                <!-- Últimos 365 dias -->
                                <div 
                                  class="w3-col s12 m6 l3"
                                  v-if="npz(resumo_vendas.tot_pedido_12meses)">

                                  <div 
                                    class="fundo-cabecalho"
                                    style="margin-bottom: 5px;"
                                    v-if="!mostrar_detalhes_ultimos365"
                                    @click="mostrar_detalhes_ultimos365 = true">
                                    &nbsp;<i class="fas fa-caret-right"></i>
                                    &nbsp;<label>Últimos 365 dias</label>
                                  </div>
                                  
                                  <div  
                                    class="fundo-cabecalho"
                                    style="margin-bottom: 5px;"
                                    v-if="mostrar_detalhes_ultimos365"
                                    @click="mostrar_detalhes_ultimos365 = false">
                                    &nbsp;<i class="fas fa-sort-down"></i>
                                    &nbsp;<label>Últimos 365 dias</label>
                                  </div>
                                  
                                  <div v-if="mostrar_detalhes_ultimos365" class="card-item">
                                  
                                    <div>
                                      <div v-if="npz(resumo_vendas.tot_pedido_12meses) ">
                                        <span>Vendas: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_pedido_12meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.tot_dev_pedido_12meses)">
                                        <span>Devoluções: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_dev_pedido_12meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.valor_liquido_ultimos_12meses) ">
                                        <span>Valor líquido: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.valor_liquido_ultimos_12meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.quant_pedido_12meses)">
                                        <span>Qtd. de pedidos: </span>
                                        <label class="alinhamento-numero"> {{ resumo_vendas.quant_pedido_12meses }} </label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.ticket_medio_ultimos_12meses)">
                                        <span>Ticket médio: </span>
                                        <label class="alinhamento-numero">R$ {{ resumo_vendas.ticket_medio_ultimos_12meses }}</label>
                                      </div>
                                      
                                      <div v-if="npz(resumo_vendas.rentabilidade_ultimos_12meses)">
                                        <span>Lucro presente: </span>
                                        <strong 
                                          class="alinhamento-numero" 
                                          :class="getLabelLucroPresente(resumo_vendas.rentabilidade_ultimos_12meses)">
                                          {{ resumo_vendas.rentabilidade_ultimos_12meses }}%
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Fim Últimos 365 dias -->
                                
                                <div class="w3-row">
                                  <!-- Atrasos financeiros -->
                                  <div 
                                    class="w3-col s12 m6 l3"
                                    v-if="npz(parseFloat(resumo_vendas.tot_atrasos_pag_financeiro))">

                                    <div 
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="!mostrar_detalhes_atrazos_financeiros"
                                      @click="mostrar_detalhes_atrazos_financeiros = true">
                                      &nbsp;<i class="fas fa-caret-right"></i>
                                      &nbsp;<label>Atrasos financeiros</label>
                                    </div>
                                      
                                    <div  
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="mostrar_detalhes_atrazos_financeiros"
                                      @click="mostrar_detalhes_atrazos_financeiros = false">
                                      &nbsp;<i class="fas fa-sort-down"></i>
                                      &nbsp;<label>Atrasos financeiros</label>
                                    </div>
                                    
                                    <div v-if="mostrar_detalhes_atrazos_financeiros" class="card-item">
                                  
                                      <div>
                                        <div v-if="npz(resumo_vendas.tot_atrasos_pag_financeiro)">
                                          <span>Média pagamento: </span>
                                          <label class="alinhamento-numero">{{ resumo_vendas.tot_atrasos_pag_financeiro }}</label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.data_maior_atraso_pag_financeiro)">
                                          <span>Maior atraso: </span>
                                          <label class="alinhamento-numero">{{ resumo_vendas.data_maior_atraso_pag_financeiro }}</label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.tot_titulo_maior_atraso)">
                                          <span>Título com maior atraso: </span>
                                          <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_titulo_maior_atraso }}</label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.tot_valor_maior_atraso)">
                                          <span>Valor com maior atraso: </span>
                                          <label class="alinhamento-numero">R$ {{ resumo_vendas.tot_valor_maior_atraso }}</label>
                                        </div>
                                      
                                      </div>
                                    </div>
                                  </div>
                                
                                  <!-- Fim Atrasos financeiros -->
                          
                                  <!-- Primeira venda -->
                                  <div 
                                    class="w3-col s12 m6 l3"
                                    v-if="npz(resumo_vendas.valor_primeira_venda)">

                                    <div  
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="!mostrar_detalhes_primeira_venda"
                                      @click="mostrar_detalhes_primeira_venda = true">
                                      &nbsp;<i class="fas fa-caret-right"></i>
                                      &nbsp;<label>Primeira venda</label>
                                    </div>
                                      
                                    <div  
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="mostrar_detalhes_primeira_venda"
                                      @click="mostrar_detalhes_primeira_venda = false">
                                      &nbsp;<i class="fas fa-sort-down"></i>
                                      &nbsp;<label>Primeira venda</label>
                                    </div>
                                    
                                    <div v-if="mostrar_detalhes_primeira_venda" class="card-item">
                                    
                                      <div>
                                        <div v-if="npz(resumo_vendas.data_primeira_venda)">
                                          <span>Data: </span>
                                          <label class="alinhamento-numero">
                                            {{resumo_vendas.data_primeira_venda}}
                                          </label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.valor_primeira_venda) ">
                                          <span>Valor: </span>
                                          <label class="alinhamento-numero">
                                            R$ {{resumo_vendas.valor_primeira_venda}}
                                          </label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.pedido_primeira_venda)">
                                          <span>Nr. do pedido: </span>
                                          <label class="alinhamento-numero"> 
                                            {{ resumo_vendas.pedido_primeira_venda }}
                                          </label>
                                        </div>
                                       
                                      </div>
                                    </div>
                                  </div>
                                
                                  <!-- Fim Primeira venda -->
                          
                                  <!-- Maior venda -->
                                  <div 
                                    class="w3-col s12 m6 l3"
                                    v-if="npz(resumo_vendas.valor_maior_venda)">

                                    <div  
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="!mostrar_detalhes_maior_venda"
                                      @click="mostrar_detalhes_maior_venda = true">
                                      &nbsp;<i class="fas fa-caret-right"></i>
                                      &nbsp;<label>Maior venda</label>
                                    </div>
                                      
                                    <div  
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="mostrar_detalhes_maior_venda"
                                      @click="mostrar_detalhes_maior_venda = false">
                                      &nbsp;<i class="fas fa-sort-down"></i>
                                      &nbsp;<label>Maior venda</label>
                                    </div>
                                    
                                    <div v-if="mostrar_detalhes_maior_venda" class="card-item">
                                    
                                      <div>
                                        <div v-if="npz(resumo_vendas.data_maior_venda)">
                                          <span>Data: </span>
                                          <label class="alinhamento-numero">{{resumo_vendas.data_maior_venda}}</label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.valor_maior_venda)">
                                          <span>Valor: </span>
                                          <label class="alinhamento-numero">R$ {{ resumo_vendas.valor_maior_venda }}</label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.pedido_maior_venda)">
                                          <span>Nr. do pedido: </span>
                                          <label class="alinhamento-numero"> {{ resumo_vendas.pedido_maior_venda }}</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                
                                  <!-- Fim Maior venda -->
                          
                                  <!-- Última venda -->
                                  <div 
                                    class="w3-col s12 m6 l3"
                                    v-if="npz(resumo_vendas.valor_ultima_venda)">

                                    <div  
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="!mostrar_detalhes_ultima_venda"
                                      @click="mostrar_detalhes_ultima_venda = true">
                                      &nbsp;<i class="fas fa-caret-right"></i>
                                      &nbsp;<label>Última venda</label>
                                    </div>
                                      
                                    <div  
                                      class="fundo-cabecalho"
                                      style="margin-bottom: 5px;"
                                      v-if="mostrar_detalhes_ultima_venda"
                                      @click="mostrar_detalhes_ultima_venda = false">
                                      &nbsp;<i class="fas fa-sort-down"></i>
                                      &nbsp;<label>Última venda</label>
                                    </div>
                                    
                                    <div v-if="mostrar_detalhes_ultima_venda" class="card-item">
                                    
                                      <div>
                                        <div v-if="npz(resumo_vendas.data_ultima_venda)">
                                          <span>Data: </span>
                                          <label class="alinhamento-numero">{{ resumo_vendas.data_ultima_venda }}</label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.valor_ultima_venda)">
                                          <span>Valor: </span>
                                          <label class="alinhamento-numero">R$ {{ resumo_vendas.valor_ultima_venda }}</label>
                                        </div>
                                          
                                        <div v-if="npz(resumo_vendas.pedido_ultima_venda)">
                                          <span>Nr. do pedido: </span>
                                          <label class="alinhamento-numero"> {{ resumo_vendas.pedido_ultima_venda }}</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="w3-animate-left w3-center" v-show="!npz(resumo_vendas.quant_pedido) && !processando_resumo_vendas">
                              <label style="font-size:13px!important; font-style: italic;">
                                Não há dados a serem exibidos.
                              </label>
                            </div>

                          </div>
                        </div>
                        <!-- Fim Observações -->
                      
                        <!-- Financeiro -->
                        <div 
                          id="tabResumoFinanceiro"
			                    class="aba w3-animate-left"
                          style="display: none; margin-top: 5px; font-size: 14px;">

                          <div class="w3-col s12 m12 l12" v-show="processando_resumo_financeiro">
                            <div class="w3-panel w3-theme w3-card-2">
                              <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                            </div>
                          </div>

                          <!--mobile-->
                          <div
                            v-show="(
                              !processando_resumo_financeiro &&
                              (
                                npz(resumo_financeiros.grid_liq_qtd_total) ||
                                npz(resumo_financeiros.grid_qtd_venc_total_vencido) ||
                                npz(resumo_financeiros.grid_val_venc_total_vencido)
                              )
                            )"> 
                            
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_duplicata_a_vencer) ||
                                npz(resumo_financeiros.grid_qtd_duplicata_a_vencer) || 
                                npz(resumo_financeiros.grid_val_venc_duplicata_vencido) ||
                                npz(resumo_financeiros.grid_med_venc_duplicata_vencido) ||
                                npz(resumo_financeiros.grid_mai_val_dia_venc_duplicata_vencido) ||
                                npz(resumo_financeiros.grid_mai_qtd_venc_duplicata_vencido) ||
                                npz(resumo_financeiros.grid_liq_total_duplicata) ||
                                npz(resumo_financeiros.grid_liq_qtd_duplicata)
                              )">

                              <div 
                                class="fundo-cabecalho"
                                v-if="!mostrar_detalhes_duplicata"
                                @click="mostrar_detalhes_duplicata = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Duplicata</label>
                              </div>
                                  
                              <div 
                                class="fundo-cabecalho"
                                v-if="mostrar_detalhes_duplicata"
                                @click="mostrar_detalhes_duplicata = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Duplicata</label>
                              </div>
                              
                              <div v-if="mostrar_detalhes_duplicata" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_duplicata_a_vencer)">

                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_duplicata_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_duplicata_a_vencer }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_qtd_duplicata_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">  {{ resumo_financeiros.grid_qtd_duplicata_a_vencer }}</label>
                                  </div>
                                </div>
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_duplicata_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_duplicata_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_duplicata_vencido}}</label>
                                  </div>
                                
                                  <div v-if="npz(resumo_financeiros.grid_qtd_venc_duplicata_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_duplicata_vencido }}
                                    </label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_duplicata_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_duplicata_vencido}}
                                    </label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_duplicata_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_duplicata_vencido}}
                                    </label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_venc_duplicata_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_venc_duplicata_vencido}}
                                    </label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_duplicata)">
                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_duplicata)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ npz(resumo_financeiros.grid_liq_total_duplicata) }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_duplicata)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">{{ resumo_financeiros.grid_liq_qtd_duplicata}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <!-- boleto-->
                          
                            <div
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_boleta_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_boleta_vencido) ||
                                npz(resumo_financeiros.grid_liq_total_boleta)
                              )"> 

                              <div
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_boleto"
                                @click="mostrar_detalhes_boleto = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Boleto</label>
                              </div>
                                    
                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_boleto"
                                @click="mostrar_detalhes_boleto = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Boleto</label>
                              </div>

                              <div v-if="mostrar_detalhes_boleto" class="card-item w3-container" style="margin:0px !important;">

                                <div v-if="npz(resumo_financeiros.grid_val_venc_boleta_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_boleta_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_boleta_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_boleta_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_val_venc_boleta_vencido}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_boleta_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_boleta_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_boleta_vencido}}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_qtd_venc_boleta_vencido)">

                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_boleta_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_boleta_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_boleta_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_boleta_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_boleta_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_venc_boleta_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_venc_boleta_vencido}}
                                    </label>
                                  </div>
                                </div>
                                
                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_boleta)">
                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_boleta)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_boleta }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_boleta)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{resumo_financeiros.grid_liq_qtd_boleta}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <!--Ch. a Vista-->
                          
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_qtd_venc_cheque_vista_vencido) ||
                                npz(resumo_financeiros.grid_val_venc_cheque_vista_vencido) ||
                                npz(resumo_financeiros.grid_liq_qtd_cheque_vista)
                              )"> 

                              <div
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_cheque_vista"
                                @click="mostrar_detalhes_cheque_vista = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Cheque a Vista</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_cheque_vista"
                                @click="mostrar_detalhes_cheque_vista = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Cheque a Vista</label>
                              </div>

                              <div v-if="mostrar_detalhes_cheque_vista" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_vista_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_cheque_vista_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_cheque_vista_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_cheque_vista_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">  {{ resumo_financeiros.grid_qtd_cheque_vista_a_vencer}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_val_venc_cheque_vista_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="resumo_financeiros.grid_val_venc_cheque_vista_vencido">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_cheque_vista_vencido}}</label>
                                  </div>
                                  
                                  <div 
                                    v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_vista_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_cheque_vista_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_cheque_vista_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_cheque_vista_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_cheque_vista_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_cheque_vista_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_dia_venc_cheque_vista_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_dia_venc_cheque_vista_vencido}}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_vista)">
                                  <strong class="w3-text-theme">Total Liquidado</strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_cheque_vista)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_cheque_vista }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_vista)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">{{ resumo_financeiros.grid_liq_qtd_cheque_vista}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <!--Ch. a Prazo-->
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_cheque_prazo_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_cheque_prazo_vencido)
                              )"> 

                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_cheque_prazo"
                                @click="mostrar_detalhes_cheque_prazo = true">
                                &nbsp;<i class="fas fa-caret-right">
                                </i>&nbsp;<label>Cheque a Prazo</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_cheque_prazo"
                                @click="mostrar_detalhes_cheque_prazo = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Cheque a Prazo</label>
                              </div>

                              <div v-if="mostrar_detalhes_cheque_prazo" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_cheque_prazo_a_vencer)">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="resumo_financeiros.grid_val_total_cheque_prazo_a_vencer">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_cheque_prazo_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_cheque_prazo_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_qtd_cheque_prazo_a_vencer}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_prazo_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="resumo_financeiros.grid_val_venc_cheque_prazo_vencido">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_cheque_prazo_vencido }}</label>
                                  </div>
                                  
                                  <div 
                                    v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_prazo_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_qtd_venc_cheque_prazo_vencido}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_cheque_prazo_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_cheque_prazo_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_cheque_prazo_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_cheque_prazo_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_dia_venc_cheque_prazo_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_dia_venc_cheque_prazo_vencido }}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_prazo)">
                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_cheque_prazo)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_cheque_prazo }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_prazo)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">{{ resumo_financeiros.grid_liq_qtd_cheque_prazo}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <!--Ch. Devolvido-->
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_cheque_devolvido_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_cheque_devolvido_vencido)
                              )">

                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_cheque_devolvido"
                                @click="mostrar_detalhes_cheque_devolvido = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Cheque Devolvido</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_cheque_devolvido"
                                @click="mostrar_detalhes_cheque_devolvido = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Cheque Devolvido</label>
                              </div>

                              <div v-if="mostrar_detalhes_cheque_devolvido" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_cheque_devolvido_a_vencer)">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="resumo_financeiros.grid_val_total_cheque_devolvido_a_vencer">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_cheque_devolvido_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_cheque_devolvido_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_qtd_cheque_devolvido_a_vencer}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_devolvido_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_cheque_devolvido_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_cheque_devolvido_vencido}}</label>
                                  </div>
                                  
                                  <div 
                                    v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_devolvido_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_cheque_devolvido_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_cheque_devolvido_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_cheque_devolvido_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_cheque_devolvido_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_cheque_devolvido_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_cheque_devolvido)">
                                    <span>Maior  qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_liq_total_cheque_devolvido }}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_devolvido)">
                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_cheque_devolvido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_cheque_devolvido }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_devolvido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_liq_qtd_cheque_devolvido}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>  
                            <!--Ch. Dev(2º Vez)-->
                          
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_cheque_reapresentado_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_cheque_reapresentado_vencido)
                              )">
                              
                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_cheque_devolvido2"
                                @click="mostrar_detalhes_cheque_devolvido2 = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Cheque Dev(2º Vez)</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_cheque_devolvido2"
                                @click="mostrar_detalhes_cheque_devolvido2 = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Cheque Dev(2º Vez)</label>
                              </div>

                              <div v-if="mostrar_detalhes_cheque_devolvido2" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_cheque_reapresentado_a_vencer)">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_cheque_reapresentado_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_cheque_reapresentado_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_cheque_reapresentado_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_qtd_cheque_reapresentado_a_vencer}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_reapresentado_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_cheque_reapresentado_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_cheque_reapresentado_vencido}}</label>
                                  </div>
                                  
                                  <div 
                                    v-if="npz(resumo_financeiros.grid_qtd_venc_cheque_reapresentado_vencido)">

                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_cheque_reapresentado_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_cheque_reapresentado_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_cheque_reapresentado_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_cheque_reapresentado_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_cheque_reapresentado_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_dia_venc_cheque_reapresentado_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_dia_venc_cheque_reapresentado_vencido}}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_reapresentado)">

                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_cheque_reapresentado)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_cheque_reapresentado }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_cheque_reapresentado)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">  {{ resumo_financeiros.grid_liq_qtd_cheque_reapresentado}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <!--Cartão-->
                          
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_cartao_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_cartao_vencido)
                              )">

                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_cartao"
                                @click="mostrar_detalhes_cartao = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Cartão</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_cartao"
                                @click="mostrar_detalhes_cartao = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Cartão</label>
                              </div>

                              <div v-if="mostrar_detalhes_cartao" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="resumo_financeiros.grid_qtd_cartao_a_vencer">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_cartao_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_cartao_a_vencer }}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_cartao_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_qtd_cartao_a_vencer }}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_cartao_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_cartao_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_cartao_vencido }}</label>
                                  </div>
                                  
                                  <div 
                                    v-if="npz(resumo_financeiros.grid_qtd_venc_cartao_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_cartao_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_cartao_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_cartao_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_cartao_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_cartao_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_venc_cartao_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_venc_cartao_vencido }}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_cartao)">
                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_cartao)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_cartao }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_cartao)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">{{ resumo_financeiros.grid_liq_qtd_cartao }}</label>
                                  </div>
                                </div>
                              </div>
                            </div>  
                            <!--Financeiro-->
                          
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_financeiro_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_financeiro_vencido)
                              )">

                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_financeiro"
                                @click="mostrar_detalhes_financeiro = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Financeiro</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_financeiro"
                                @click="mostrar_detalhes_financeiro = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Financeiro</label>
                              </div>
                              
                              <div v-if="mostrar_detalhes_financeiro" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_financeiro_a_vencer)">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_financeiro_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_financeiro_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_financeiro_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">{{ resumo_financeiros.grid_qtd_financeiro_a_vencer}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_financeiro_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_financeiro_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_financeiro_vencido}}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_qtd_venc_financeiro_vencido)">

                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_financeiro_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_financeiro_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_financeiro_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_dia_venc_financeiro_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_qtd_dia_venc_financeiro_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_venc_financeiro_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_venc_financeiro_vencido}}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_financeiro)">

                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_financeiro) ">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_financeiro }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_financeiro)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_liq_qtd_financeiro}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>  
                            <!--Crédito-->
                          
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_credito_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_credito_vencido)
                              )">

                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_limite_credito"
                                @click="mostrar_detalhes_limite_credito = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Crédito</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_limite_credito"
                                @click="mostrar_detalhes_limite_credito = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Crédito</label>
                              </div>
                            
                              <div v-if="mostrar_detalhes_limite_credito" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_credito_a_vencer)">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_credito_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_credito_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_credito_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">{{ resumo_financeiros.grid_qtd_credito_a_vencer}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_credito_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_credito_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_credito_vencido}}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_qtd_venc_credito_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_credito_vencido }} 
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_credito_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_credito_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_credito_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_credito_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_venc_credito_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_venc_credito_vencido}}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_credito)">
                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_credito)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_credito }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_credito)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_liq_qtd_credito}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--Previsão-->
                            
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_previsao_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_previsao_vencido)
                              )">

                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_previsao"
                                @click="mostrar_detalhes_previsao = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Previsão</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_previsao"
                                @click="mostrar_detalhes_previsao = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Previsão</label>
                              </div>

                              <div v-if="mostrar_detalhes_previsao" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_qtd_previsao_a_vencer)">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_previsao_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_previsao_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_qtd_previsao_a_vencer)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero">{{ resumo_financeiros.grid_qtd_previsao_a_vencer}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_previsao_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_previsao_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_previsao_vencido}}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_qtd_venc_previsao_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_previsao_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_previsao_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_previsao_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_previsao_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_previsao_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_dia_venc_previsao_vencido)">
                                    <span>Maior  qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_dia_venc_previsao_vencido }}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_previsao)">
                                  <strong class="w3-text-theme">Total Liquidado </strong>
                                  <div v-if="npz(resumo_financeiros.grid_liq_total_previsao) ">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_liq_total_previsao }}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_liq_qtd_previsao)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_liq_qtd_previsao}}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!--totais-->
                          
                            <div 
                              class="w3-col s12 m6 l3 w3-container"
                              style="padding: 3px!important; margin:0px !important;"
                              v-if="(
                                npz(resumo_financeiros.grid_val_total_a_vencer) ||
                                npz(resumo_financeiros.grid_val_venc_total_vencido)
                              )">

                              <div 
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="!mostrar_detalhes_totais"
                                @click="mostrar_detalhes_totais = true">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Total Geral</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="margin-botton: 5px;"
                                v-if="mostrar_detalhes_totais"
                                @click="mostrar_detalhes_totais = false">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Total Geral</label>
                              </div>

                              <div v-if="mostrar_detalhes_totais" class="card-item w3-container" style="margin:0px !important;">
                                
                                <div v-if="npz(resumo_financeiros.grid_val_venc_total_vencido)">
                                  <strong class="w3-text-theme">Total em Aberto a Vencer </strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_total_a_vencer)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_total_a_vencer}}</label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_total_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> {{ resumo_financeiros.grid_val_venc_total_vencido}}</label>
                                  </div>
                                </div>
                                  
                                <div v-if="npz(resumo_financeiros.grid_qtd_venc_total_vencido)">

                                  <strong class="w3-text-theme">Total em Aberto Vencido</strong>
                                  <div v-if="npz(resumo_financeiros.grid_val_venc_total_vencido)">
                                    <span>Valor: </span>
                                    <label class="alinhamento-numero">R$ {{ resumo_financeiros.grid_val_venc_total_vencido}}</label>
                                  </div>
                                  
                                  <div v-if="npz(resumo_financeiros.grid_qtd_venc_total_vencido)">
                                    <span>Quantidade: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_qtd_venc_total_vencido }}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_med_venc_total_vencido)">
                                    <span>Média dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_med_venc_total_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_val_dia_venc_total_vencido)">
                                    <span>Maior valor: </span>
                                    <label class="alinhamento-numero"> 
                                      R$ {{ resumo_financeiros.grid_mai_val_dia_venc_total_vencido}}
                                    </label>
                                  </div>
                                    
                                  <div v-if="npz(resumo_financeiros.grid_mai_qtd_venc_total_vencido)">
                                    <span>Maior qtd. dias: </span>
                                    <label class="alinhamento-numero"> 
                                      {{ resumo_financeiros.grid_mai_qtd_venc_total_vencido}}
                                    </label>
                                  </div>
                                </div>

                                <div v-if="npz(resumo_financeiros.grid_liq_qtd_total)">
                                    <strong class="w3-text-theme">Total Liquidado </strong>
                                    <div v-if="npz(resumo_financeiros.grid_liq_total)">
                                      <span>Valor: </span>
                                      <label class="alinhamento-numero"> {{ resumo_financeiros.grid_liq_total}}</label>
                                    </div>
                                    
                                    <div v-if="npz(resumo_financeiros.grid_liq_qtd_total)">
                                      <span>Quantidade: </span>
                                      <label class="alinhamento-numero"> {{ resumo_financeiros.grid_liq_qtd_total}}</label>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>

                          <div 
                            class="w3-animate-left w3-center"
                            v-show="(
                              !processando_resumo_financeiro &&
                              !npz(resumo_financeiros.grid_liq_qtd_total) &&
                              !npz(resumo_financeiros.grid_qtd_venc_total_vencido) &&
                              !npz(resumo_financeiros.grid_val_venc_total_vencido)
                            )">
                            <label style="font-size:13px!important; font-style: italic;">
                              Não há dados a serem exibidos.
                            </label>
                          </div>
                        </div>
                        <!-- Fim Observações -->
                      </div>
                      
                      <!-- Inicio Financeiro-->
                      <div 
                        style="cursor: default;" 
                        v-if="item.slug === 'financeiro'">
                        
                        <div id="tab_cadastro">
                          
                          <div style="padding:0px">
                            <div class="w3-bar" style="margin-top: 10px;">    
                              <div class="w3-col s4 m4 l4">
                                <div
                                  class="tablink w3-center"
                                  style="width: 98%; margin-top: 5px; text-decoration: underline;"
                                  @click="setTabInterna('tabFinanceirosAberto')"   
                                  :class="getClasseTabInternaAtiva('tabFinanceirosAberto')">
                                  <b>Abertos</b>
                                </div>
                              </div>
                              
                              <div class="w3-col s4 m4 l4">
                                <div 
                                  class="tablink w3-center" 
                                  style="width: 98%; margin-top: 5px; text-decoration: underline;"
                                  @click="setTabInterna('tabFinanceirosBaixados')"   
                                  :class="getClasseTabInternaAtiva('tabFinanceirosBaixados')">
                                  <b>Baixados</b>
                                </div>
                              </div>
                              
                              <div class="w3-col s4 m4 l4">
                                <div
                                  class="tablink w3-center"
                                  style="width: 98%; margin-top: 5px; text-decoration: underline;"
                                  @click="setTabInterna('tabFinanceirosUnificados')"   
                                  :class="getClasseTabInternaAtiva('tabFinanceirosUnificados')">
                                  <b>Unificados</b>
                                </div>
                              </div>
                            </div>
                          </div>
                    
                          <!-- ABERTOS -->
                          <div class="w3-row aba w3-animate-left" v-show="tabInternaAtual == 'tabFinanceirosAberto'">
                            <div class="w3-col s12 m12 l12" v-show="processando_tot_fin_aberto">
                              <div class="w3-panel w3-theme w3-card-2">
                                <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                              </div>
                            </div>

                            <div 
                              v-cloak
                              class="w3-col s12 m12 l12 w3-row">
                              
                              <div  
                                :key="index"
                                v-show="!processando_tot_fin_aberto"
                                class="w3-row card-item w3-border w3-margin-top" 
                                v-for="(empresa, index) in total_geral_financeiros_abertos.totalizadores_empresas">

                                <div>
                                  
                                  <strong 
                                    class="titulo-vermelho w3-center">
                                    {{ empresa.empresa_id + ' - ' + empresa.nome_resumido_empresa }}
                                  </strong>
                                  
                                  <div>
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_documento)">
                                      <label>Valor: </label>
                                      <label class="" style="color: #175aa6;">
                                        R$ {{ empresa.total_empresa_valor_documento }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_juros)">
                                      <label>Juros: </label>
                                      <label style="color: #b33030;">
                                        R$ {{ empresa.total_empresa_valor_juros }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_multa)">
                                      <label>Multa: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_multa }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" >
                                      <label>Custo cartório: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_custos_cartorio }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_desconto)">
                                      <label>Desconto: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_desconto }}
                                      </label>
                                    </div>

                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_desconto)">
                                      <label>Adiantado: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_desconto }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_saldo_devedor)">
                                      <label>Saldo devedor: </label>
                                      <strong style="color: #17a644;">
                                        R$ {{ empresa.total_empresa_saldo_devedor }}
                                      </strong>
                                    </div>
                                  </div>
                                
                                  <div class="w3-center" style="font-size: 14px;">
                                    <div v-on:click="mostrarDetalhesFinanceirosAbertos(empresa.empresa_id)" class="w3-text-theme">
                                      <i v-show="empresa.visualizar" class="fas fa-angle-down w3-animate-zoom"/>
                                      <i v-show="!empresa.visualizar" class="fas fa-ellipsis-h w3-animate-zoom"/>
                                    </div>
                                  </div>
                                  
                                  <!-- mobile-->
                                  <div 
                                    class="w3-col s12 m12 l12"
                                    v-show="empresa.visualizar"
                                    style="padding: 0; font-size: 14px;">
                                    
                                    <div>
                                      <div 
                                        :key="index_financeiro"
                                        class="card-item w3-border w3-white margin-top w3-container"
                                        v-for="(financeiro, index_financeiro) in financeirosAbertosFiltrados">
                                        
                                        <div>
                                          <span>
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-pink'">
                                              <legenda>
                                                <span>Pedido vencido</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-pink"></i>
                                              </legenda>
                                            </label>
                                              
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-orange'">
                                              <legenda>
                                                <span>Pedido a vencer</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-orange"></i>
                                              </legenda>
                                            </label>
                                              
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-blue'">
                                              <legenda>
                                                <span>Pedido não baixa limite crédito</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-blue"></i>
                                              </legenda>
                                            </label>
                                            &nbsp;
                                          </span>

                                          <label style="min-width: 95px;" class="alinhamento-numero">Financeiro: </label>
                                          <strong class="alinhamento-numero">{{ financeiro.financeiro_id }}</strong>
                                        </div>
                                        
                                        <div v-if="financeiro.data_emissao">
                                          <label>Emissão: </label>
                                          <label>{{ financeiro.data_emissao }}</label>
                                        </div>
                                        
                                        <div v-if="financeiro.data_vencimento">
                                          <label>Vencimento: </label>
                                          <label>{{ financeiro.data_vencimento }}</label>
                                        </div>
                                        
                                        <div v-if="financeiro.data_vencimento_util">
                                          <label>Vencimento útil: </label>
                                          <label>{{ financeiro.data_vencimento_util }}</label>
                                        </div>

                                        <div v-if="financeiro.data_recebimento">
                                          <label>Recebimento: </label>
                                          <label>{{ financeiro.data_recebimento }}</label>
                                        </div>

                                        <div v-if="financeiro.dias_atraso > 0">
                                          <label>Dias atraso: </label>
                                          <strong class="w3-text-red">{{ financeiro.dias_atraso }}</strong>
                                        </div>
                                        
                                        <div>
                                          <label>Tipo: </label>
                                          <label :class="getClassTipoFinanceiro(financeiro.tipo)"> {{ financeiro.tipo_analitico_menor }}</label>
                                        </div>
                                        
                                        <div>
                                          <label>Documento: </label>
                                          <label>{{ financeiro.documento }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_documento)">
                                          <label>Valor: </label>
                                          <label style="color: #175aa6;">R$ {{ financeiro.valor_documento }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_juros)">
                                          <label>Juros: </label>
                                          <label style="color: #b33030;">R$ {{ financeiro.valor_juros }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_multa)">
                                          <label>Multa: </label>
                                          <label>R$ {{ financeiro.valor_multa }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_custos_cartorio)">
                                          <label>Custo cartório: </label>
                                          <label>R$ {{ financeiro.valor_custos_cartorio }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_desconto)">
                                          <label>Desconto: </label>
                                          <label>R$ {{ financeiro.valor_desconto }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_adiantado)">
                                          <label>Adiantado: </label>
                                          <label>R$ {{ financeiro.valor_adiantado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.saldo_devedor)">
                                          <label>Saldo devedor: </label>
                                          <strong style="color: #17a644;">R$ {{ financeiro.saldo_devedor }}</strong>
                                        </div>
                                        
                                        <div v-if="financeiro.teve_contato_financeiro == 'S'">
                                          <label>Teve contato: </label>
                                          <label class="titulo-vermelho">
                                            <b>{{ financeiro.teve_contato_financeiro == "S" ? "Sim" : '' }}</b>
                                          </label>
                                        </div>
                                        
                                        <div v-if="financeiro.status_prostesto_analitico">
                                          <label class="w3-center">Status protesto</label>
                                          <label :class="getClassStatusProtesto(financeiro.status_prostesto_analitico)">
                                            <b>{{ financeiro.status_prostesto_analitico }}</b>
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="w3-animate-left w3-center" v-show="(Object.keys(financeiros_abertos).length == 0)">
                                      <label style="font-size:13px!important; font-style: italic;">
                                        Não há dados a serem exibidos.
                                      </label>
                                    </div>

                                    <div
                                      style="margin-bottom: 5px;"
                                      class="w3-col l12 w3-center"
                                      v-show="empresa.mostrar_botao_ver_mais_financeiros && (paginaAtualAberto == totalDePaginasAberto - 1)">
                                      <button
                                        class="w3-button w3-theme"
                                        v-on:click="buscarFinanceirosAbertos(empresa.empresa_id, true)">
                                        <span>Ver mais..</span>
                                      </button>
                                    </div>
	
                                    <paginacao
                                      @pagina="mudarPaginaAberto"
                                      :pagina-atual="paginaAtualAberto"
                                      :itens-por-pagina="itensPorPagina"
                                      :total-resultados="totalResultadosAberto"
                                      :total-de-paginas="totalDePaginasAberto"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div
                                class="w3-row w3-margin-top card-item w3-border w3-container" 
                                v-show="(
                                  !processando_tot_fin_aberto &&
                                  (total_geral_financeiros_abertos.totalizadores_empresas) &&
                                  (total_geral_financeiros_abertos.totalizadores_empresas.length > 0)
                                )">
                                
                                <p 
                                  class="fundo-cabecalho"
                                  v-if="!mostrar_detalhes_empresa_total_geral"
                                  @click="mostrar_detalhes_empresa_total_geral = true">
                                  &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                  <label>Total Geral</label>
                                </p>
                                
                                <p  
                                  class="fundo-cabecalho"
                                  v-if="mostrar_detalhes_empresa_total_geral"
                                  @click="mostrar_detalhes_empresa_total_geral = false">
                                  &nbsp;<i class="fas fa-sort-down"/>
                                  &nbsp;<label>Total Geral</label>
                                </p>
                              
                                <div class="w3-margin-left" v-if="mostrar_detalhes_empresa_total_geral">
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_abertos.total_geral_valor_documento)">
                                    <label>Valor: </label>
                                    <label style="color: #175aa6;">
                                      R$ {{ total_geral_financeiros_abertos.total_geral_valor_documento }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_abertos.total_geral_valor_juros)">
                                    <label>Juros: </label>
                                    <label style="color: #b33030;">
                                      R$ {{ total_geral_financeiros_abertos.total_geral_valor_juros }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_abertos.total_geral_valor_multa)">
                                    <label>Multa: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_abertos.total_geral_valor_multa }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_abertos.total_geral_valor_custos_cartorio)">
                                    <label>Custo cartório: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_abertos.total_geral_valor_custos_cartorio }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_abertos.total_geral_valor_desconto)">
                                    <label>Desconto: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_abertos.total_geral_valor_desconto }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_abertos.total_geral_valor_adiantado)">
                                    <label>Adiantado: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_abertos.total_geral_valor_adiantado }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_abertos.total_geral_saldo_devedor)">
                                    <label>Saldo devedor: </label>
                                    <strong style="color: #17a644;">
                                      R$ {{ total_geral_financeiros_abertos.total_geral_saldo_devedor }}
                                    </strong>
                                  </div>
                                </div>
                              </div>

                              <div
                                class="w3-animate-left w3-center" 
                                v-show="(
                                  !processando_tot_fin_aberto &&
                                  (
                                    (!total_geral_financeiros_abertos.totalizadores_empresas) ||
                                    (total_geral_financeiros_abertos.totalizadores_empresas.length == 0)
                                  )
                                )">
                                <label style="font-size:13px!important; font-style: italic;">
                                  Não há dados a serem exibidos.
                                </label>
                              </div>
                            </div>
                            
                          </div>
                          <!-- Fim Abertos -->
                    
                          <!-- Baixados -->
                          <div class="w3-row aba w3-animate-left" v-show="tabInternaAtual == 'tabFinanceirosBaixados'" style="display: none;">

                            <div class="w3-col s12 m12 l12" v-show="processando_tot_fin_baixado">
                              <div class="w3-panel w3-theme w3-card-2">
                                <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                              </div>
                            </div>

                            <div class="w3-col s12 m12 l12 w3-row" v-show="!processando_tot_fin_baixado">
                              
                              <div  
                                :key="index"
                                class="w3-row card-item w3-border w3-margin-top" 
                                v-for="(empresa, index) in total_geral_financeiros_baixados.totalizadores_empresas">

                                <div>
                                  
                                  <strong 
                                    class="titulo-vermelho w3-center">
                                    {{ empresa.empresa_id + ' - ' + empresa.nome_resumido_empresa }}
                                  </strong>
                                  
                                  <div>
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_documento)">
                                      <label>Valor: </label>
                                      <label class="" style="color: #175aa6;">
                                        R$ {{ empresa.total_empresa_valor_documento }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_juros)">
                                      <label>Juros: </label>
                                      <label style="color: #b33030;">
                                        R$ {{ empresa.total_empresa_valor_juros }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_multa)">
                                      <label>Multa: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_multa }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_custos_cartorio)">
                                      <label>Custo cartório: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_custos_cartorio }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_desconto)">
                                      <label>Desconto: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_desconto }}
                                      </label>
                                    </div>

                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_adiantado)">
                                      <label>Adiantado: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_adiantado }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_saldo_devedor)">
                                      <label>Valor recebido: </label>
                                      <strong style="color: #17a644;">
                                        R$ {{ empresa.total_empresa_saldo_devedor }}
                                      </strong>
                                    </div>
                                  </div>
                                
                                  <div class="w3-center" style="font-size: 14px;">
                                    <div v-on:click="mostrarDetalhesFinanceirosBaixados(empresa.empresa_id)" class="w3-text-theme">
                                      <i v-show="empresa.visualizar" class="fas fa-angle-down w3-animate-zoom"/>
                                      <i v-show="!empresa.visualizar" class="fas fa-ellipsis-h w3-animate-zoom"/>
                                    </div>
                                  </div>
                                  
                                  <!-- mobile-->
                                  <div 
                                    class="w3-col s12 m12 l12"
                                    v-show="empresa.visualizar"
                                    style="padding: 0; font-size: 14px;">
                                    
                                    <div>
                                      <div 
                                        :key="index_financeiro"
                                        class="card-item w3-border w3-white margin-top w3-container"
                                        v-for="(financeiro, index_financeiro) in financeirosBaixadosFiltrados">
                                        
                                        <div>
                                          <span>
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-pink'">
                                              <legenda>
                                                <span>Pedido vencido</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-pink"></i>
                                              </legenda>
                                            </label>
                                              
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-orange'">
                                              <legenda>
                                                <span>Pedido a vencer</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-orange"></i>
                                              </legenda>
                                            </label>
                                              
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-blue'">
                                              <legenda>
                                                <span>Pedido não baixa limite crédito</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-blue"></i>
                                              </legenda>
                                            </label>
                                            &nbsp;
                                          </span>

                                          <label style="min-width: 95px;" class="alinhamento-numero">Financeiro: </label>
                                          <strong class="alinhamento-numero">{{ financeiro.financeiro_id }}</strong>
                                        </div>
                                        
                                        <div v-if="financeiro.data_emissao">
                                          <label>Emissão: </label>
                                          <label>{{ financeiro.data_emissao }}</label>
                                        </div>
                                        
                                        <div v-if="financeiro.data_vencimento">
                                          <label>Vencimento: </label>
                                          <label>{{ financeiro.data_vencimento }}</label>
                                        </div>
                                        
                                        <div v-if="financeiro.data_vencimento_util">
                                          <label>Vencimento útil: </label>
                                          <label>{{ financeiro.data_vencimento_util }}</label>
                                        </div>

                                        <div v-if="financeiro.data_recebimento">
                                          <label>Recebimento: </label>
                                          <label>{{ financeiro.data_recebimento }}</label>
                                        </div>

                                        <div v-if="financeiro.dias_atraso > 0">
                                          <label>Dias atraso: </label>
                                          <strong class="w3-text-red">{{ financeiro.dias_atraso }}</strong>
                                        </div>
                                        
                                        <div>
                                          <label>Tipo: </label>
                                          <label :class="getClassTipoFinanceiro(financeiro.tipo)"> {{ financeiro.tipo_analitico_menor }}</label>
                                        </div>
                                        
                                        <div>
                                          <label>Documento: </label>
                                          <label>{{ financeiro.documento }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_documento)">
                                          <label>Valor: </label>
                                          <label style="color: #175aa6;">R$ {{ financeiro.valor_documento }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_juros)">
                                          <label>Juros: </label>
                                          <label style="color: #b33030;">R$ {{ financeiro.valor_juros }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_multa)">
                                          <label>Multa: </label>
                                          <label>R$ {{ financeiro.valor_multa }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_custos_cartorio)">
                                          <label>Custo cartório: </label>
                                          <label>R$ {{ financeiro.valor_custos_cartorio }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_desconto)">
                                          <label>Desconto: </label>
                                          <label>R$ {{ financeiro.valor_desconto }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_adiantado)">
                                          <label>Adiantado: </label>
                                          <label>R$ {{ financeiro.valor_adiantado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.saldo_devedor)">
                                          <label>Valor recebido: </label>
                                          <strong style="color: #17a644;">R$ {{ financeiro.saldo_devedor }}</strong>
                                        </div>
                                        
                                        <div v-if="financeiro.teve_contato_financeiro == 'S'">
                                          <label>Teve contato: </label>
                                          <label class="titulo-vermelho">
                                            <b>{{ financeiro.teve_contato_financeiro == "S" ? "Sim" : '' }}</b>
                                          </label>
                                        </div>
                                        
                                        <div v-if="financeiro.status_prostesto_analitico">
                                          <label class="w3-center">Status protesto</label>
                                          <label :class="getClassStatusProtesto(financeiro.status_prostesto_analitico)">
                                            <b>{{ financeiro.status_prostesto_analitico }}</b>
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="w3-animate-left w3-center" v-show="(Object.keys(financeiros_baixados).length == 0)">
                                      <label style="font-size:13px!important; font-style: italic;">
                                        Não há dados a serem exibidos.
                                      </label>
                                    </div>
                                  
                                    <div v-show="Object.keys(financeiros_baixados).length > 0" class="atencao-clean">
                                      <p class="atencao-titulo">
                                        Atenção: Para os títulos que tiveram adiantamentos, só será incorporado ao total o valor de saldo devedor.
                                      </p>
                                    </div>

                                    <div
                                      style="margin-bottom: 5px;"
                                      class="w3-col l12 w3-center"
                                      v-show="empresa.mostrar_botao_ver_mais_financeiros && (paginaAtualBaixado == totalDePaginasBaixado - 1)">
                                      <button
                                        class="w3-button w3-theme"
                                        v-on:click="buscarFinanceirosBaixados(empresa.empresa_id, true)">
                                        <span>Ver mais..</span>
                                      </button>
                                    </div>
	
                                    <paginacao
                                      @pagina="mudarPaginaBaixado"
                                      :pagina-atual="paginaAtualBaixado"
                                      :itens-por-pagina="itensPorPagina"
                                      :total-resultados="totalResultadosBaixado"
                                      :total-de-paginas="totalDePaginasBaixado"
                                    />
                                  </div>
                                </div>
                              </div>
                              
                              <div
                                class="w3-row w3-margin-top card-item w3-border w3-container" 
                                v-show="(
                                  (total_geral_financeiros_baixados.totalizadores_empresas) &&
                                  (total_geral_financeiros_baixados.totalizadores_empresas.length > 0)
                                )">

                                <p 
                                  class="fundo-cabecalho"
                                  v-if="!mostrar_detalhes_empresa_total_geral"
                                  @click="mostrar_detalhes_empresa_total_geral = true">
                                  &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                  <label>Total Geral</label>
                                </p>
                                
                                <p  
                                  class="fundo-cabecalho"
                                  v-if="mostrar_detalhes_empresa_total_geral"
                                  @click="mostrar_detalhes_empresa_total_geral = false">
                                  &nbsp;<i class="fas fa-sort-down"/>
                                  &nbsp;<label>Total Geral</label>
                                </p>
                              
                                <div class="w3-margin-left" v-if="mostrar_detalhes_empresa_total_geral">
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_baixados.total_geral_valor_documento)">
                                    <label>Valor: </label>
                                    <label style="color: #175aa6;">
                                      R$ {{ total_geral_financeiros_baixados.total_geral_valor_documento }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_baixados.total_geral_valor_juros)">
                                    <label>Juros: </label>
                                    <label style="color: #b33030;">
                                      R$ {{ total_geral_financeiros_baixados.total_geral_valor_juros }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_baixados.total_geral_valor_multa)">
                                    <label>Multa: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_baixados.total_geral_valor_multa }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_baixados.total_geral_valor_custos_cartorio)">
                                    <label>Custo cartório: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_baixados.total_geral_valor_custos_cartorio }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_baixados.total_geral_valor_desconto)">
                                    <label>Desconto: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_baixados.total_geral_valor_desconto }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_baixados.total_geral_valor_adiantado)">
                                    <label>Adiantado: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_baixados.total_geral_valor_adiantado }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_baixados.total_geral_saldo_devedor)">
                                    <label>Saldo devedor: </label>
                                    <strong style="color: #17a644;">
                                      R$ {{ total_geral_financeiros_baixados.total_geral_saldo_devedor }}
                                    </strong>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div 
                              class="w3-animate-left w3-center" 
                              v-show="(
                                !processando_tot_fin_baixado && 
                                (
                                  (!total_geral_financeiros_baixados.totalizadores_empresas) ||
                                  (total_geral_financeiros_baixados.totalizadores_empresas.length == 0)
                                )
                              )">
                              <label style="font-size:13px!important; font-style: italic;">
                                Não há dados a serem exibidos.
                              </label>
                            </div>
                          </div>
                          <!-- Fim Baixados -->
                    
                          <!-- Unificados -->
                          <div class="w3-row aba w3-animate-left" v-show="tabInternaAtual == 'tabFinanceirosUnificados'" style="display: none">

                            <div class="w3-col s12 m12 l12" v-show="processando_tot_fin_unificado">
                              <div class="w3-panel w3-theme w3-card-2">
                                <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                              </div>
                            </div>
                            
                            <div class="w3-col s12 m12 l12 w3-row" v-show="!processando_tot_fin_unificado">
                              
                              <div  
                                :key="index"
                                class="w3-row card-item w3-border w3-margin-top" 
                                v-for="(empresa, index) in total_geral_financeiros_unificados.totalizadores_empresas">

                                <div>
                                  
                                  <strong 
                                    class="titulo-vermelho w3-center">
                                    {{ empresa.empresa_id + ' - ' + empresa.nome_resumido_empresa }}
                                  </strong>
                                  
                                  <div>
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_documento)">
                                      <label>Valor: </label>
                                      <label class="" style="color: #175aa6;">
                                        R$ {{ empresa.total_empresa_valor_documento }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_juros)">
                                      <label>Juros: </label>
                                      <label style="color: #b33030;">
                                        R$ {{ empresa.total_empresa_valor_juros }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_multa)">
                                      <label>Multa: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_multa }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_custos_cartorio)">
                                      <label>Custo cartório: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_custos_cartorio }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_desconto)">
                                      <label>Desconto: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_desconto }}
                                      </label>
                                    </div>

                                    <div class="w3-col" v-if="npz(empresa.total_empresa_valor_adiantado)">
                                      <label>Adiantado: </label>
                                      <label>
                                        R$ {{ empresa.total_empresa_valor_adiantado }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col" v-if="npz(empresa.total_empresa_saldo_devedor)">
                                      <label>Valor recebido: </label>
                                      <strong style="color: #17a644;">
                                        R$ {{ empresa.total_empresa_saldo_devedor }}
                                      </strong>
                                    </div>
                                  </div>
                                
                                  <div class="w3-center" style="font-size: 14px;">
                                    <div v-on:click="mostrarDetalhesFinanceirosUnificados(empresa.empresa_id)" class="w3-text-theme">
                                      <i v-show="empresa.visualizar" class="fas fa-angle-down w3-animate-zoom"/>
                                      <i v-show="!empresa.visualizar" class="fas fa-ellipsis-h w3-animate-zoom"/>
                                    </div>
                                  </div>
                                  
                                  <!-- mobile-->
                                  <div 
                                    class="w3-col s12 m12 l12"
                                    v-show="empresa.visualizar"
                                    style="padding: 0; font-size: 14px;">
                                    
                                    <div>
                                      <div 
                                        :key="index_financeiro"
                                        class="card-item w3-border w3-white margin-top w3-container"
                                        v-for="(financeiro, index_financeiro) in financeirosUnificadosFiltrados">
                                        
                                        <div>
                                          <span>
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-pink'">
                                              <legenda>
                                                <span>Pedido vencido</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-pink"></i>
                                              </legenda>
                                            </label>
                                              
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-orange'">
                                              <legenda>
                                                <span>Pedido a vencer</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-orange"></i>
                                              </legenda>
                                            </label>
                                              
                                            <label v-if="verificarVencimento(financeiro) == 'w3-text-blue'">
                                              <legenda>
                                                <span>Pedido não baixa limite crédito</span>
                                                <i slot="referencia" class="fa fa-circle w3-text-blue"></i>
                                              </legenda>
                                            </label>
                                            &nbsp;
                                          </span>

                                          <label style="min-width: 95px;" class="alinhamento-numero">Financeiro: </label>
                                          <strong class="alinhamento-numero">{{ financeiro.financeiro_id }}</strong>
                                        </div>
                                        
                                        <div v-if="financeiro.data_emissao">
                                          <label>Emissão: </label>
                                          <label>{{ financeiro.data_emissao }}</label>
                                        </div>
                                        
                                        <div v-if="financeiro.data_vencimento">
                                          <label>Vencimento: </label>
                                          <label>{{ financeiro.data_vencimento }}</label>
                                        </div>
                                        
                                        <div v-if="financeiro.data_vencimento_util">
                                          <label>Vencimento útil: </label>
                                          <label>{{ financeiro.data_vencimento_util }}</label>
                                        </div>

                                        <div v-if="financeiro.data_recebimento">
                                          <label>Recebimento: </label>
                                          <label>{{ financeiro.data_recebimento }}</label>
                                        </div>

                                        <div v-if="financeiro.dias_atraso > 0">
                                          <label>Dias atraso: </label>
                                          <strong class="w3-text-red">{{ financeiro.dias_atraso }}</strong>
                                        </div>
                                        
                                        <div>
                                          <label>Tipo: </label>
                                          <label :class="getClassTipoFinanceiro(financeiro.tipo)"> {{ financeiro.tipo_analitico_menor }}</label>
                                        </div>
                                        
                                        <div>
                                          <label>Documento: </label>
                                          <label>{{ financeiro.documento }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_documento)">
                                          <label>Valor: </label>
                                          <label style="color: #175aa6;">R$ {{ financeiro.valor_documento }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_juros)">
                                          <label>Juros: </label>
                                          <label style="color: #b33030;">R$ {{ financeiro.valor_juros }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_multa)">
                                          <label>Multa: </label>
                                          <label>R$ {{ financeiro.valor_multa }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_custos_cartorio)">
                                          <label>Custo cartório: </label>
                                          <label>R$ {{ financeiro.valor_custos_cartorio }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_desconto)">
                                          <label>Desconto: </label>
                                          <label>R$ {{ financeiro.valor_desconto }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.valor_adiantado)">
                                          <label>Adiantado: </label>
                                          <label>R$ {{ financeiro.valor_adiantado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(financeiro.saldo_devedor)">
                                          <label>Valor recebido: </label>
                                          <strong style="color: #17a644;">R$ {{ financeiro.saldo_devedor }}</strong>
                                        </div>
                                        
                                        <div v-if="financeiro.teve_contato_financeiro == 'S'">
                                          <label>Teve contato: </label>
                                          <label class="titulo-vermelho">
                                            <b>{{ financeiro.teve_contato_financeiro == "S" ? "Sim" : '' }}</b>
                                          </label>
                                        </div>
                                        
                                        <div v-if="financeiro.status_prostesto_analitico">
                                          <label class="w3-center">Status protesto</label>
                                          <label :class="getClassStatusProtesto(financeiro.status_prostesto_analitico)">
                                            <b>{{ financeiro.status_prostesto_analitico }}</b>
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="w3-animate-left w3-center" v-show="(Object.keys(financeiros_unificados).length == 0)">
                                      <label style="font-size:13px!important; font-style: italic;">
                                        Não há dados a serem exibidos.
                                      </label>
                                    </div>

                                    <div v-show="Object.keys(financeiros_unificados).length > 0" class="atencao-clean">
                                      <p class="atencao-titulo">
                                        Atenção: Para os títulos que tiveram adiantamentos, só será incorporado ao total o valor de saldo devedor.
                                      </p>
                                    </div>

                                    <div 
                                      style="margin-bottom: 5px;"
                                      class="w3-col l12 w3-center"
                                      v-show="empresa.mostrar_botao_ver_mais_financeiros && (paginaAtualUnificado == totalDePaginasUnificado - 1)">
                                      <button
                                        class="w3-button w3-theme"
                                        v-on:click="buscarFinanceirosUnificados(empresa.empresa_id, true)">
                                        <span>Ver mais..</span>
                                      </button>
                                    </div>
	
                                    <paginacao
                                      @pagina="mudarPaginaUnificado"
                                      :pagina-atual="paginaAtualUnificado"
                                      :itens-por-pagina="itensPorPagina"
                                      :total-resultados="totalResultadosUnificado"
                                      :total-de-paginas="totalDePaginasUnificado"
                                    />
                                  </div>
                                </div>
                              </div>
                            
                              <div
                                class="w3-row w3-margin-top card-item w3-border w3-container" 
                                v-show="(
                                  (total_geral_financeiros_unificados.totalizadores_empresas) &&
                                  (total_geral_financeiros_unificados.totalizadores_empresas.length > 0)
                                )">
                                
                                <p 
                                  class="fundo-cabecalho"
                                  v-if="!mostrar_detalhes_empresa_total_geral"
                                  @click="mostrar_detalhes_empresa_total_geral = true">
                                  &nbsp;<i class="fas fa-caret-right"></i>&nbsp;
                                  <label>Total Geral</label>
                                </p>
                                
                                <p  
                                  class="fundo-cabecalho"
                                  v-if="mostrar_detalhes_empresa_total_geral"
                                  @click="mostrar_detalhes_empresa_total_geral = false">
                                  &nbsp;<i class="fas fa-sort-down"/>
                                  &nbsp;<label>Total Geral</label>
                                </p>
                              
                                <div class="w3-margin-left" v-if="mostrar_detalhes_empresa_total_geral">
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_unificados.total_geral_valor_documento)">
                                    <label>Valor: </label>
                                    <label style="color: #175aa6;">
                                      R$ {{ total_geral_financeiros_unificados.total_geral_valor_documento }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_unificados.total_geral_valor_juros)">
                                    <label>Juros: </label>
                                    <label style="color: #b33030;">
                                      R$ {{ total_geral_financeiros_unificados.total_geral_valor_juros }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_unificados.total_geral_valor_multa)">
                                    <label>Multa: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_unificados.total_geral_valor_multa }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_unificados.total_geral_valor_custos_cartorio)">
                                    <label>Custo cartório: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_unificados.total_geral_valor_custos_cartorio }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_unificados.total_geral_valor_desconto)">
                                    <label>Desconto: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_unificados.total_geral_valor_desconto }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_unificados.total_geral_valor_adiantado)">
                                    <label>Adiantado: </label>
                                    <label>
                                      R$ {{ total_geral_financeiros_unificados.total_geral_valor_adiantado }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(total_geral_financeiros_unificados.total_geral_saldo_devedor)">
                                    <label>Saldo devedor: </label>
                                    <strong style="color: #17a644;">
                                      R$ {{ total_geral_financeiros_unificados.total_geral_saldo_devedor }}
                                    </strong>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="w3-animate-left w3-center"
                              v-show="(
                                !processando_tot_fin_unificado &&
                                (
                                  (!total_geral_financeiros_unificados.totalizadores_empresas) ||
                                  (total_geral_financeiros_unificados.totalizadores_empresas.length == 0)
                                )
                              )">
                              <label style="font-size:13px!important; font-style: italic;">
                                Não há dados a serem exibidos.
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Inicio Lista negra-->
                      <div
                        v-if="item.slug === 'listanegra'"
                        style="cursor: default; border-bottom-style: none;">

                        <div class="w3-col s12 m12 l12" v-show="processando_lista_negra">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>

                        <div class="w3-animate-left w3-center cards-dados" v-show="!processando_lista_negra && (Object.keys(lista_negra).length == 0)">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>

                        <div class="w3-row aba w3-animate-left" style="margin-top: 5px;" v-show="!processando_lista_negra && (Object.keys(lista_negra).length > 0)"> 
                          <div
                            :key="index"
                            v-for="(lista, index) in lista_negra"
                            v-show="(Object.keys(lista_negra).length > 0)"
                            class="card-item w3-container">
                            
                            <div class="w3-third">
                              <label>Data cadastro: </label>
                              <strong>{{ lista.data_cadastro }}</strong>
                            </div>
                            
                            <div class="w3-third">
                              <label>Motivo: </label>
                              <label>{{ lista.nome_motivo }}</label>
                            </div>
                            
                            <div class="w3-third">
                              <label>Impedido: </label>
                              <strong :style="getStyleAzulVermelho(lista.impedir, true)">
                                {{ lista.impedir_analitico }}
                              </strong>
                            </div>
                            
                            <div class="w3-third">
                              <label>Observações:</label>
                              <textarea 
                                rows="3" 
                                cols="33" 
                                class="w3-col s12"
                                disabled style="border-radius: 5px; background-color: #f1f1f1; resize: none; font-size: 14px!important;" 
                                v-model="lista.observacao"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Inicio Pedidos-->
                      <div 
                        v-if="item.slug === 'pedidos'"
                        style="cursor: default; border-bottom-style: none; font-size: 14px;">

                        <div class="w3-col s12 m12 l12" v-show="processando_tot_pedidos">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>
                        
                        <div v-show="!processando_tot_pedidos" class="w3-row aba w3-animate-left w3-row" v-for="(empresa, index) in total_geral_pedidos.totalizadores_empresas" :key="index" v-cloak>
                          <div class="w3-margin-bottom">
                            <div class="w3-container cards-dados" style="padding: 5px">
                            
                              <div class="w3-col s12" style="margin: 3px; font-size: 14px;">
                                <strong class="w3-text-theme label-clicavel"><strong>{{`${empresa.empresa_id} - ${empresa.nome_empresa}`}}</strong></strong>
                              </div>
                              
                              <!-- mobile-->
                              <div class="w3-col s12">
                                <div 
                                  style="color: black !important"
                                  class="card-item w3-border w3-container">
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_produtos)">
                                    <label>Valor produtos: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_produtos }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_frete)">
                                    <label>Frete: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_frete }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_outras_despesas)">
                                    <label>Outras despesas: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_outras_despesas }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_juros)">
                                    <label>Juros: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_juros }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_tac)">
                                    <label>TAC: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_tac }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_desconto) ">
                                    <label>Desconto: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_desconto }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_credito_manual)">
                                    <label>Crédito manual: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_credito_manual }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_liquido)">
                                    <label>Vlr. líquido: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_liquido }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_acumulativo)">
                                    <label>Vlr. acumulativo: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_acumulativo }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_boleta)">
                                    <label>Vlr. boleto: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_boleta }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_cartao_cr) ">
                                    <label>Vlr. cartão crédito: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_cartao_cr }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_cartao_db)">
                                    <label>Vlr. cartão débito: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_cartao_db }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_cheque_prazo)">
                                    <label>Vlr. cheque a prazo: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_cheque_prazo }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_cheque_vista)">
                                    <label>Vlr. cheque a vista: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_cheque_vista }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_credito_gerado)">
                                    <label>Vlr. crédito gerado: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_credito_gerado }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_credito_utilizado)">
                                    <label>Vlr. crédito utilizado: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_credito_utilizado }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_dinheiro)">
                                    <label>Vlr. dinheiro: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_dinheiro }}</label>
                                  </div>

                                  <div v-if="npz(empresa.total_empresa_valor_pix)">
                                    <label>Vlr. pix: </label>
                                    <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_pix }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_duplicata)">
                                    <label>Vlr. duplicata: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_duplicata }}</label>
                                  </div>
                                  
                                  <div class="w3-quarter" v-if="npz(empresa.total_empresa_valor_financeira)">
                                    <label>Vlr. financeira: </label>
                                    <label>R$ {{ empresa.total_empresa_valor_financeira }}</label>
                                  </div>
                                  
                                  <div  
                                    class="w3-col w3-text-theme" style="font-size:14px;"
                                    v-on:click="mostrarDetalhesVendasEmpresas(empresa.empresa_id)">

                                    <center 
                                      v-show="!empresa.visualizar">
                                      <i class="fas fa-ellipsis-h w3-animate-zoom"/>
                                    </center>

                                    <center 
                                      v-show="empresa.visualizar">
                                      <i class="fas fa-angle-down w3-animate-zoom"/>
                                    </center>
                                  
                                  </div>
                                </div>
                                
                                <div class="w3-col s12" v-show="empresa.visualizar">
                                  <div>
                                    <div class="w3-bar w3-white" style="margin-top: 10px;">
                                      <div class="w3-col s4 m4 l4 accordion">
                                        <div
                                          style="width: 100%; text-decoration: underline; font-size: 14px;"
                                          class="tablink w3-center"
                                          @click="setTabInterna('tabVendasPedidos')"   
                                          :class="getClasseTabInternaAtiva('tabVendasPedidos')">
                                          Pedido
                                        </div>
                                      </div>
                                    
                                      <div class="w3-col s4 m4 l4 accordion">
                                        <div
                                          style="width: 100%; text-decoration: underline; font-size: 14px;"
                                          class="tablink w3-center"
                                          @click="setTabInterna('tabVendasAcumulativos')"   
                                          :class="getClasseTabInternaAtiva('tabVendasAcumulativos')">
                                          Acumulativos
                                        </div>
                                      </div>
                                    
                                      <div class="w3-col s4 m4 l4 accordion">
                                        <div
                                          style="width: 100%; text-decoration: underline; font-size: 14px;"
                                          class="tablink w3-center" 
                                          @click="setTabInterna('tabVendasDevolucoes')"  
                                          :class="getClasseTabInternaAtiva('tabVendasDevolucoes')">
                                          Devoluções
                                        </div>
                                      </div>
                                    
                                    </div>
                                  
                                    <div 
                                      v-cloak
                                      style="display: block"
                                      v-show="tabInternaAtual == 'tabVendasPedidos'"
                                      class="w3-row aba w3-animate-left w3-margin-top">
                                      
                                      <div v-if="pedidosFiltrados">  
                                        <div 
                                          :key="index"
                                        
                                          v-for="(pedido, index) in pedidosFiltrados">
                                          
                                          <div class="w3-container card-item w3-border" style="padding:0px 5px 5px 5px">
                                            <div style="color: black !important">
                                              
                                              <div v-if="pedido.tipo" class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                                                <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                                <h6 
                                                  class="fundo-cabecalho-dados">
                                                  &nbsp;
                                                  <i class="fas fa-shopping-cart">
                                                  </i>&nbsp;
                                                  <strong> Pedido </strong> 
                                                </h6>
                                                <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.id)">
                                                <strong class="w3-text-blue">{{ npz(pedido.id) }}</strong>
                                              </div>
                                              
                                              <div class="w3-third" v-if="pedido.nome_vendedor">
                                                <label>Vendedor: </label>
                                                <label>{{ pedido.nome_vendedor }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="pedido.data_recebimento">
                                                <label>Data recebimento: </label>
                                                <label>{{ pedido.data_recebimento}}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_produtos)">
                                                <label>Valor produtos: </label>
                                                <label>R$ {{ pedido.valor_produtos }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_frete)">
                                                <label>Frete: </label>
                                                <label>R$ {{ pedido.valor_frete }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_outras_despesas)" >
                                                <label>Outras despesas: </label>
                                                <label>R$ {{ pedido.valor_outras_despesas }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_juros)">
                                                <label>Vendas Juros: </label>
                                                <label>R$ {{ pedido.valor_juros }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_tac)">
                                                <label>TAC: </label>
                                                <label>R$ {{ pedido.valor_tac }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_desconto)">
                                                <label>Desconto: </label>
                                                <label>R$ {{ pedido.valor_desconto }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_credito_manual)">
                                                <label>Crédito manual: </label>
                                                <label>R$ {{ pedido.valor_credito_manual }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_liquido)">
                                                <label>Vlr. líquido: </label>
                                                <label>R$ {{ pedido.valor_liquido }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_acumulativo)">
                                                <label>Vlr. acumulativo: </label>
                                                <label>R$ {{ pedido.valor_acumulativo }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_boleta)">
                                                <label>Vlr. boleto: </label>
                                                <label>R$ {{ pedido.valor_boleta }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_cartao_cr)">
                                                <label>Vlr. cartão crédito: </label>
                                                <label>R$ {{ pedido.valor_cartao_cr }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_cartao_db)">
                                                <label>Vlr. cartão débito: </label>
                                                <label>R$ {{ pedido.valor_cartao_db }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_cheque_prazo)">
                                                <label>Vlr. cheque a prazo: </label>
                                                <label>R$ {{ pedido.valor_cheque_prazo }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_cheque_vista)">
                                                <label>Vlr. cheque a vista: </label>
                                                <label>R$ {{ pedido.valor_cheque_vista }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_credito_gerado)">
                                                <label>Vlr. crédito gerado: </label>
                                                <label>R$ {{ pedido.valor_credito_gerado }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_credito_utilizado)">
                                                <label>Vlr. crédito utilizado: </label>
                                                <label>R$ {{ pedido.valor_credito_utilizado }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_dinheiro)">
                                                <label>Vlr. dinheiro: </label>
                                                <label>R$ {{ pedido.valor_dinheiro }}</label>
                                              </div>

                                              <div class="w3-third" v-if="npz(pedido.valor_pix)">
                                                <label>Vlr. pix: </label>
                                                <label>R$ {{ pedido.valor_pix }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_duplicata)">
                                                <label>Vlr. duplicata: </label>
                                                <label>R$ {{ pedido.valor_duplicata }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(pedido.valor_financeira) ">
                                                <label>Vlr. financeira: </label>
                                                <label>R$ {{ pedido.valor_financeira }}</label>
                                              </div>

                                              <center 
                                                style="font-size: 14px;"
                                                v-show="!pedido.mostrar_itens"
                                                v-on:click="alternarDetalhesVendas(pedido.id, pedido.tipo)">
                                                <i class="fas fa-ellipsis-h w3-text-theme"></i>
                                              </center>

                                              <center 
                                                style="font-size: 14px;"
                                                v-show="pedido.mostrar_itens"
                                                v-on:click="alternarDetalhesVendas(pedido.id, pedido.tipo)">
                                                <i class="fas fa-angle-down w3-text-theme"></i>
                                              </center>

                                              <div v-show="pedido.mostrar_itens">

                                                <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                                                  <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                                  <h6 
                                                    class="fundo-cabecalho-dados">
                                                    &nbsp;
                                                    <i class="fas fa-list-ul">
                                                    </i>&nbsp;
                                                    <strong> Itens do pedido </strong> 
                                                  </h6>
                                                  <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                                </div>

                                                <div 
                                                  v-for="(item, index) in pedido.itens_pedido" :key="index"
                                                  class="card-item w3-container" style="border: 0px!important;">
                                                  
                                                  <div class="w3-col w3-text-gray" style="font-style: italic; margin-left:90%; margin-top:0px; margin-bottom:0px;">
                                                    <label>Item </label>
                                                    <label>{{ index + 1 }}</label>
                                                  </div>

                                                  <div class="w3-col w3-text-theme">
                                                    <strong>{{ item.produto_id }} - {{ item.nome }}</strong>
                                                  </div>
                                                  
                                                  <div class="w3-third"> 
                                                    <label>Marca: </label>
                                                    <label>{{ item.marca }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third">
                                                    <label>Quantidade: </label>
                                                    <label>{{ item.quantidade }}</label>
                                                  </div>
                                                  
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Preço venda: </label>
                                                    <label>R$ {{ item.preco_venda }}</label>
                                                  </div>
                                                  
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Total item: </label>
                                                    <label>R$ {{ item.valor_total }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third" v-if="npz(item.valor_juros)">
                                                    <label class="alinhamento-numero">Juros: </label>
                                                    <label>R$ {{ item.valor_juros }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third" v-if="npz(item.total_desconto)">
                                                    <label class="alinhamento-numero">Desconto: </label>
                                                    <label>R$ {{ item.total_desconto }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Total líquido: </label>
                                                    <strong class="w3-text-green">R$ {{ item.total_liquido }}</strong>
                                                  </div>
                                                  
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Total custo: </label>
                                                    <label>{{ autorizacoes.permitir_visualizar_lucratividade_mix == 'S' ? item.valor_total_custo : 'Não autorizado' }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">% Lucro: </label>
                                                    <label>{{ autorizacoes.permitir_visualizar_lucratividade_mix == 'S' ? item.percentual_lucro : 'Não autorizado' }}</label>
                                                  </div>
                                                  
                                                  <div class="w3-third" v-if="item.usou_promocao == 'S'">
                                                    <label class="alinhamento-numero">Promoção: </label>
                                                    <strong :style="getStyleAzulVermelho(item.usou_promocao)">{{ item.usou_promocao_analitico }}</strong>
                                                  </div>

                                                  <!-- Sempre por último -->
                                                  <div style="margin-top: 3px; border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                                </div>
                                              </div>
                                              
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="w3-animate-left w3-center" v-show="(Object.keys(pedidos).length == 0)">
                                        <label style="font-size:13px!important; font-style: italic;">
                                          Não há dados a serem exibidos.
                                        </label>
                                      </div>

                                      <div
                                        style="margin-bottom: 5px;"
                                        class="w3-col l12 w3-center"
                                        v-show="empresa.mostrar_botao_ver_mais_pedidos && (paginaAtualPedidos == totalDePaginasPedidos - 1)">
                                        <button
                                          class="w3-button w3-theme"
                                          v-on:click="buscarPedidos(empresa.empresa_id, true)">
                                          <span>Ver mais..</span>
                                        </button>
                                      </div>
                                      
                                      <paginacao
                                        @pagina="mudarPaginaPedidos" 
                                        :pagina-atual="paginaAtualPedidos"
                                        :itens-por-pagina="itensPorPagina"
                                        :total-resultados="totalResultadosPedidos"
                                        :total-de-paginas="totalDePaginasPedidos"
                                      />
                                    </div>
                      
                                    <div 
                                      v-cloak
                                      style="display: none"
                                      v-show="tabInternaAtual == 'tabVendasAcumulativos'"
                                      class="w3-row aba w3-animate-left w3-margin-top">
                                      
                                      <div v-if="pedidosAcumuladosFiltrados">
                                        <div
                                        
                                          :key="index + 'acumulativo'"
                                          v-for="(acumulativo, index) in pedidosAcumuladosFiltrados">
                                        
                                          <div class="w3-container card-item w3-border" style="padding:0px 5px 5px 5px">
                                            <div style="color: black !important">

                                              <div v-if="acumulativo.tipo" class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                                                <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                                <h6 
                                                  class="fundo-cabecalho-dados">
                                                  &nbsp;
                                                  <i class="fas fa-shopping-cart">
                                                  </i>&nbsp;
                                                  <strong> Acumulativo </strong> 
                                                </h6>
                                                <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                              </div>
                                             
                                              <div class="w3-third" v-if="npz(acumulativo.id)">
                                                <strong class="w3-text-green">{{ npz(acumulativo.id) }}</strong>
                                              </div>
                                              
                                              <div class="w3-third" v-if="acumulativo.nome_vendedor">
                                                <label>Vendedor: </label>
                                                <label>{{ acumulativo.nome_vendedor }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="acumulativo.data_recebimento">
                                                <label>Data recebimento: </label>
                                                <label>{{ acumulativo.data_recebimento }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_produtos)">
                                                <label>Valor produtos: </label>
                                                <label>R$ {{ acumulativo.valor_produtos }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_frete)">
                                                <label>Frete: </label>
                                                <label>R$ {{ acumulativo.valor_frete }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_outras_despesas)">
                                                <label>Outras despesas: </label>
                                                <label>R$ {{ acumulativo.valor_outras_despesas }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_juros)">
                                                <label>Vendas Juros: </label>
                                                <label>R$ {{ acumulativo.valor_juros }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_tac)">
                                                <label>TAC: </label>
                                                <label>R$ {{ acumulativo.valor_tac }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_desconto ) ">
                                                <label>Desconto: </label>
                                                <label>R$ {{ acumulativo.valor_desconto  }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if=" npz(acumulativo.valor_credito_manual)">
                                                <label>Crédito manual: </label>
                                                <label>R$ {{ acumulativo.valor_credito_manual }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_liquido)">
                                                <label>Vlr. líquido: </label>
                                                <label>R$ {{ acumulativo.valor_liquido }}</label>
                                              </div>
                                              
                                              <div class="w3-third"  v-if="npz(acumulativo.valor_acumulativo)">
                                                <label>Vlr. acumulativo: </label>
                                                <label>R$ {{ acumulativo.valor_acumulativo }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_boleta)">
                                                <label>Vlr. boleto: </label>
                                                <label>R$ {{ acumulativo.valor_boleta }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_cartao_cr)">
                                                <label>Vlr. cartão crédito: </label>
                                                <label>R$ {{ acumulativo.valor_cartao_cr }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_cartao_db)">
                                                <label>Vlr. cartão débito: </label>
                                                <label>R$ {{ acumulativo.valor_cartao_db }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_cheque_prazo)">
                                                <label>Vlr. cheque a prazo: </label>
                                                <label>R$ {{ acumulativo.valor_cheque_prazo }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_cheque_vista)">
                                                <label>Vlr. cheque a vista: </label>
                                                <label>R$ {{ acumulativo.valor_cheque_vista }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_credito_gerado)">
                                                <labe>Vlr. crédito gerado: </labe>
                                                <label>R$ {{ acumulativo.valor_credito_gerado }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_credito_utilizado)">
                                                <label>Vlr. crédito utilizado> </label>
                                                <label>R$ {{ acumulativo.valor_credito_utilizado }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_dinheiro)">
                                                <label>Vlr. dinheiro: </label>
                                                <label>R$ {{ acumulativo.valor_dinheiro }}</label>
                                              </div>

                                              <div class="w3-third" v-if="npz(acumulativo.valor_pix)">
                                                <label>Vlr. pix: </label>
                                                <label>R$ {{ acumulativo.valor_pix }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(acumulativo.valor_duplicata)">
                                                <label>Vlr. duplicata: </label>
                                                <label>R$ {{ acumulativo.valor_duplicata }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if=" npz(acumulativo.valor_financeira)">
                                                <label>Vlr. financeira: </label>
                                                <label>R$ {{ acumulativo.valor_financeira }}</label>
                                              </div>

                                              <center 
                                                style="font-size: 14px;"
                                                v-show="!acumulativo.mostrar_itens"
                                                v-on:click="alternarDetalhesVendas(acumulativo.id, acumulativo.tipo)">
                                                <i class="fas fa-ellipsis-h w3-text-theme"></i>
                                              </center>

                                              <center 
                                                style="font-size: 14px;"
                                                v-show="acumulativo.mostrar_itens"
                                                v-on:click="alternarDetalhesVendas(acumulativo.id, acumulativo.tipo)">
                                                <i class="fas fa-angle-down w3-text-theme"></i>
                                              </center>

                                              <div v-show="acumulativo.mostrar_itens">

                                                <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                                                  <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                                  <h6 
                                                    class="fundo-cabecalho-dados">
                                                    &nbsp;
                                                    <i class="fas fa-list-ul">
                                                    </i>&nbsp;
                                                    <strong> Itens do acumulativo </strong> 
                                                  </h6>
                                                  <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                                </div>

                                                <div 
                                                  v-for="(item, index) in acumulativo.itens_pedido" :key="index + 'acumulativo_itens'"
                                                  class="card-item w3-container" style="border: 0px!important;">
                                                  
                                                  <div class="w3-col w3-text-gray" style="font-style: italic; margin-left:90%; margin-top:0px; margin-bottom:0px;">
                                                    <label>Item </label>
                                                    <label>{{ index + 1 }}</label>
                                                  </div>

                                                  <div class="w3-col w3-text-theme">
                                                    <strong>{{ item.produto_id }} - {{ item.nome }}</strong>
                                                  </div>
                                                  
                                                  <div class="w3-third"> 
                                                    <label>Marca: </label>
                                                    <label>{{ item.marca }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third">
                                                    <label>Quantidade: </label>
                                                    <label>{{ item.quantidade }}</label>
                                                  </div>
                                                  
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Preço venda: </label>
                                                    <label>R$ {{ item.preco_venda }}</label>
                                                  </div>
                                                  
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Total item: </label>
                                                    <label>R$ {{ item.valor_total }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third" v-if="npz(item.valor_juros)">
                                                    <label class="alinhamento-numero">Juros: </label>
                                                    <label>R$ {{ item.valor_juros }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third" v-if="npz(item.total_desconto)">
                                                    <label class="alinhamento-numero">Desconto: </label>
                                                    <label>R$ {{ item.total_desconto }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Total líquido: </label>
                                                    <strong class="w3-text-green">R$ {{ item.total_liquido }}</strong>
                                                  </div>
                                                  
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">Total custo: </label>
                                                    <label>{{ autorizacoes.permitir_visualizar_lucratividade_mix == 'S' ? item.valor_total_custo : 'Não autorizado' }}</label>
                                                  </div>
                                                
                                                  <div class="w3-third">
                                                    <label class="alinhamento-numero">% Lucro: </label>
                                                    <label>{{ autorizacoes.permitir_visualizar_lucratividade_mix == 'S' ? item.percentual_lucro : 'Não autorizado' }}</label>
                                                  </div>
                                                  
                                                  <div class="w3-third" v-if="item.usou_promocao == 'S'">
                                                    <label class="alinhamento-numero">Promoção: </label>
                                                    <strong :style="getStyleAzulVermelho(item.usou_promocao)">{{ item.usou_promocao_analitico }}</strong>
                                                  </div>

                                                  <!-- Sempre por último -->
                                                  <div style="margin-top: 3px; border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                                </div>
                                              </div>
                                            
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      
                                      <div class="w3-animate-left w3-center" v-show="(Object.keys(acumulativos).length == 0)">
                                        <label style="font-size:13px!important; font-style: italic;">
                                          Não há dados a serem exibidos.
                                        </label>
                                      </div>

                                      <div
                                        style="margin-bottom: 5px;"
                                        class="w3-col l12 w3-center"
                                        v-show="empresa.mostrar_botao_ver_mais_acumulativos && (paginaAtualAcumulados == totalDePaginasAcumulados - 1)">
                                        <button
                                          class="w3-button w3-theme"
                                          v-on:click="buscarAcumulativos(empresa.empresa_id, true)">
                                          <span>Ver mais..</span>
                                        </button>
                                      </div>
                                      
                                      <paginacao
                                        @pagina="mudarPaginaAcumulados"
                                        :pagina-atual="paginaAtualAcumulados"
                                        :itens-por-pagina="itensPorPagina"
                                        :total-resultados="totalResultadosAcumulados" 
                                        :total-de-paginas="totalDePaginasAcumulados"
                                      />
                                    </div>
                    
                                    <div 
                                      v-cloak
                                      style="display: none"
                                      v-show="tabInternaAtual == 'tabVendasDevolucoes'"
                                      class="w3-row aba w3-animate-left w3-margin-top">
                                      
                                      <div v-if="pedidosDevolucoesFiltrados">
                                        <div
                                          :key="index"
                                        
                                          v-for="(devolucao, index) in pedidosDevolucoesFiltrados">
                                        
                                          <div class="w3-container card-item w3-border" style="padding:0px 5px 5px 5px">
                                            
                                            <div style="color: black !important" >

                                              <div v-if="devolucao.tipo" class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                                                <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                                <h6 
                                                  class="fundo-cabecalho-dados">
                                                  &nbsp;
                                                  <i class="fas fa-handshake-slash">
                                                  </i>&nbsp;
                                                  <strong> Devolução </strong> 
                                                </h6>
                                                <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.id)">
                                                <strong class="w3-text-red">{{ npz(devolucao.id) }}</strong>
                                              </div>
                                              
                                              <div class="w3-third" v-if="devolucao.nome_vendedor ">
                                                <label>Vendedor: </label>
                                                <label>{{ devolucao.nome_vendedor }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="devolucao.data_recebimento">
                                                <label>Dt. receb: </label>
                                                <label>{{ devolucao.data_recebimento }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_produtos)">
                                                <label>Valor produtos: </label>
                                                <label>R$ {{ devolucao.valor_produtos }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_fret)">
                                                <label>Frete: </label>
                                                <label>R$ {{ devolucao.valor_frete }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_outras_despesa)">
                                                <label>Outras despesas: </label>
                                                <label>R$ {{ devolucao.valor_outras_despesa }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_juro)">
                                                <label>Vendas Juros: </label>
                                                <label>R$ {{ devolucao.valor_juro }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_ta)">
                                                <label>TAC: </label>
                                                <label>R$ {{ devolucao.valor_ta }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_desconto)">
                                                <label>Desconto: </label>
                                                <label>R$ {{ devolucao.valor_desconto }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_credito_manual)">
                                                <label>Crédito manual: </label>
                                                <label>R$ {{ devolucao.valor_credito_manual }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_liquido)">
                                                <label>Vlr. líquido: </label>
                                                <label>R$ {{ devolucao.valor_liquido }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_acumulativo)">
                                                <label>Vlr. acumulativo: </label>
                                                <label>R$ {{ devolucao.valor_acumulativo }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_boleta)">
                                                <label>Vlr. boleto: </label>
                                                <label>R$ {{ devolucao.valor_boleta }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_cartao_cr)">
                                                <label>Vlr. cartão crédito: </label>
                                                <label>R$ {{ devolucao.valor_cartao_cr }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_cartao_cr)">
                                                <label>Vlr. cartão débito: </label>
                                                <label>R$ {{ devolucao.valor_cartao_db }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_cheque_prazo)">
                                                <label>Vlr. cheque a prazo: </label>
                                                <label>R$ {{ devolucao.valor_cheque_prazo }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_cheque_vista)">
                                                <label>Vlr. cheque a vista: </label>
                                                <label>R$ {{ devolucao.valor_cheque_vista }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_credito_gerado)">
                                                <label>Vlr. crédito gerado: </label>
                                                <label>R$ {{ devolucao.valor_credito_gerado }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_credito_utilizado)">
                                                <label>Vlr. crédito utilizado: </label>
                                                <label>R$ {{ devolucao.valor_credito_utilizado }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_dinheiro)">
                                                <label>Vlr. dinheiro: </label>
                                                <label>R$ {{ devolucao.valor_dinheiro }}</label>
                                              </div>

                                              <div class="w3-third" v-if="npz(devolucao.valor_pix)">
                                                <label>Vlr. pix: </label>
                                                <label>R$ {{ devolucao.valor_pix }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_duplicata)">
                                                <label>Vlr. duplicata: </label>
                                                <label>R$ {{ devolucao.valor_duplicata }}</label>
                                              </div>
                                              
                                              <div class="w3-third" v-if="npz(devolucao.valor_financeira)">
                                                <label>Vlr. financeira: </label>
                                                <label>R$ {{ devolucao.valor_financeira }}</label>
                                              </div>

                                              <center 
                                                  style="font-size: 14px;"
                                                  v-show="!devolucao.mostrar_itens"
                                                  v-on:click="alternarDetalhesVendas(devolucao.id, devolucao.tipo)">
                                                  <i class="fas fa-ellipsis-h w3-text-theme"></i>
                                                </center>

                                                <center 
                                                  style="font-size: 14px;"
                                                  v-show="devolucao.mostrar_itens"
                                                  v-on:click="alternarDetalhesVendas(devolucao.id, devolucao.tipo)">
                                                  <i class="fas fa-angle-down w3-text-theme"></i>
                                                </center>

                                                <div v-show="devolucao.mostrar_itens">

                                                  <div class="w3-col s12" style="margin-bottom: 0px; color: #333333;">
                                                    <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                                    <h6 
                                                      class="fundo-cabecalho-dados">
                                                      &nbsp;
                                                      <i class="fas fa-list-ul">
                                                      </i>&nbsp;
                                                      <strong> Itens da devolução </strong> 
                                                    </h6>
                                                    <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                                  </div>

                                                  <div 
                                                    v-for="(item, index) in devolucao.itens_pedido" :key="index"
                                                    class="card-item w3-container" style="border: 0px!important;">
                                                    
                                                    <div class="w3-col w3-text-gray" style="font-style: italic; margin-left:90%; margin-top:0px; margin-bottom:0px;">
                                                      <label>Item </label>
                                                      <label>{{ index + 1 }}</label>
                                                    </div>

                                                    <div class="w3-col w3-text-theme">
                                                      <strong>{{ item.produto_id }} - {{ item.nome }}</strong>
                                                    </div>
                                                    
                                                    <div class="w3-third"> 
                                                      <label>Marca: </label>
                                                      <label>{{ item.marca }}</label>
                                                    </div>
                                                  
                                                    <div class="w3-third">
                                                      <label>Quantidade: </label>
                                                      <label>{{ item.quantidade }}</label>
                                                    </div>
                                                    
                                                    <div class="w3-third">
                                                      <label class="alinhamento-numero">Preço venda: </label>
                                                      <label>R$ {{ item.preco_venda }}</label>
                                                    </div>
                                                    
                                                    <div class="w3-third">
                                                      <label class="alinhamento-numero">Total item: </label>
                                                      <label>R$ {{ item.valor_total }}</label>
                                                    </div>
                                                  
                                                    <div class="w3-third" v-if="npz(item.valor_juros)">
                                                      <label class="alinhamento-numero">Juros: </label>
                                                      <label>R$ {{ item.valor_juros }}</label>
                                                    </div>
                                                  
                                                    <div class="w3-third" v-if="npz(item.total_desconto)">
                                                      <label class="alinhamento-numero">Desconto: </label>
                                                      <label>R$ {{ item.total_desconto }}</label>
                                                    </div>
                                                  
                                                    <div class="w3-third">
                                                      <label class="alinhamento-numero">Total líquido: </label>
                                                      <strong class="w3-text-green">R$ {{ item.total_liquido }}</strong>
                                                    </div>
                                                    
                                                    <div class="w3-third">
                                                      <label class="alinhamento-numero">Total custo: </label>
                                                      <label>{{ autorizacoes.permitir_visualizar_lucratividade_mix == 'S' ? item.valor_total_custo : 'Não autorizado' }}</label>
                                                    </div>
                                                  
                                                    <div class="w3-third">
                                                      <label class="alinhamento-numero">% Lucro: </label>
                                                      <label>{{ autorizacoes.permitir_visualizar_lucratividade_mix == 'S' ? item.percentual_lucro : 'Não autorizado' }}</label>
                                                    </div>
                                                    
                                                    <div class="w3-third" v-if="item.usou_promocao == 'S'">
                                                      <label class="alinhamento-numero">Promoção: </label>
                                                      <strong :style="getStyleAzulVermelho(item.usou_promocao)">{{ item.usou_promocao_analitico }}</strong>
                                                    </div>

                                                    <!-- Sempre por último -->
                                                    <div style="margin-top: 3px; border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                                  </div>

                                                </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="w3-animate-left w3-center" v-show="(Object.keys(devolucoes).length == 0)">
                                        <label style="font-size:13px!important; font-style: italic;">
                                          Não há dados a serem exibidos.
                                        </label>
                                      </div>

                                      <div 
                                        style="margin-bottom: 5px;"
                                        class="w3-col l12 w3-center"
                                        v-show="empresa.mostrar_botao_ver_mais_devolucoes && (paginaAtualDevolu == totalDePaginasDevolu - 1)">
                                        <button
                                          class="w3-button w3-theme"
                                          v-on:click="buscarDevolucoes(empresa.empresa_id, true)">
                                          <span>Ver mais..</span>
                                        </button>
                                      </div>
                                      
                                      <paginacao
                                        @pagina="mudarPaginaDevolu" 
                                        :pagina-atual="paginaAtualDevolu"
                                        :itens-por-pagina="itensPorPagina"
                                        :total-resultados="totalResultadosDevolu" 
                                        :total-de-paginas="totalDePaginasDevolu"
                                      />
                                    </div>
                                  </div>
                                </div>
                                
                                <!--mobile-->
                                <div class="w3-col s12" v-cloak>
                                  <div 
                                    class="w3-responsive label-clicavel" 
                                    style="overflow: auto; color: black !important;">

                                    <div v-if="empresa.total_ped_valor_produtos">
                                    
                                      <p 
                                        v-if="!mostrar_detalhes_empresa_total_pedidos"
                                        @click="mostrar_detalhes_empresa_total_pedidos = true"
                                        class="fundo-cabecalho">
                                        &nbsp;<i class="fas fa-caret-right"></i>&nbsp;<label>Total de Pedidos</label>
                                      </p>
                                            
                                      <p  
                                        v-if="mostrar_detalhes_empresa_total_pedidos"
                                        @click="mostrar_detalhes_empresa_total_pedidos = false"
                                        class="fundo-cabecalho">
                                        &nbsp;<i class="fas fa-sort-down"></i>&nbsp;<label>Total de Pedidos</label>
                                      </p>
                                      
                                      <div v-if="mostrar_detalhes_empresa_total_pedidos" class="card-item w3-border">
                                        
                                        <div v-if="npz(empresa.total_ped_valor_produtos)">
                                          <label>Valor produtos: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_produtos }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_frete) ">
                                          <label>Frete: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_frete }}</label>
                                        </div>
                                        
                                        <div  v-if="npz(empresa.total_ped_valor_outras_despesas)">
                                          <label>Outras despesas: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_outras_despesas }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_juros) ">
                                          <label>Juros: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_juros }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_tac)">
                                          <label>TAC: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_tac }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_desconto) ">
                                          <label>Desconto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_desconto }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_credito_manual) ">
                                          <label>Crédito manual: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_credito_manual }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_liquido) ">
                                          <label>Vlr. líquido: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_liquido }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_acumulativo) ">
                                          <label>Vlr. acumulativo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_acumulativo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_boleta)">
                                          <label>Vlr. boleto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_boleta }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_cartao_cr)">
                                          <label>Vlr. cartão crédito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_cartao_cr }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_cartao_db)">
                                          <label>Vlr. cartão débito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_cartao_db }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_cheque_prazo)">
                                          <label>Vlr. cheque a prazo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_cheque_prazo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_cheque_vista)">
                                          <label>Vlr. cheque a vista: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_cheque_vista }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_credito_gerado)">
                                          <label>Vlr. crédito gerado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_credito_gerado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_credito_utilizado)">
                                          <label>Vlr. crédito utilizado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_credito_utilizado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_dinheiro)">
                                          <label>Vlr. dinheiro: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_dinheiro }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_duplicata)">
                                          <label>Vlr. duplicata: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_duplicata }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_ped_valor_financeira)">
                                          <label>Vlr. financeira: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_ped_valor_financeira }}</label>
                                        </div>
                                      
                                      </div>
                                    </div>
                                    
                                    <div v-if="empresa.total_acumul_valor_produtos">
                                      
                                      <p 
                                        class="fundo-cabecalho"
                                        v-if="!mostrar_detalhes_empresa_total_acumulativos"
                                        @click="mostrar_detalhes_empresa_total_acumulativos = true">
                                        &nbsp;<i class="fas fa-caret-right"></i>&nbsp;<label>Total de Acumulativos</label>
                                      </p>
                                            
                                      <p  
                                        class="fundo-cabecalho"
                                        v-if="mostrar_detalhes_empresa_total_acumulativos"
                                        @click="mostrar_detalhes_empresa_total_acumulativos = false">
                                        &nbsp;<i class="fas fa-sort-down"></i>&nbsp;<label>Total de Acumulativos</label>
                                      </p>
                                      
                                      <div v-if="mostrar_detalhes_empresa_total_acumulativos" class="card-item w3-border">
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_produtos)">
                                          <label>Valor produtos: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_produtos }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_frete)">
                                          <label>Frete: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_frete }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_outras_despesas)">
                                          <label>Outras despesas: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_outras_despesas }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_juros)">
                                          <label>Juros: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_juros }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_tac)">
                                          <label>TAC: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_tac }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_desconto)">
                                          <label>Desconto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_desconto }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_credito_manual)">
                                          <label>Crédito manual: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_credito_manual }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_liquido)">
                                          <label>Vlr. líquido: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_liquido }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_acumulativo)">
                                          <label>Vlr. acumulativo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_acumulativo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_boleta)">
                                          <label>Vlr. boleto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_boleta }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_cartao_cr)">
                                          <label>Vlr. cartão crédito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_cartao_cr}}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_cartao_db)">
                                          <label>Vlr. cartão débito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_cartao_db }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_cheque_prazo)">
                                          <label>Vlr. cheque a prazo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_cheque_prazo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_cheque_vista)">
                                          <label>Vlr. cheque a vista: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_cheque_vista }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_credito_gerado)">
                                          <label>Vlr. crédito gerado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_credito_gerado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_credito_utilizado)">
                                          <label>Vlr. crédito utilizado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_credito_utilizado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_dinheiro)">
                                          <label>Vlr. dinheiro: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_dinheiro }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_duplicata)">
                                          <label>Vlr. duplicata: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_duplicata }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_acumul_valor_financeira)">
                                          <label>Vlr. financeira: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_acumul_valor_financeira }}</label>
                                        </div>
                                        
                                        
                                      </div>
                                    </div>
                                    
                                    <div v-if="empresa.total_devol_valor_produtos">
                                      <p 
                                        class="fundo-cabecalho"
                                        v-if="!mostrar_detalhes_empresa_total_devolucoes"
                                        @click="mostrar_detalhes_empresa_total_devolucoes = true">
                                        &nbsp;<i class="fas fa-caret-right"></i>&nbsp;<label>Total de Devoluções</label>
                                      </p>
                                            
                                      <p  
                                        class="fundo-cabecalho"
                                        v-if="mostrar_detalhes_empresa_total_devolucoes"
                                        @click="mostrar_detalhes_empresa_total_devolucoes = false">
                                        &nbsp;<i class="fas fa-sort-down"></i>&nbsp;<label>Total de Devoluções</label>
                                      </p>
                                      
                                      <div v-if="mostrar_detalhes_empresa_total_devolucoes" class="card-item w3-border">
                                        
                                        <div v-if="npz(empresa.total_devol_valor_produtos)">
                                          <label>Valor produtos: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_produtos }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_frete)">
                                          <label>Frete: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_frete }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_outras_despesas)">
                                          <label>Outras despesas: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_outras_despesas }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_juros)">
                                          <label>Juros: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_juros }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_tac)">
                                          <label>TAC: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_tac }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_desconto)">
                                          <label>Desconto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_desconto }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_credito_manual)">
                                          <label>Crédito manual: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_credito_manual }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_liquido)">
                                          <label>Vlr. líquido: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_liquido }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_acumulativo)">
                                          <label>Vlr. acumulativo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_acumulativo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_boleta)">
                                          <label>Vlr. boleto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_boleta }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_cartao_cr)">
                                          <label>Vlr. cartão crédito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_cartao_cr }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_cartao_db)">
                                          <label>Vlr. cartão débito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_cartao_db }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_cheque_prazo)">
                                          <label>Vlr. cheque a prazo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_cheque_prazo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_cheque_vista)">
                                          <label>Vlr. cheque a vista: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_cheque_vista }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_credito_gerado)">
                                          <label>Vlr. crédito gerado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_credito_gerado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_credito_utilizado)">
                                          <label>Vlr. crédito utilizado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_credito_utilizado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_dinheiro)">
                                          <label>Vlr. dinheiro: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_dinheiro }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_duplicata)">
                                          <label>Vlr. duplicata: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_duplicata }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_devol_valor_financeira)">
                                          <label>Vlr. financeira: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_devol_valor_financeira }}</label>
                                        </div>
                                      
                                      </div>
                                    </div>
                                    
                                    <div v-if="empresa.total_empresa_valor_produtos"> 
                                      <p 
                                        class="fundo-cabecalho"
                                        v-if="!mostrar_detalhes_empresa_total_empresa"
                                        @click="mostrar_detalhes_empresa_total_empresa = true">
                                        &nbsp;<i class="fas fa-caret-right"></i>&nbsp;&nbsp;<label>Total Empresa</label>
                                      </p>
                                            
                                      <p  
                                        class="fundo-cabecalho"
                                        v-if="mostrar_detalhes_empresa_total_empresa"
                                        @click="mostrar_detalhes_empresa_total_empresa = false">
                                        &nbsp;<i class="fas fa-sort-down"></i>&nbsp;&nbsp;<label>Total Empresa</label>
                                      </p>
                                      
                                      <div v-if="mostrar_detalhes_empresa_total_empresa" class="card-item w3-border">
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_produtos)">
                                          <label>Valor produtos: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_produtos }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_frete)">
                                          <label>Frete: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_frete }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_outras_despesas)">
                                          <label>Outras despesas: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_outras_despesas }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_juros)">
                                          <label>Juros: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_juros }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_tac)">
                                          <label>TAC: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_tac }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_desconto)">
                                          <label>Desconto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_desconto }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_credito_manual)">
                                          <label>Crédito manual: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_credito_manual }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_liquido)">
                                          <label>Vlr. líquido: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_liquido }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_acumulativo)">
                                          <label>Vlr. acumulativo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_acumulativo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_boleta)">
                                          <label>Vlr. boleto: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_boleta }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_cartao_cr)">
                                          <label>Vlr. cartão crédito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_cartao_cr }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_cartao_db)">
                                          <label>Vlr. cartão débito: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_cartao_db }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_cheque_prazo)">
                                          <label>Vlr. cheque a prazo: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_cheque_prazo }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_cheque_vista)">
                                          <label>Vlr. cheque a vista: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_cheque_vista }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_credito_gerado)">
                                          <label>Vlr. crédito gerado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_credito_gerado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_credito_utilizado)">
                                          <label>Vlr. crédito utilizado: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_credito_utilizado }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_dinheiro)">
                                          <label>Vlr. dinheiro: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_dinheiro }}</label>
                                        </div>

                                        <div v-if="npz(empresa.total_empresa_valor_pix)">
                                          <label>Vlr. pix: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_pix }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_duplicata)">
                                          <label>Vlr. duplicata: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_duplicata }}</label>
                                        </div>
                                        
                                        <div v-if="npz(empresa.total_empresa_valor_financeira)">
                                          <label>Vlr. financeira: </label>
                                          <label class="alinhamento-numero">R$ {{ empresa.total_empresa_valor_financeira }}</label>
                                        </div>
                                       
                                      </div>
                                    </div>
                                  </div>
                                </div>
                               
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="w3-animate-left w3-center w3-container cards-dados" v-show="!processando_tot_pedidos && (Object.keys(total_geral_pedidos.totalizadores_empresas).length == 0)">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>

                        <div class="w3-container cards-dados w3-row" v-show="!processando_tot_pedidos && (Object.keys(total_geral_pedidos.totalizadores_empresas).length > 0)">
                          <p 
                            class="fundo-cabecalho"
                            v-if="!mostrar_detalhes_empresa_total_geral"
                            @click="mostrar_detalhes_empresa_total_geral = true">
                            &nbsp;<i class="fas fa-caret-right"/>&nbsp;<label>Total Geral</label>
                          </p>
                          
                          <p  
                            class="fundo-cabecalho"
                            v-if="mostrar_detalhes_empresa_total_geral"
                            @click="mostrar_detalhes_empresa_total_geral = false">
                            &nbsp;<i class="fas fa-sort-down"/>&nbsp;<label>Total Geral</label>
                          </p>
                          
                          <div 
                            v-if="mostrar_detalhes_empresa_total_geral" 
                            class=" w3-padding-bottom w3-border card-item w3-container">
                            
                            <div class="w3-container" style="padding:0px 5px 5px 5px">
                            
                              <div>
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_produtos)">
                                  <label>Valor produtos: </label>
                                  <label >R$ {{ total_geral_pedidos.total_geral_valor_produtos }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_frete)">
                                  <label>Frete: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_frete }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_outras_despesas)">
                                  <label>Outras despesas: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_outras_despesas }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_juros)">
                                  <label>Juros: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_juros }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_tac)">
                                  <label>TAC: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_tac }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_desconto)">
                                  <label>Desconto: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_desconto }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_credito_manual)">
                                  <label>Crédito manual: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_credito_manual }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_liquido)">
                                  <label>Vlr. líquido: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_liquido }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_acumulativo)">
                                  <label>Vlr. acumulativo: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_acumulativo }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_boleta)">
                                  <label>Vlr. boleto: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_boleta }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_cartao_cr)">
                                  <label>Vlr. cartão crédito: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_cartao_cr }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_cartao_db)">
                                  <label>Vlr. cartão débito: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_cartao_db }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_cheque_prazo)">
                                  <label>Vlr. cheque a prazo: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_cheque_prazo }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_cheque_vista)">
                                  <label>Vlr. cheque a vista: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_cheque_vista }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_credito_gerado)">
                                  <label>Vlr. crédito gerado: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_credito_gerado }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_credito_utilizado)">
                                  <label>Vlr. crédito utilizado: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_credito_utilizado }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_dinheiro)">
                                  <label>Vlr. dinheiro: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_dinheiro }}</label>
                                </div>

                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_pix)">
                                  <label>Vlr. pix: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_pix }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_duplicata)">
                                  <label>Vlr. duplicata: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_duplicata }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(total_geral_pedidos.total_geral_valor_financeira)">
                                  <label>Vlr. financeira: </label>
                                  <label>R$ {{ total_geral_pedidos.total_geral_valor_financeira }}</label>
                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Inicio Acumulativos-->
                      <div  
                        style="cursor: default;" 
                        v-if="item.slug === 'acumulativos'">

                        <div class="w3-col s12 m12 l12" v-show="processando_acumulativos_aberto">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>
                        
                        <div v-show="!processando_acumulativos_aberto && (Object.keys(acumulativo_aberto).length > 0)" class="aba w3-animate-left w3-row-padding" style="margin-top: 5px;">
                    			<div 
                            :key="index_acumulativo"
                    			  v-for="(acumulativo, index_acumulativo) in acumulativos_aberto_por_ender_e_emp">
                    			  
                    				<div class="w3-col s12 m12 l12 w3-container" style="margin: 0px!important;">
                    					
                              <div v-for="(empresa, index) in acumulativo.empresas" :key="index" style="font-size: 14px;">
                                  
                                <div class="w3-col s12" style="margin-bottom: 5px; color: #333333; margin-top: 0px!important;">
                                  
                                  <div v-if="empresa.mostrar_nome_endereco">
                                    <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                    <h6 
                                      class="fundo-cabecalho-dados">
                                      &nbsp;
                                      <i class="fas fa-map-marked-alt">
                                      </i>&nbsp;
                                      <strong> {{acumulativo.endereco_completo}} </strong> 
                                    </h6>
                                    <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                  </div>

                                  <div v-if="empresa.mostrar_nome_empresa" class="w3-center">
                                    <h6>&nbsp;
                                      <strong class="w3-text-theme"> {{`${empresa.empresa_id} - ${empresa.nome_resumido_empresa}`}} </strong>
                                    </h6>
                                  </div>

                                  <div class="w3-container card-item" style="margin-top: 0px!important;">

                                    <h6 
                                      class="fundo-cabecalho-dados">
                                      &nbsp;
                                      <i class="fas fa-shopping-cart">
                                      </i>&nbsp;
                                      <strong> Pedido </strong> 
                                    </h6>
                                    <div style="border-bottom: 2px dotted #a3a3a3; margin-bottom: 5px;" class="w3-col s12"></div>

                                    <div class="w3-col m3 l3">
                                      <strong class="w3-text-theme">{{empresa.orcamento_id}}</strong>
                                    </div>
                                      
                                    <div v-if="empresa.nome_vendedor" class="w3-col">
                                      <label>Vendedor: </label>
                                      <label>{{empresa.nome_vendedor}}</label>
                                    </div>
                                      
                                    <div v-if="empresa.data_recebimento" class="w3-col m3 l3">
                                      <label>Data recebimento: </label>
                                      <label>{{ empresa.data_recebimento }}</label>
                                    </div>
                                      
                                    <div v-if="npz(empresa.valor_produtos)" class="w3-col m3 l3">
                                      <label>Valor produtos: </label>
                                      <label>R$ {{ empresa.valor_produtos }}</label>
                                    </div>
                                      
                                    <div v-if="npz(empresa.valor_perc_frete)" class="w3-col m3 l3">
                                      <label>Frete/out.desp/TAC: </label>
                                      <label>R$ {{ empresa.valor_perc_frete }}</label>
                                    </div>
                                      
                                    <div v-if="npz(empresa.valor_desconto)" class="w3-col m3 l3">
                                      <label>Desconto: </label>
                                      <label>R$ {{ empresa.valor_desconto }}</label>
                                    </div>
                                      
                                    <div v-if="npz(empresa.valor_pedido)" class="w3-col m3 l3">
                                      <label>Valor líquido: </label>
                                      <label>R$ {{ empresa.valor_pedido }}</label>
                                    </div>
                                      
                                    <div v-if="npz(empresa.valor_dev_acum_aberto)" class="w3-col m3 l3">
                                      <label>Devolvido: </label>
                                      <label>R$ {{ empresa.valor_dev_acum_aberto }}</label>
                                    </div>
                                      
                                    <div class="w3-col m3 l3">
                                      <label>Saldo: </label>
                                      <label>
                                        R$	{{
                                          formatarValor(
                                            parseFloat(
                                              strPadraoToNumber(empresa.valor_pedido) - 
                                              strPadraoToNumber(empresa.valor_dev_acum_aberto)
                                            ), 
                                          2) 
                                        }}
                                      </label>
                                    </div>
                                    
                                    <div class="w3-col w3-center" style="font-size: 14px;">
                                      <div @click="mostrarProdutos(empresa)" class="w3-text-theme" >
                                        <i class="fas fa-angle-down w3-animate-zoom" v-if="empresa.mostrar"></i>
                                        <i v-else class="fas fa-ellipsis-h w3-animate-zoom"></i>
                                      </div>
                                    </div>

                                    <transition name="fade" mode="out-in">
                                      <div v-if="empresa.mostrar" style="padding:0px;">
                                        
                                        <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                        <h6 
                                          class="fundo-cabecalho-dados">
                                          &nbsp;
                                          <i class="fas fa-list-ul">
                                          </i>&nbsp;
                                          <strong> Itens do pedido </strong> 
                                        </h6>
                                        <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                                        <br/>

                                        <div 
                                          :key="index"
                                          style="margin-left: 5px;"
                                          v-for="(produto, index) in acumulativos_items">

                                          <div v-if="empresa.orcamento_id == produto.orcamento_id">
                                            <div class="w3-col">
                                              <strong class="w3-text-theme">{{ produto.produto_id }} - {{ produto.descricao }}</strong>
                                            </div>
                                              
                                            <div class="w3-col">
                                              <label>Marca: </label>
                                              <label>{{ produto.marca }}</label>
                                            </div>
                                                      
                                            <div class="w3-col">
                                              <label>Quantidade: </label>
                                              <label>{{ produto.quantidade }}</label>
                                            </div>
                                                      
                                            <div class="w3-col">
                                              <label>Saldo: </label>
                                              <label>{{ produto.saldo }}</label>
                                            </div>

                                            <!-- Sempre por último -->
                                            <div style="border-bottom: 2px dotted #a3a3a3; margin-top: 5px; margin-bottom: 10px;" class="w3-col s12"></div>	
                                          </div>
                                        </div>
                                      </div>
                                    </transition>
                                  </div>

                                  <div 
                                    class="fundo-cabecalho"
                                    @click="mostrar_detalhes_totais_empresa = true"
                                    v-if="!mostrar_detalhes_totais_empresa && empresa.mostrar_totalizador_empresa">
                                    &nbsp;<i class="fas fa-caret-right"></i>
                                    &nbsp;<label>Total Por Empresa</label>
                                  </div>
                                        
                                  <div  
                                    class="fundo-cabecalho"
                                    @click="mostrar_detalhes_totais_empresa = false"
                                    v-if="mostrar_detalhes_totais_empresa && empresa.mostrar_totalizador_empresa">
                                    &nbsp;<i class="fas fa-sort-down"></i>
                                    &nbsp;<label>Total Por Empresa</label>
                                  </div>

                                  <div style="margin-bottom: 5px;"/>

                                  <div 
                                    style="margin-top: 5px;"
                                    class="w3-container card-item"
                                    v-if="mostrar_detalhes_totais_empresa && empresa.mostrar_totalizador_empresa">
                                      
                                    <div class="w3-col m3 l3">
                                      <label>Total valor: </label>
                                      <label>R$ {{ empresa.totalizador.total_emp_valor_produtos }} </label>
                                    </div>

                                    <div class="w3-col m3 l3">
                                      <label>Total frete/out.desp/TAC: </label>
                                      <label> R$ {{ empresa.totalizador.total_emp_frete_outros }} </label>
                                    </div>
                                        
                                    <div class="w3-col m3 l3">
                                      <label>Total desconto: </label>
                                      <label> R$ {{ empresa.totalizador.total_emp_desconto }} </label>
                                    </div>
                                      
                                    <div class="w3-col m3 l3">
                                      <label>Total liquido: </label>
                                      <label>R$ {{ empresa.totalizador.total_emp_valor_liquido }} </label>
                                    </div>
                                        
                                    <div class="w3-col m3 l3">
                                      <label>Total devolvido: </label>
                                      <label>R$ {{ empresa.totalizador.total_emp_devolvido }} </label>
                                    </div>
                                        
                                    <div class="w3-col m3 l3">
                                      <label>Total saldo: </label>
                                      <label>R$ {{ empresa.totalizador.total_emp_saldo }} </label>
                                    </div>
                                  </div>

                                  <div 
                                    class="fundo-cabecalho" 
                                    @click="mostrar_detalhes_totais_endereco = true"
                                    style="background-color: #9c1d1c!important;"
                                    v-if="!mostrar_detalhes_totais_endereco && index == acumulativo.empresas.length - 1 && totalizadores_acumulativos !== undefined">
                                    &nbsp;<i class="fas fa-caret-right"></i>
                                    &nbsp;<label>Total Por Endereço</label>
                                  </div>
                                        
                                  <div  
                                    class="fundo-cabecalho"
                                    @click="mostrar_detalhes_totais_endereco = false"
                                    style="background-color: #9c1d1c!important;"
                                    v-if="mostrar_detalhes_totais_endereco && index == acumulativo.empresas.length - 1 && totalizadores_acumulativos !== undefined">
                                    &nbsp;<i class="fas fa-sort-down"></i>
                                    &nbsp;<label>Total Por Endereço</label>
                                  </div>

                                  <div 
                                    style="margin-top: 5px;"
                                    class="w3-container card-item"
                                    v-if="mostrar_detalhes_totais_endereco && index == acumulativo.empresas.length - 1 && totalizadores_acumulativos !== undefined">
                                      
                                    <div class="w3-col m3 l3">
                                      <label>Total valor: </label>
                                      <label>R$ {{ totalizadores_acumulativos[index_acumulativo].acumulativo_tot_produto }} </label>
                                    </div>
                                      
                                    <div class="w3-col m3 l3">
                                      <label>Total frete/out.desp/TAC: </label>
                                      <label> R$ {{ totalizadores_acumulativos[index_acumulativo].acumulativo_tot_frete_outros }} </label>
                                    </div>
                                        
                                    <div class="w3-col m3 l3">
                                      <label>Total desconto: </label>
                                      <label> R$ {{ totalizadores_acumulativos[index_acumulativo].acumulativo_tot_desconto }} </label>
                                    </div>
                                      
                                    <div class="w3-col m3 l3">
                                      <label>Total liquido: </label>
                                      <label>R$ {{ totalizadores_acumulativos[index_acumulativo].acumulativo_tot_liquido }} </label>
                                    </div>
                                        
                                    <div class="w3-col m3 l3">
                                      <label>Total devolvido: </label>
                                      <label>R$ {{ totalizadores_acumulativos[index_acumulativo].acumulativo_tot_devolvido }} </label>
                                    </div>
                                        
                                    <div class="w3-col m3 l3">
                                      <label>Total saldo: </label>
                                      <label>R$ {{ totalizadores_acumulativos[index_acumulativo].acumulativo_tot_saldo }} </label>
                                    </div>
                                  </div>
                                </div>
                    				  </div>

                              <paginacao
                                @pagina="mudarPaginaAcum" 
                                :pagina-atual="paginaAtualAcum" 
                                :itens-por-pagina="itensPorPagina" 
                                :total-resultados="totalResultadosAcum"
                                :total-de-paginas="totalDePaginasAcum" 
                              />
                    			  </div>
                    		  </div>

                          <div 
                            v-if="Object.keys(acumulativo_aberto).length > 0"
                            class="card-item w3-container" style="margin-left: 8px; margin-right: 8px;">

                              <div 
                                class="fundo-cabecalho"
                                style="background-color: #3f51b5!important;"
                                @click="mostrar_detalhes_totais = true"
                                v-if="!mostrar_detalhes_totais">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Total Geral Acumulativos Abertos</label>
                              </div>
                                    
                              <div  
                                class="fundo-cabecalho"
                                style="background-color: #3f51b5!important;"
                                @click="mostrar_detalhes_totais = false"
                                v-if="mostrar_detalhes_totais">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Total Geral Acumulativos Abertos</label>
                              </div>
                              
                              <div style="margin-bottom: 5px;"/>

                              <div v-if="mostrar_detalhes_totais" class="w3-row-padding" style="font-size: 14px;">
                                <div class="w3-col">
                                  <label>Valor produtos: </label>
                                  <label>
                                    R$ {{ acumulativo_aberto.totalizadores_acumulativos[acumulativo_aberto.totalizadores_acumulativos.length - 1].acumulativo_tot_ger_produto }}
                                  </label>
                                </div>
                                
                                <div class="w3-col">
                                  <label>Frete/out.desp/TAC: </label>
                                  <label>
                                    R$ {{ acumulativo_aberto.totalizadores_acumulativos[acumulativo_aberto.totalizadores_acumulativos.length - 1].acumulativo_tot_ger_frete_outros }}
                                  </label>
                                </div>
                                
                                <div class="w3-col">
                                  <label>Valor líquido: </label>
                                  <label>
                                    R$ {{ acumulativo_aberto.totalizadores_acumulativos[acumulativo_aberto.totalizadores_acumulativos.length - 1].acumulativo_tot_ger_desconto }}
                                  </label>
                                </div>
                                
                                <div class="w3-col">
                                  <label>Custo cartório: </label>
                                  <label>
                                    R$ {{ acumulativo_aberto.totalizadores_acumulativos[acumulativo_aberto.totalizadores_acumulativos.length - 1].acumulativo_tot_ger_liquido }}
                                  </label>
                                </div>
                                
                                <div class="w3-col">
                                  <label>Devolvido: </label>
                                  <label>
                                    R$ {{ acumulativo_aberto.totalizadores_acumulativos[acumulativo_aberto.totalizadores_acumulativos.length - 1].acumulativo_tot_ger_devolvido }}
                                  </label>
                                </div>
                                
                                <div class="w3-col">
                                  <label>Saldo: </label>
                                  <label>
                                    R$ {{ acumulativo_aberto.totalizadores_acumulativos[acumulativo_aberto.totalizadores_acumulativos.length - 1].acumulativo_tot_ger_saldo }}
                                  </label>
                                </div>
                              </div>
                            </div>
                        
                            <div class="w3-row  w3-row-padding w3-margin-bottom w3-hide" >
                              <div class="w3-col s12 m6 l6 w3-center w3-margin-top">
                                <input class="w3-check" type="checkbox" checked="checked" id="docDesc">
                                <label for="docDesc" class="label-clicavel"><label>Trocar cliente dos acumulativos</label></label>
                              </div>
                              <div class="w3-col s12 m6 l6 w3-center" style="padding-top: 10px;">
                                <label class="label-vermelha"  style="display: block; ">Total percentual participação</label>
                                <p style="margin: 0">0,00</p>
                              </div>
                            </div>
                          </div>

                          <div class="w3-animate-left w3-center cards-dados w3-container" v-show="!processando_acumulativos_aberto && (Object.keys(acumulativo_aberto).length == 0)">
                            <label style="font-size:13px!important; font-style: italic;">
                              Não há dados a serem exibidos.
                            </label>
                          </div>
                        </div>
                      
                      <div 
                        v-if="item.slug === 'creditos'"
                        style="cursor: default; border-bottom-style: none; font-size: 14px;">

        								<div class="w3-col s12 m12 l12" v-show="processando_creditos">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>
                        
                        <div 
                          v-if="!processando_creditos && (creditos.length > 0)"
                          style="margin-top: 10px;"
                          class="aba w3-animate-left w3-row-padding no-padding-mobile">
                          
                          <div class="w3-row">
                            <div class="w3-row">
                              <div class="w3-col s12">
                                <strong >Tipo do recebimento: </strong>
                                <select v-model="filtro_credito" @change="mudarPagina(0)" class="w3-btn w3-border w3-white">
                                  <option value="A">Em Aberto</option> 
                                  <option value="B">Baixados</option>
                                  <option value="todos">Todos</option>
                                </select>
                              </div>
                            </div>
                            
                            <div class="w3-margin-top">
                              <div 
                                v-for="(credito, index) in creditosFiltrados" :key="index"
                                class="card-item w3-border w3-container" >
                                
                                <div class="w3-third">
                                  <label>Financeiro: </label>
                                  <strong>R$ {{ npz(credito.financeiro_id) }}</strong>
                                </div>
                                
                                <div class="w3-third">
                                  <label>Status: </label>
                                  <label :class="getColorStatus(credito.status)">{{ credito.status_nome }}</label>
                                </div>
                                
                                <div class="w3-third">
                                  <label>Emissão: </label>
                                  <label>{{ credito.data_emissao }}</label>
                                </div>
                                
                                <div class="w3-third">
                                  <label>Vencimento: </label>
                                  <label>{{ credito.data_vencimento }}</label>
                                </div>
                                
                                <div class="w3-third">
                                  <label>Empresa: </label>
                                  <label>{{ `${credito.empresa_id} - ${credito.nome_resumido_empresa}` }}</label>
                                </div>
                              
                                <div class="w3-third">
                                  <label>Documento: </label>
                                  <label>{{ credito.documento }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(credito.valor_documento)">
                                  <label>Valor: </label>
                                  <label>R$ {{ credito.valor_documento }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(credito.valor_juros)" >
                                  <label>Juros: </label>
                                  <label>R$ {{ credito.valor_juros }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(credito.valor_multa)">
                                  <label>Multa: </label>
                                  <label>R$ {{ credito.valor_multa }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(credito.valor_desconto)">
                                  <label>Desconto: </label>
                                  <label>R$ {{ credito.valor_desconto }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(credito.valor_adiantado)">
                                  <label>Adiantado: </label>
                                  <label>R$ {{ credito.valor_adiantado }}</label>
                                </div>
                                
                                <div class="w3-third" v-if="npz(credito.valor_documento)">
                                  <label>Valor crédito: </label>
                                  <label>R$ {{ credito.valor_documento }}</label>
                                </div>

                              </div>

                              <div 
                                v-if="!mostrar_detalhes_totais"
                                @click="mostrar_detalhes_totais = true"
                                class="fundo-cabecalho">
                                &nbsp;<i class="fas fa-caret-right"></i>
                                &nbsp;<label>Total Geral</label>
                              </div>
                                    
                              <div  
                                v-if="mostrar_detalhes_totais"
                                @click="mostrar_detalhes_totais = false"
                                class="fundo-cabecalho">
                                &nbsp;<i class="fas fa-sort-down"></i>
                                &nbsp;<label>Total Geral</label>
                              </div>

                              <div v-if="mostrar_detalhes_totais" class="card-item w3-container" style="margin-top: 5px;">
                                <strong>R$ {{ formatarValor(valor_total_geral, 2) }}</strong>
                              </div>

                            </div>

                            <paginacao
                              @pagina="mudarPaginaCredito"
                              :pagina-atual="paginaAtualCreditos"
                              :itens-por-pagina="itensPorPagina"
                              :total-resultados="totalResultadosCreditos"
                              :total-de-paginas="totalDePaginasCreditos"
                            />
                          </div>
                        </div>

                        <div class="w3-animate-left w3-center cards-dados w3-container" v-show="!processando_creditos && (Object.keys(creditos).length == 0)">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>
                      </div>
                      
                      <div 
                        v-if="item.slug === 'devolucoes'"
                        style="cursor: default; border-bottom: none;"
                        class="w3-row aba w3-animate-left">
                        
                        <div class="w3-col s12 m12 l12" v-show="processando_devolucoes_pendentes">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>
                        
                        <div style="margin-top: 5px;" v-show="!processando_devolucoes_pendentes && (Object.keys(devolucoes_pendentes).length > 0)">
                          <div 
                            :key="index"
                            v-for="(devolucao, index) in devolucoes_pendentes"
                            class="w3-row card-item w3-border">

                              <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                              <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                              <h6 
                                class="fundo-cabecalho-dados">
                                &nbsp;
                                <i class="fas fa-handshake-slash">
                                </i>&nbsp;
                                <strong> Devolução: </strong> 
                                <strong> {{ devolucao.requisicao_id }} </strong>
                              </h6>
                              <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                            </div>

                            <div class="w3-col">
                              <label>Pedido: </label>
                              <strong class="">{{ devolucao.orcamento_id }}</strong>
                            </div>
                            
                            <div class="w3-col">
                              <label>Data da cadastro: </label>
                              <label class="">{{ devolucao.data_cadastro }}</label>
                            </div>
                            
                            <div class="w3-col">
                              <label>Valor: </label>
                              <label class="">R$ {{ devolucao.valor_devolucao }}</label>
                            </div>
                            
                            <div class="w3-col">
                              <label>Empresa: </label>
                              <label class="">{{ devolucao.nome_resumido_empresa }}</label>
                            </div>
                            
                            <div class="w3-col">
                              <label>Gerar crédito?: </label>
                              <strong 
                              
                                :style="getStyleAzulVermelho(devolucao.gerar_credito, false)">
                                {{ devolucao.gerar_credito_analitico }}
                              </strong>
                            </div>

                            <center 
                              style="font-size: 14px;"
                              v-on:click="mostrartItems(devolucao)"
                              v-show="!devolucao.mostrar && (devolucao.itens_devolucoes.length > 0)">
                              <i class="fas fa-ellipsis-h w3-text-theme"></i>
                            </center>

                            <center 
                              style="font-size: 14px;"
                              v-on:click="mostrartItems(devolucao)"
                              v-show="devolucao.mostrar && (devolucao.itens_devolucoes.length > 0)">
                              <i class="fas fa-angle-down w3-text-theme"></i>
                            </center>
                            
                            <div v-if="devolucao.mostrar">

                              <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                                <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px;" class="w3-col s12"></div>
                                <h6 
                                  class="fundo-cabecalho-dados">
                                  &nbsp;
                                  <i class="fas fa-list-ul">
                                  </i>&nbsp;
                                  <strong> Itens da devolução </strong> 
                                </h6>
                                <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                              </div>

                              <div 
                                :key="index_item"
                                v-for="(produto, index_item) in devolucao.itens_devolucoes" style="font-size: 14px;">
                                
                                <div class="w3-col s12 w3-text-theme">
                                  <strong>{{ produto.produto_id }} - {{ produto.nome }}</strong>
                                </div>
                                
                                <div class="w3-col s12">
                                  <label>Marca: </label>
                                  <label class="">{{ produto.marca }}</label>
                                </div>
                                
                                <div class="w3-col s12">
                                  <label>Unidade: </label>
                                  <label class="">{{ produto.unidade }}</label>
                                </div>
                                
                                <div class="w3-col s12">
                                  <label>Sem agen.: </label>
                                  <label class="">{{ produto.quantidade_sem_agendamento }}</label>
                                </div>
                                
                                <div class="w3-col s12">
                                  <label>Ent.pend.: </label>
                                  <label class="">{{ produto.quantidade_nao_entregue }}</label>
                                </div>
                                
                                <div class="w3-col s12">
                                  <label>Já entregue: </label>
                                  <label class="">{{produto.quantidade_ja_entregue }}</label>
                                </div>
                                
                                <div class="w3-col s12">
                                  <label>Total qtd: </label>
                                  <label class="">{{produto.quantidade_total }}</label>
                                </div>

                                <!-- Sempre por último -->
                                <div style="margin-top: 3px; border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="w3-animate-left w3-center cards-dados w3-container" v-show="!processando_devolucoes_pendentes && (Object.keys(devolucoes_pendentes).length == 0)">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>
                      </div>
                      
                      <div 
                        v-if="item.slug === 'naorecebidos'"
                        class="w3-animate-left"
                        style="cursor: default; border-bottom-style: none">

                        <div class="w3-col s12 m12 l12" v-show="processando_rec_entr_nao_receb">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>
                        
                        <div class="w3-bar w3-white" v-if="!processando_rec_entr_nao_receb && (entregas_nao_recebidos.length > 0)">
                          <div class="w3-col s6 m6" style="margin-top: 10px; margin-bottom: 10px; font-size: 12px;">
                            <div 
                              class="tablink w3-center" 
                              style="width: 98%; margin-top: 5px; text-decoration: underline;"
                              @click="setTabInterna('tabGerouDocumento')"   
                              :class="getClasseTabInternaAtiva('tabGerouDocumento')">
                              <b>Gerou Documento</b>
                            </div>
                          </div>
                          
                          <div class="w3-col s6 m6" style="margin-top: 10px; margin-bottom: 10px; font-size: 12px;">
                            <div 
                              class="tablink w3-center" 
                              style="width: 98%; margin-top: 5px; text-decoration: underline;"
                              @click="setTabInterna('tabNaoGerouDocumento')"   
                              :class="getClasseTabInternaAtiva('tabNaoGerouDocumento')">
                              <b>Não Gerou Documento</b>
                            </div>
                          </div>
                        </div>
                        
                        <div 
                          class="tab"
                          id="tabGerou"
                          :data-aba="'tabGerou'" 
                          style="display: block"
                          v-show="!processando_rec_entr_nao_receb && (Object.keys(entregas_nao_recebidos).length > 0) && (tabInternaAtual == 'tabGerouDocumento')">
                          
                          <div class="w3-row aba w3-animate-left w3-container cards-dados">
                          
                            <div 
                              class="w3-row w3-margin-top" 
                              v-for="(entrega, index) in entregas_nao_recebidos" :key="index">
                            
                              <strong class="w3-center w3-margin-left texto-vermelho">{{ entrega.nome_empresa }}</strong> 
                              <div 
                                :key="index_gerou"
                                class="w3-margin-top card-item w3-border w3-container"
                                v-for="(documento, index_gerou) in entrega.gerou_documentos">
                                
                                <div>
                                  <div class="w3-col">
                                    <label class="w3-left">Data pedido: </label>
                                    <label>{{documento.data_cadastro }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Empresa: </label>
                                    <label>{{ documento.nome_resumido_empresa }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Pedido: </label>
                                    <label>{{ documento.orcamento_id  }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Cliente: </label>
                                    <label>{{ documento.nome_fantasia_cliente }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Valor: </label>
                                    <label>R$ {{ documento.valor_pedido }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Vendedor: </label>
                                    <label >{{ documento.nome_vendedor }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Status: </label>
                                    <label :class="getClasseStatus(documento.recebido)">{{ getNomeStatus(documento.recebido) }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Tipo de entrega: </label>
                                    <label :class="getClassTipoEntrega(documento.recebimento_na_entrega , documento.confirmado_caixa)">
                                      {{ getNomeTipoEntrega(documento.recebimento_na_entrega , documento.confirmado_caixa) }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Vlr. Crédito manual: </label>
                                    <label >{{ documento.valor_credito_manual }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Forma de Pagamento: </label>
                                    <label>{{ documento.nome_condicao }}</label>
                                  </div>
                                  
                                </div>
                                
                                <div 
                                  class="w3-center" 
                                  v-if="index_gerou != entrega.gerou_documentos.length - 1">
                                  <i class="fas fa-minus w3-text-theme"/>
                                </div>
                              </div>

                              <div class="w3-animate-left w3-center" v-show="(Object.keys(entrega.gerou_documentos).length == 0)">
                                <label style="font-size:13px!important; font-style: italic;">
                                  Não há dados a serem exibidos.
                                </label>
                              </div>
                              
                              <paginacao 
                                @pagina="mudarPagina"
                                :pagina-atual="entrega.paginaAtual"
                                :itens-por-pagina="itensPorPagina"
                                :total-resultados="entrega.totalResultados"
                                :total-de-paginas="entrega.totalDePaginas"
                              />
                            </div>
                          </div>
                        </div>
                        
                        <div id="tabNaoGerou" class="tab" :data-aba="'tabNaoGerou'" style="display: none" v-show="!processando_rec_entr_nao_receb && (Object.keys(entregas_nao_recebidos).length > 0) && (tabInternaAtual == 'tabNaoGerouDocumento')">
                          <div class="w3-row aba w3-animate-left w3-container cards-dados">
                            <div 
                              :key="index_entrega"
                              class="w3-row w3-margin-top"
                              v-for="(entrega, index_entrega) in entregas_nao_recebidos">
                              
                              <strong class="w3-center w3-margin-left texto-vermelho">{{ entrega.nome_empresa }}</strong>   
                              <div
                                :key="index_nao_gerou"
                                class="w3-margin-top card-item w3-border w3-container"
                                v-for="(documento, index_nao_gerou) in entrega.nao_gerou_documentos">
                                
                                <div>
                                  <div class="w3-col s12">
                                    <label>Data pedido: </label>
                                    <label>{{ documento.data_cadastro }}</label>
                                  </div>
                                  
                                  <div class="w3-col s12">
                                    <label>Empresa: </label>
                                    <label>{{ documento.nome_resumido_empresa }}</label>
                                  </div>
                                  
                                  <div class="w3-col s12">
                                    <label>Pedido: </label>
                                    <label>{{ documento.orcamento_id }}</label>
                                  </div>
                                  
                                  <div class="w3-col s12">
                                    <label>Cliente: </label>
                                    <label>{{ documento.nome_fantasia_cliente }}</label>
                                  </div>
                                  
                                  <div class="w3-col s12">
                                    <label>Valor: </label>
                                    <label>R$ {{ documento.valor_pedido }}</label>
                                  </div>
                                  
                                  <div class="w3-col s12">
                                    <label>Vendedor: </label>
                                    <label>{{ documento.nome_vendedor }}</label>
                                  </div>
                                  
                                  <div class="w3-col s12">
                                    <label>Status: </label>
                                    <label :class="getClasseStatus(documento.recebido)">
                                      {{ getNomeStatus(documento.recebido) }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-col s12">
                                    <label>Tipo de entrega: </label>
                                    <label :class="getClassTipoEntrega(documento.recebimento_na_entrega , documento.confirmado_caixa)">
                                      {{ getNomeTipoEntrega(documento.recebimento_na_entrega , documento.confirmado_caixa) }}
                                    </label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Vlr. Crédito manual: </label>
                                    <label>{{ documento.valor_credito_manual }}</label>
                                  </div>
                                  
                                  <div class="w3-col">
                                    <label class="w3-left">Forma de Pagamento: </label>
                                    <label>{{ documento.nome_condicao }}</label>
                                  </div>
                                  
                                  <div class="w3-center" v-if="index_nao_gerou != entrega.nao_gerou_documentos.length - 1">
                                    <i class="fas fa-minus w3-text-theme"></i>
                                  </div>
                                </div>
                              </div>

                              <div class="w3-animate-left w3-center" v-show="(Object.keys(entrega.nao_gerou_documentos).length == 0)">
                                <label style="font-size:13px!important; font-style: italic;">
                                  Não há dados a serem exibidos.
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="w3-animate-left w3-center cards-dados w3-container" v-show="!processando_rec_entr_nao_receb && (Object.keys(entregas_nao_recebidos).length == 0)">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>
                      </div>

                      <div style="cursor: default; border-bottom-style: none" v-if="item.slug === 'notascliente'">

                        <div class="w3-col s12 m12 l12" v-show="processando_notas_fiscais">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>

                        <div class="w3-row w3-row-padding no-padding-mobile w3-animate-left" style="font-size: 14px;" v-show="!processando_notas_fiscais && (Object.keys(notas_fiscais).length > 0)">
                          <div class="wrapper-componente" style="margin-top: 5px;">
                            <div 
                              :key="index"
                              class="w3-container card-item w3-border"
                              v-for="(nota, index) in notasFiscaisFiltradas">

                              <div class="w3-col s12" style="margin-bottom: 5px; color: #333333;">
                                <div style="border-bottom: 2px dotted #a3a3a3; margin-top:5px; font-size: 12px!important;" class="w3-col s12"></div>
                                <h6 
                                  class="fundo-cabecalho-dados">
                                  &nbsp;
                                  <i class="fas fa-shopping-cart">
                                  </i>&nbsp;
                                  <strong>Tipo: </strong>
                                  <strong
                                    :style="getEstiloCor(nota.tipo_nota_cor)">
                                    {{ nota.tipo_nota_analitico }}
                                  </strong>
                                </h6>
                                <div style="border-bottom: 2px dotted #a3a3a3;" class="w3-col s12"></div>
                              </div>

                              <div class="w3-col s12">
                                <label>Data Emissão: </label>
                                <label>{{ nota.emitida == "S" ? nota.data_emissao : '' }}</label>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Número da nota: </label>
                                <strong class="w3-text-indigo">{{ nota.numero_nota }}</strong>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Valor da nota: </label>
                                <label>R$ {{ nota.valor_total_nota }}</label>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Emitida: </label>
                                <strong
                                  :style="getStyleAzulVermelho(nota.emitida)">
                                  {{ nota.emitida == "S" ? "Sim" : "Não" }}
                                </strong>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Empresa: </label>
                                <label>{{ nota.nome_resumido_empresa }}</label>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Tipo movimento: </label>
                                <label>{{ nota.tipo_movimento_analitico }}</label>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Movimento Id: </label>
                                <label>{{ nota.movimento_id }}</label>
                              </div>
                            </div>

                            <div
                              style="margin-bottom: 5px;"
                              class="w3-col l12 w3-center"
                              v-if="mostrar_botao_ver_mais_notas_fiscais && (paginaAtualNotasFiscais == totalDePaginasNotasFiscais - 1)">
                              <button
                                class="w3-button w3-theme"
                                v-on:click="buscarNotasFiscais(true)">
                                <span>Ver mais..</span>
                              </button>
                            </div>
                          </div>
                          
                          <paginacao
                            @pagina="mudarPaginaNotasFiscais"
                            :pagina-atual="paginaAtualNotasFiscais"
                            :itens-por-pagina="itensPorPagina"
                            :total-resultados="totalResultadosNotasFiscais"
                            :total-de-paginas="totalDePaginasNotasFiscais"
                          />
                        </div>

                        <div class="w3-animate-left w3-center w3-container cards-dados" v-show="!processando_notas_fiscais && (Object.keys(notas_fiscais).length == 0)">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>                        
                      </div>
                      
                      <!-- Inicio Ocorrencias-->
                      <div style="cursor: default; border-bottom-style: none" v-if="item.slug === 'ocorrencias'">

                        <div class="w3-col s12 m12 l12" v-show="processando_ocorrencias">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>

                        <div class="w3-animate-left w3-center w3-container cards-dados" v-show="!processando_ocorrencias && Object.keys(ocorrenciasFiltrados).length == 0">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>  
                        
                        <div
                          style="margin-top: 5px;"
                          class="w3-row w3-animate-left w3-row-padding no-padding-mobile"
                          v-if="!processando_ocorrencias && (autorizacoes.visualizar_ocorrencia_cadastros == 'S') && (Object.keys(ocorrenciasFiltrados).length > 0)">

                          <div class="wrapper-componente">
                            
                            <div 
                              :key="index"
                              v-for="(ocorrencia, index) in ocorrenciasFiltrados"
                              class="card-item w3-border w3-container">
                              
                              <div class="w3-col s12">
                                <label>Ocorrência: </label>
                                <strong>{{ocorrencia.ocorrencia_id}}</strong>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Data: </label>
                                <label>{{ocorrencia.data_ocorrencia}}</label>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Tipo: </label>
                                <label>{{`${ocorrencia.tipo_ocorrencia_id} ${ocorrencia.nome_tipo_ocorrencia}`}}</label>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Acessibilidade: </label>
                                <strong :class="getClasseAcessibilidade(ocorrencia.acessibilidade)">{{ocorrencia.acessibilidade_analitico}}</strong>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Usuário de inserção: </label>
                                <label>{{`${ocorrencia.usuario_cadastro_id} - ${ocorrencia.nome_usuario_cadastro}`}}</label>
                              </div>
                              
                              <div class="w3-col s12">
                                <label>Data/hora inserção: </label>
                                <label>{{ ocorrencia.data_hora_cadastro }}</label>
                              </div>
                              
                              <div class="w3-col s12" v-if="ocorrencia.nome_departamento">
                                <label>Nome do departamento: </label>
                                <label>{{  `${ocorrencia.departamento_id} - ${ocorrencia.nome_departamento}` }}</label>
                              </div>
                            
                              <div class="w3-col s12">
                                <label>Assunto: </label>
                                <label>{{ ocorrencia.assunto }}</label>
                              </div>
                            
                              <div class="w3-col s12" v-if="ocorrencia.mostrar">
                                <div class="w3-margin-top w3-margin-bottom">
                                  <fieldset class="w3-col s12 l12 w3-border" style=" border-radius: 5px">
                                    <legend>&nbsp; Observações &nbsp;</legend>
                                    <textarea 
                                      class="w3-col s12" 
                                      rows="5" 
                                      cols="33" 
                                      disabled 
                                      style="background-color: #f1f1f1;  resize: none;"
                                      v-model="ocorrencia.observacao"
                                    />
                                  </fieldset>
                                </div>
                              </div>
                              
                              <div class="conteudo-centralizado" style="margin-bottom: 5px; margin-top: 5px;">
                                <button 
                                  style="font-size: 14px; margin-top: 5px;"
                                  class="w3-button w3-theme" 
                                  @click="toogleItems(ocorrencia, !ocorrencia.mostrar)">
                                  {{ ocorrencia.mostrar ? '- Ocultar Observações' : '+ Ver Observações' }}
                                </button>
                              </div>

                            </div>
                          </div>

                          <paginacao 
                            @pagina="mudarPaginaOcorrencia"
                            :pagina-atual="paginaAtualOcorrencias"
                            :itens-por-pagina="itensPorPagina" 
                            :total-resultados="totalResultadosOcorrencias" 
                            :total-de-paginas="totalDePaginasOcorrencias" 
                          />
                        </div>
                      </div>

                      <!-- redes sociais-->
                      <div 
                        v-if="item.slug === 'sociais'" 
                        class="w3-animate-left"
                        style="cursor: default; border-bottom-style: none">

                        <div class="w3-col s12 m12 l12" v-show="processando_redes_sociais">
                          <div class="w3-panel w3-theme w3-card-2">
                            <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
                          </div>
                        </div>

                        <div class="w3-animate-left w3-center w3-container cards-dados" v-show="!processando_redes_sociais && Object.keys(redes_sociais_cliente).length == 0">
                          <label style="font-size:13px!important; font-style: italic;">
                            Não há dados a serem exibidos.
                          </label>
                        </div>

                        <div class="w3-row" style="margin-top: 5px;" v-show="!processando_redes_sociais && Object.keys(redes_sociais_cliente).length > 0">
                          
                          <div 
                            :key="index"
                            v-for="(rede_social, index) in redes_sociais_cliente"
                            class="card-item w3-container">
                              
                            <div class="w3-col s12">
                              <label>Nome rede social: </label>
                              <strong>{{ rede_social.nome }}</strong>
                            </div>
                              
                            <div class="w3-col s12">
                              <label>Endereço: </label>
                              <label style="font-style: italic;">{{ rede_social.endereco }}</label>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <pesquisa-clientes
      ref="pesquisaClientes"
      @confirmar="confirmarCliente"
    />

  </div>
</template>

<script>
import moment from "moment"
import toastr from "toastr"
import NavMenu from "@/components/Menu"
import Legenda from '@/components/Legendas'
import Paginacao from '@/components/Paginacao'
import RVidaCliente from '@/components/Rest/RVidaCliente.js'
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import formatarValorMixin from "@/mixins/formatarValorMixin.js"
import PesquisaClientes from '@/components/Pesquisas/PesquisaClientes'

export default {
  name: "VidaCliente",
  mixins: [formatarValorMixin],
  components: {
    NavMenu,
    Legenda,
    Paginacao,
    PesquisaClientes
  },
  data() {
    return {
      listaAbas: [
        {nome: "Cadastro", mostrar: false, slug: "cadastro", inativo: false, buscou_dados: false},
        {nome: "Resumo", mostrar: false, slug: "resumo", inativo: false, buscou_dados: false},
        {nome: "Financeiro", mostrar: false, slug: "financeiro", inativo: false, buscou_dados: false},
        {nome: "Lista negra", mostrar: false, slug: "listanegra", inativo: false, buscou_dados: false},
        {nome: "Pedidos", mostrar: false, slug: "pedidos", inativo: false, buscou_dados: false},
        {nome: "Acumulativos em aberto",  mostrar: false, slug: "acumulativos", inativo: false, buscou_dados: false},
        {nome: "Créditos", mostrar: false, slug: "creditos", inativo: false, buscou_dados: false},
        {nome: "Devoluções pendentes", mostrar: false, slug: "devolucoes", inativo: false, buscou_dados: false},
        {nome: "Rec. na entrega não recebidos", mostrar: false, slug: "naorecebidos", inativo: false, buscou_dados: false},
        {nome: "Notas do cliente", mostrar: false, slug: "notascliente", inativo: false, buscou_dados: false},
        {nome: "Ocorrências", mostrar: false, slug: "ocorrencias", inativo: false, buscou_dados: false},
        {nome: "Redes sociais", mostrar: false, slug: "sociais", inativo: false, buscou_dados: false}
      ],
      listaAbasInternas : [
        {tab: 'tabCadastroPrincipais', buscou_dados: false},
        {tab: 'tabCadastroReferencia', buscou_dados: false},
        {tab: 'tabCadastroObservacoes', buscou_dados: false},
        {tab: 'tabCadastroSocios', buscou_dados: false},
        {tab: 'tabCadastroSpcSerasa', buscou_dados: false},
        {tab: 'TabVendasPedidos', buscou_dados: false},
        {tab: 'TabVendasAcumulativos', buscou_dados: false},
        {tab: 'TabVendasDevolucoes', buscou_dados: false},        
        {tab: 'tabFinanceirosAberto', buscou_dados: false},
        {tab: 'tabFinanceirosBaixados', buscou_dados: false},
        {tab: 'tabFinanceirosUnificados', buscou_dados: false},
        {tab: 'tabResumoVendas', buscou_dados: false},
        {tab: 'tabResumoFinanceiro', buscou_dados: false},
      ],

      /* Buscou dados aba*/ 
      buscou_observacoes_cadastro: false,
      buscou_referencias: false,
      buscou_spcserasa: false,
      buscou_socios: false,
      buscou_lista_negra: false,
      buscou_notas_fiscais: false,
      buscou_totalizador_pedidos: false,
      buscou_acumulativo_aberto: false,
      buscou_resumo_vendas: false,
      buscou_resumo_financeiros: false,
      buscou_creditos: false,
      buscou_devolucoes_pendentes: false,
      buscou_pedido_rec_entrega_nao_recebido: false,
      buscou_ocorrencias: false,
      buscou_redes_sociais: false,
      buscou_totalizador_financeiros_abertos: false,
      buscou_totalizador_financeiros_baixados: false,
      buscou_totalizador_financeiros_unificados: false,

      /* Paginação */
      qtd_max_linhas: 50,
      tabInternaAtual: 'PED',

      /* Notas fiscais */
      notas_ja_mostradas_ids: [],
      totalDePaginas: 0,
      mostrar_botao_ver_mais_notas_fiscais: false,

      /* Pedidos */
      pedidos: [],
      pedidos_ja_mostrados_ids: [],
      mostrar_botao_ver_mais_pedidos: false,

      /* Acumulativos */
      acumulativos: [],
      acumulativos_ja_mostrados_ids: [],

      /* Devoluções */
      devolucoes: [],
      devolucoes_ja_mostrados_ids: [],

      editando: false,
      modalTelefone: false,
      numero_telefone_atual: '',
      /* Acumulativos aberto*/
      acumulativos_aberto_itens_filtrados: [],
			acumulativos_aberto_por_ender_e_emp: [],
			acumulativos_items: [],
			index_acumulativo: null,

			/* PAGINAÇÃO Acumulativo aberto*/
			paginaAtualAcum: 0,
			totalResultadosAcum: 0,
			totalDePaginasAcum: 0,
			
      /*Entrega não recebido*/
      entregas_nao_recebidos: [],
      
      /* creditos*/
      valor_total_geral: 0,
      filtro_credito: 'A',

      /* PAGINAÇÃO GEROU DOCUMENTO */
      paginaAtualGerou: 0,
      totalResultadosGerou: 0,
      totalDePaginasGerou: 0,

      /* PAGINAÇÃO NÃO GEROU DOCUMENTO*/
      paginaAtualNaoGerou: 0,
      totalResultadosNaoGerou: 0,
      totalDePaginasNaoGerou: 0,
      /*fim entrega não revebido*/
      
      /* PAGINAÇÃO */
      paginaAtual: 0,
      totalResultados: 0,
      totalDePaginas: 0,

      api: process.env.API,
      proc_carregando_vida_cliente: false,

      processando_cadastro_principais: false,
      processando_cadastro_observacoes: false,
      processando_cadastro_spc_serasa: false,
      processando_cadastro_socios: false,
      processando_resumo_vendas: false,
      processando_resumo_financeiro: false,
      processando_tot_fin_aberto: false,
      processando_tot_fin_baixado: false,
      processando_tot_fin_unificado: false,
      processando_lista_negra: false,
      processando_tot_pedidos: false,
      processando_acumulativos_aberto: false,
      processando_creditos: false,
      processando_devolucoes_pendentes: false,
      processando_rec_entr_nao_receb: false,
      processando_notas_fiscais: false,
      processando_ocorrencias: false,
      processando_redes_sociais: false,

      /*card notas*/
      notas_fiscais_filtrada: [],
      processando: false,
      
      /*Ocorrencias*/
      mostrarModalObservacao: false,
      ocorrenciaSelecionada: {},
      

      /* Modal */
      abrirModalSelecionarCliente: false,

      /* Cliente */
      mostrar_accordion: false,
      dados_cliente: {},
      observacoes_cadastro: '',
      limite_credito: {},
      clientes_filtrados: [],
      cliente_selecionado: {},
      cadastro: {},
      socios: [],
      cliente: {},
      resumo_vendas: {},
      resumo_financeiros: {},
      total_geral_pedidos: {},
      total_geral_financeiros_abertos: {},
      total_geral_financeiros_baixados: {},
      total_geral_financeiros_unificados: {},
      contatos: [],
      lista_negra: [],
      notas_fiscais: [],
      redes_sociais_cliente: [],
      referencias_bancarias: [],
      referencias_comerciais: [],
      referencias_pessoais: [],
      telefone_cadastro: [],
      devolucoes_pendentes: [],
      orcamentos_rec_entrega_nao_recebidos: [],
      creditos: [],
      consultas_serasa: [],
      consultas_spc: [],
      financeiro: [],
      financeiros_abertos: [],
      financeiros_abertos_ja_mostrados_ids: [],
      financeiros_baixados: [],
      financeiros_baixados_ja_mostrados_ids: [],
      financeiros_unificados: [],
      financeiros_unificados_ja_mostrados_ids: [],
      acumulativo_aberto: {},
      totalizadores_acumulativos: {},
      ocorrencias: [],

      /* Permisões */
      autorizacoes: {},
      
      /* pedidos*/
      indice_empresa: 0,
      sem_pedidos: false,
      mostrarModalItens: false,
      tabAtual: '',
      itens: [],
      
      /*Controle de telas*/
      mostrar_detalhes_empresa_total_pedidos: false,
      mostrar_detalhes_empresa_total_acumulativos: false,
      mostrar_detalhes_empresa_total_devolucoes: false,
      mostrar_detalhes_empresa_total_empresa: false,
      mostrar_detalhes_empresa_total_geral: false,

      /* PAGINAÇÃO PEDIDOS */
      paginaAtualItens: 0,
      totalResultadosItens: 0,
      totalDePaginasItens: 0,

      /* PAGINAÇÃO PEDIDOS */
      paginaAtualPedidos: 0,
      totalResultadosPedidos: 0,
      totalDePaginasPedidos: 0,

      /* PAGINAÇÃO DEVOLUÇÕES */
      paginaAtualDevolu: 0,
      totalResultadosDevolu: 0,
      totalDePaginasDevolu: 0,

      /* PAGINAÇÃO ACUMUA*/
      paginaAtualAcumulados: 0,
      totalResultadosAcumulados: 0,
      totalDePaginasAcumulados: 0,
      
      /* lista negra*/
      indice_linha: null,
      show_modal_observacao: false,
      mostrarModalObservacao: false,
      /*fim*/
      
      /*Financeiro*/
      financeiro_antigo: {},
      financeiro_tipo_antigo: '',
      tabAtual: 'tabFinanceirosAberto',

      itensPorPagina: 5,

      /* PAGINAÇÃO VENCIDOS */
      paginaAtualAberto: 0,
      totalResultadosAberto: 0,
      totalDePaginasAberto: 0,

      /* PAGINAÇÃO BAIXADOS */
      paginaAtualBaixado: 0,
      totalResultadosBaixado: 0,
      totalDePaginasBaixado: 0,

      /* PAGINAÇÃO UNIFICADOS */
      paginaAtualUnificado: 0,
      totalResultadosUnificado: 0,
      totalDePaginasUnificado: 0,
      /*fim Financeiro*/

      /* PAGINAÇÃO NOTAS FISCAIS */
      paginaAtualNotasFiscais: 0,
      totalResultadosNotasFiscais: 0,
      totalDePaginasNotasFiscais: 0,

      /* PAGINAÇÃO OCORRÊNCAS */
      paginaAtualOcorrencias: 0,
	    totalResultadosOcorrencias: 0,
	    totalDePaginasOcorrencias: 0,
  
      /* PAGINAÇÃO CRÉDITOS */
	    paginaAtualCreditos: 0,
	    totalResultadosCreditos: 0,
	    totalDePaginasCreditos: 0,
      
      /*resumo*/
      tabAtual: 'tabResumoVendas',
        
      /* controles de tela */
      mostrar_detalhes_formaspgto : false,
      mostrar_detalhes_ultimos90: false,
      mostrar_detalhes_ultimos180: false,
      mostrar_detalhes_ultimos365: false,
      mostrar_detalhes_atrazos_financeiros: false,
      mostrar_detalhes_primeira_venda: false,
      mostrar_detalhes_maior_venda: false,
      mostrar_detalhes_ultima_venda: false,
      mostrar_detalhes_duplicata: false,
      mostrar_detalhes_boleto: false,
      mostrar_detalhes_cheque_vista: false,
      mostrar_detalhes_cheque_prazo: false,
      mostrar_detalhes_cheque_devolvido: false,
      mostrar_detalhes_cheque_devolvido2: false,
      mostrar_detalhes_financeiro: false,
      mostrar_detalhes_limite_credito: false,
      mostrar_detalhes_totais: false,
      mostrar_detalhes_totais_empresa: false,
      mostrar_detalhes_totais_endereco: false,
      mostrar_detalhes_previsao: false,
      mostrar_detalhes_cartao: false,
      /* fim resumo*/
      
      /* cadastro*/
      referencias_socios: [],
      pessoa_fisica: false,
      pessoa_juridica: false,
      tabAtual: 'tabCadastroPrincipais',
      ultima_consulta_spc: '',
      ultima_consulta_serasa: '',
      ultima_consulta_spc_passou: false,
      ultima_consulta_serasa_passou: false,
      
      /* controle de telas*/
      mostrar_detalhes_referencia_pessoal: false,
      mostrar_detalhes_referencia_comercial: false,
      mostrar_detalhes_referencia_bancarias: false,
      mostrar_detalhes_obs_nota_fiscal: false,
      mostrar_detalhes_obs_cadastro: false,
      mostrar_detalhes_telefone: false,
      mostrar_detalhes_limite_credito: false,
      mostrar_detalhes_contato: false,
      mostrar_detalhes_socios: false,
      mostrar_detalhes_spc: false,
      mostrar_detalhes_serasa: false,

      consultas_serasa: [],
      consultas_spc: [],
      /* fim cadastro*/
      
      mostrar_modal_produtos: false,
      produtos: [],
    }
  },
  watch: {
    abrirModalSelecionarCliente() {
      this.verificarModalAberto();
    },

    mostrarModalItens() {
      this.verificarModalAberto();
    },
  },
  computed: {
    financeirosAbertosFiltrados() {
      if (!this.financeiros_abertos){
        return;
      }

      this.totalResultadosAberto = this.financeiros_abertos.length;
      this.totalDePaginasAberto = Math.ceil(this.totalResultadosAberto / this.itensPorPagina);
      
      if (this.paginaAtualAberto >= this.totalDePaginasAberto) {
        this.paginaAtualAberto = this.totalDePaginasAberto;
      }

      let index = this.paginaAtualAberto * this.itensPorPagina;

      return this.financeiros_abertos.slice(index, index + this.itensPorPagina);
    },

    financeirosBaixadosFiltrados() {
      if (!this.financeiros_baixados){
        return;
      }

      this.totalResultadosBaixado = this.financeiros_baixados.length;
      this.totalDePaginasBaixado = Math.ceil(this.totalResultadosBaixado / this.itensPorPagina);
      
      if (this.paginaAtualBaixado >= this.totalDePaginasBaixado) {
        this.paginaAtualBaixado = this.totalDePaginasBaixado;
      }

      let index = this.paginaAtualBaixado * this.itensPorPagina;

      return this.financeiros_baixados.slice(index, index + this.itensPorPagina);
    },

    financeirosUnificadosFiltrados() {
      if (!this.financeiros_unificados){
        return;
      }

      this.totalResultadosUnificado = this.financeiros_unificados.length;
      this.totalDePaginasUnificado = Math.ceil(this.totalResultadosUnificado / this.itensPorPagina);
      
      if (this.paginaAtualUnificado >= this.totalDePaginasUnificado) {
        this.paginaAtualUnificado = this.totalDePaginasUnificado;
      }

      let index = this.paginaAtualUnificado * this.itensPorPagina;

      return this.financeiros_unificados.slice(index, index + this.itensPorPagina);
    },

    notasFiscaisFiltradas() {
      if(!this.notas_fiscais){
        return;
      }

      this.totalResultadosNotasFiscais = this.notas_fiscais.length;
      this.totalDePaginasNotasFiscais = Math.ceil(this.totalResultadosNotasFiscais / this.itensPorPagina);
      if (this.paginaAtualNotasFiscais >= this.totalDePaginasNotasFiscais) {
        this.paginaAtualNotasFiscais = this.totalDePaginasNotasFiscais;
      }

      let index = this.paginaAtualNotasFiscais * this.itensPorPagina;

      return this.notas_fiscais.slice(index, index + this.itensPorPagina);
    },
    
    pedidosFiltrados() {
      this.totalResultadosPedidos = this.pedidos.length;
      this.totalDePaginasPedidos =  Math.ceil(this.totalResultadosPedidos / this.itensPorPagina);
      if(this.paginaAtualPedidos >= this.totalDePaginasPedidos) {
        this.paginaAtualPedidos = this.totalDePaginasPedidos
      }

      let index = this.paginaAtualPedidos * this.itensPorPagina;

      return this.pedidos.slice(index, index + this.itensPorPagina);
    },

    pedidosDevolucoesFiltrados() {
      this.totalResultadosDevolu = this.devolucoes.length
      this.totalDePaginasDevolu =  Math.ceil(this.totalResultadosDevolu / this.itensPorPagina)
      
      if(this.paginaAtualDevolu >= this.totalDePaginasDevolu) {
        this.paginaAtualDevolu = this.totalDePaginasDevolu;
      }

      let index = this.paginaAtualDevolu * this.itensPorPagina;

      return this.devolucoes.slice(index, index + this.itensPorPagina);
    },

    pedidosAcumuladosFiltrados() {
      this.totalResultadosAcumulados = this.acumulativos.length;
      this.totalDePaginasAcumulados =  Math.ceil(this.totalResultadosAcumulados / this.itensPorPagina);
      
      if(this.paginaAtualAcumulados >= this.totalDePaginasAcumulados) {
        this.paginaAtualAcumulados = this.totalDePaginasAcumulados;
      }

      let index = this.paginaAtualAcumulados * this.itensPorPagina;

      return this.acumulativos.slice(index, index + this.itensPorPagina);
    },

    itensFiltrados() {
      this.totalResultadosItens = this.itens.length;
      this.totalDePaginasItens =  Math.ceil(this.totalResultadosItens / this.itensPorPagina);
      
      if(this.paginaAtualItens >= this.totalDePaginasItens) {
        this.paginaAtualItens = this.totalDePaginasItens
      }

      let index = this.paginaAtualItens * this.itensPorPagina;

      return this.itens.slice(index, index + this.itensPorPagina);
    },

    ocorrenciasFiltrados() {
      if(!this.ocorrencias){
        return; 
      }

      this.totalResultadosOcorrencias = this.ocorrencias.length;
      this.totalDePaginasOcorrencias = Math.ceil(this.totalResultadosOcorrencias / this.itensPorPagina);
      if (this.paginaAtualOcorrencias >= this.totalDePaginasOcorrencias) {
        this.paginaAtualOcorrencias = this.totalDePaginasOcorrencias;
      }

      let index = this.paginaAtualOcorrencias * this.itensPorPagina;

      return this.ocorrencias.slice(index, index + this.itensPorPagina);
    },

    creditosFiltrados() {
      if(!this.creditos){
        return;
      }
      
      let creditos_filtrados = this.creditos
      
      if (this.filtro_credito != 'todos') {
        creditos_filtrados = creditos_filtrados.filter(credito => {
          return credito.status === this.filtro_credito
        })
      }

      this.valor_total_geral = 0;
      for (let i = 0; i < creditos_filtrados.length; i++) {
        this.valor_total_geral += Biblioteca.valor(creditos_filtrados[i].valor_documento);
      }

      this.totalResultadosCreditos = creditos_filtrados.length;
      this.totalDePaginasCreditos = Math.ceil(this.totalResultadosCreditos / this.itensPorPagina);
      if (this.paginaAtualCreditos >= this.totalDePaginasCreditos) {
        this.paginaAtualCreditos = this.totalDePaginasCreditos;
      }

      let index = this.paginaAtualCreditos * this.itensPorPagina;

      return creditos_filtrados.slice(index,index + this.itensPorPagina);
    },

    verificarModal() {
      if (this.mostrarModalItens){
        return true;
      } 
      else {
        return false;
      }
    },

    verificarModal() {
      if (this.abrirModalSelecionarCliente){
        return true;
      } else{
        return false;
      }
    },
  },

  async created() {
    await this.buscarAutorizacoes();
  },

  methods: {
    iniciarBuscouDados(){
      this.buscou_observacoes_cadastro = false;
      this.buscou_referencias = false;
      this.buscou_spcserasa = false;
      this.buscou_socios = false;
      this.buscou_lista_negra = false;
      this.buscou_notas_fiscais = false;
      this.buscou_totalizador_pedidos = false;
      this.buscou_acumulativo_aberto = false;
      this.buscou_resumo_vendas = false;
      this.buscou_resumo_financeiros = false;
      this.buscou_creditos = false;
      this.buscou_devolucoes_pendentes = false;
      this.buscou_pedido_rec_entrega_nao_recebido = false;
      this.buscou_ocorrencias = false;
      this.buscou_redes_sociais = false;
      this.buscou_totalizador_financeiros_abertos = false;
    },

    tratarNumeroTelefone(telefone){
      telefone = telefone.replace("-","");
      telefone = telefone.replace(" ","");
      telefone = telefone.replace("(", '');
      telefone = telefone.replace(")", '');
      return telefone;
    },
  
    async abrirTelefone(telefone, ligar, whats){
      if (!telefone){
        return;
      }
  
      try {
        this.modalTelefone = true;
        if(!ligar || !whats){
          this.numero_telefone_atual = await this.tratarNumeroTelefone(telefone);
        }
          
        if(whats){
          window.open("https://api.whatsapp.com/send?phone=" + telefone + "6&text&source&data",'_blank');
        }
          
        if(ligar){
          window.open("tel:$" + telefone);
        }
        
      } catch (error) {
        toastr.info('Não foi possivel usar o telefone') 
      }
    },
    
    pesquisarCliente() {
      this.$refs.pesquisaClientes.abrir('N');
    },

    getStyleAzulVermelho(valor, inverter_cor) {
      return Biblioteca.corAzulVermelho(valor, inverter_cor);
    },
    
    getClassPrincipal(){
      if (this.pessoa_juridica){
        return 'w3-col s6 m2 l2';
      } else{
        return 'w3-col s6 m3 l3';
      }
    },

    getEstiloCor(cor) {
      return 'color: ' + cor
    },

    getClasseTabAtiva(tabAtual) {
      try {
        if(this.tabAtual == tabAtual) {
          return 'w3-text-theme active';
        } else {
          return 'w3-text-gray';
        } 
      } catch (error) {
        // Fazer nada.
      }
    },

    getClasseTabInternaAtiva(tabAtual) {
      try {
        if(this.tabInternaAtual == tabAtual) {
          return 'w3-text-theme active';
        } else {
          return 'w3-text-gray';
        } 
      } catch (error) {
        // Fazer nada.
      }
    },

    async setTab(tabAtual) {
      for (let tab of this.listaAbasInternas) {
        this.tabAtual = tabAtual;
        await mudarAba(event, tabAtual);

        if (tabAtual == tab.tab) {
          if ((tabAtual == 'tabCadastroObservacoes') && !tab.buscou_dados){
            await this.buscarObservacoesCadastro();
          } else if ((tabAtual == 'tabCadastroReferencia') && !tab.buscou_dados){
            await this.buscarReferencias();
          } else if ((tabAtual == 'tabCadastroSpcSerasa') && !tab.buscou_dados){
            await this.buscarSpcSerasa();
          } else if ((tabAtual == 'tabCadastroSocios') && !tab.buscou_dados){
            await this.buscarSocios();
          } else if ((tabAtual == 'tabResumoVendas') && !tab.buscou_dados){
            await this.buscarResumoVendas();
          } else if ((tabAtual == 'tabResumoFinanceiro') && !tab.buscou_dados){
            await this.buscarResumoFinanceiros();
          }

          tab.buscou_dados = true;
          break;
        }
      } 
    },

    iniciarCadatro(){
      this.pessoa_fisica = this.dados_cliente.tipo_pessoa == 'F' ? true : false;
      this.pessoa_juridica = this.dados_cliente.tipo_pessoa == 'J' ? true : false;
    },

    ticketMedio(resumo_vendas) {
      try {
        let x = 
          this.formatarValor(
            (
              Biblioteca.valor(resumo_vendas.total_movimento_acumulativo) + 
              Biblioteca.valor(resumo_vendas.total_movimento_pedido)
            )  / 
            Biblioteca.valor(resumo_vendas.quant_pedido), 2
          );
          
        if (x != '-NaN'){
          return x;
        }
      } catch (error) {
        return 0; 
      }
    },

    getLabelLucroPresente(lucro_presente) {
      if (strPadraoToNumber(lucro_presente) >= 0) {
        return 'label-vista';
      }

      return 'label-devolvido';
    },
  
    verificarVencimento (movimento) {
      let date = moment(moment(), 'DD/MM/YYYY').format('DD/MM/YYYY')
      let vencido = moment(movimento.data_vencimento, 'DD/MM/YYYY').isBefore(moment(new Date(), 'DD/MM/YYYY'))
      let a_vencer = moment(movimento.data_vencimento_util, 'DD/MM/YYYY').isSameOrAfter(moment(`${date}`, 'DD/MM/YYYY'))

      // A VENCER
      if (a_vencer && (movimento.tipo != 'CV' && movimento.tipo != 'CC' && movimento.tipo != 'FI')) {
        return 'w3-text-orange';
      }

      // NÃO BAIXA LIMITE DE CRÉDITO'
      if (movimento.tipo == 'CC' || movimento.tipo == 'CV' || movimento.tipo == 'FI') {
        return 'w3-text-blue';
      }

      // VENCIDOS
      if (vencido && movimento.tipo != 'CC' && movimento.tipo != 'CV' && movimento.tipo != 'FI') {
        return 'w3-text-pink';
      }
    },

    getClassStatusProtesto(status) {
      if (status === "Enviado para cartório") {
        return 'envia_cartorio';
      } else if (status === "Protestado no SERASA") {
        return 'protesto_serasa';
      } else if (status === "Prot. rejeitado pelo cartório") {
        return 'protesto_rejeitado';
      } else if (status === "Em processo de protesto") {
        return 'envia_em_processo';
      }
    },

    getBackground(index) {
      if (index % 2 == 0) {
        return "fundo-branco";
      }
    },

    getClassTipoFinanceiro(tipo_financeiro) {
      if (tipo_financeiro == "CT") {
        return 'credito';
      } else if (tipo_financeiro == "BL") {
        return 'boleto';
      } else if (tipo_financeiro == "DP") {
        return 'duplicata';
      } else if (tipo_financeiro == "CV") {
        return 'cheve_a_vista';
      } else if (tipo_financeiro == "CP") {
        return 'cheve_a_prazo';
      } else if (tipo_financeiro == "CT") {
        return 'credito';
      } else if (tipo_financeiro == "CC") {
        return 'cartao';
      } else if (tipo_financeiro == "PR") {
        return 'previsao';
      } else if (tipo_financeiro == "FI") {
        return 'financeiro';
      } else if (tipo_financeiro == "AD") {
        return '';
      }
    },

    selectFinanceiro(empresa_id) {
      this.index_clicado = empresa_id;
    },

    /* PAGINAÇÃO */
    mudarPaginaAberto(numeroDaPagina) {
      this.paginaAtualAberto = numeroDaPagina;
    },

    mudarPaginaBaixado(numeroDaPagina) {
      this.paginaAtualBaixado = numeroDaPagina;
    },

    mudarPaginaUnificado(numeroDaPagina) {
      this.paginaAtualUnificado = numeroDaPagina;
    },
    
    async mostrarDetalhesFinanceirosAbertos(empresa_id) {
      for (let i = 0; i < this.total_geral_financeiros_abertos.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(this.total_geral_financeiros_abertos.totalizadores_empresas[i].empresa_id) == Biblioteca.valorInt(empresa_id)){

          if (!this.total_geral_financeiros_abertos.totalizadores_empresas[i].buscou_dados_financeiros_abertos) {
            await this.buscarFinanceirosAbertos(empresa_id, false);
            this.total_geral_financeiros_abertos.totalizadores_empresas[i].buscou_dados_financeiros_abertos = true;
          } else {
            this.financeiros_abertos = [];
            if (this.total_geral_financeiros_abertos.totalizadores_empresas[i].financeiros_abertos){
              this.financeiros_abertos = JSON.parse(JSON.stringify(this.total_geral_financeiros_abertos.totalizadores_empresas[i].financeiros_abertos)); 
            }
          }

          this.mostrar_detalhes_empresa_total_geral = true;
          this.total_geral_financeiros_abertos.totalizadores_empresas[i].visualizar = this.total_geral_financeiros_abertos.totalizadores_empresas[i].visualizar ? false : true;
        } else {
          this.total_geral_financeiros_abertos.totalizadores_empresas[i].visualizar = false;
        }
      }

      this.mudarPaginaAberto(0);
      this.$forceUpdate();
    },

    async mostrarDetalhesFinanceirosBaixados(empresa_id) {
      for (let i = 0; i < this.total_geral_financeiros_baixados.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(this.total_geral_financeiros_baixados.totalizadores_empresas[i].empresa_id) == Biblioteca.valorInt(empresa_id)){

          if (!this.total_geral_financeiros_baixados.totalizadores_empresas[i].buscou_dados_financeiros_baixados) {
            await this.buscarFinanceirosBaixados(empresa_id, false);
            this.total_geral_financeiros_baixados.totalizadores_empresas[i].buscou_dados_financeiros_baixados = true;
          } else {
            this.financeiros_baixados = [];
            if (this.total_geral_financeiros_baixados.totalizadores_empresas[i].financeiros_baixados){
              this.financeiros_baixados = JSON.parse(JSON.stringify(this.total_geral_financeiros_baixados.totalizadores_empresas[i].financeiros_baixados)); 
            }
          }

          this.mostrar_detalhes_empresa_total_geral = true;
          this.total_geral_financeiros_baixados.totalizadores_empresas[i].visualizar = this.total_geral_financeiros_baixados.totalizadores_empresas[i].visualizar ? false : true;
        } else {
          this.total_geral_financeiros_baixados.totalizadores_empresas[i].visualizar = false;
        }
      }

      this.mudarPaginaBaixado(0);
      this.$forceUpdate();
    },

    async mostrarDetalhesFinanceirosUnificados(empresa_id) {
      for (let i = 0; i < this.total_geral_financeiros_unificados.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(this.total_geral_financeiros_unificados.totalizadores_empresas[i].empresa_id) == Biblioteca.valorInt(empresa_id)){

          if (!this.total_geral_financeiros_unificados.totalizadores_empresas[i].buscou_dados_financeiros_unificados) {
            await this.buscarFinanceirosUnificados(empresa_id, false);
            this.total_geral_financeiros_unificados.totalizadores_empresas[i].buscou_dados_financeiros_unificados = true;
          } else {
            this.financeiros_unificados = [];
            if (this.total_geral_financeiros_unificados.totalizadores_empresas[i].financeiros_unificados){
              this.financeiros_unificados = JSON.parse(JSON.stringify(this.total_geral_financeiros_unificados.totalizadores_empresas[i].financeiros_unificados)); 
            }
          }

          this.mostrar_detalhes_empresa_total_geral = true;
          this.total_geral_financeiros_unificados.totalizadores_empresas[i].visualizar = this.total_geral_financeiros_unificados.totalizadores_empresas[i].visualizar ? false : true;
        } else {
          this.total_geral_financeiros_unificados.totalizadores_empresas[i].visualizar = false;
        }
      }

      this.mudarPaginaUnificado(0);
      this.$forceUpdate();
    },

    toogleItems(lista, mostrar) {
      for (let i = 0; i < this.lista_negra.length; i++) {
        if ( this.lista_negra[i].lista_id == lista.lista_id){
          this.lista_negra[i].mostrar = mostrar;
        } else {
          this.lista_negra[i].mostrar = false;
        }
      }

      this.$forceUpdate();
    },
    
    getClasseImpedido(impedido) {
      let retorno = 'w3-center';

      if (impedido == 'S') {
        retorno = retorno + 'impedido';
      } else {
        retorno = retorno + 'nao_impedido';
      }

      return retorno;
    },

    verificarModalAberto(){
      const el = document.documentElement
      if (this.verificarModal) {
        el.classList.add('modal-aberto');
      } else {
        el.classList.remove('modal-aberto');
      }
    },

    mudarPaginaItens(numeroDaPaginaItens) {
      this.paginaAtualItens = numeroDaPaginaItens;
    },

    mostrarModal(itens) {
      this.paginaAtualItens = 0;
      this.mostrarModalItens = true;
      this.itens = [];
      this.itens = itens.itens_pedido;
    },
    
    forcarMudarTab(nomeTab) {
      this.tabAtual = nomeTab;
      mudarAba(event, nomeTab);
    },

    async setTabInterna(nomeTab){
      this.tabInternaAtual = nomeTab;
      this.$forceUpdate();

      if (nomeTab == 'tabFinanceirosAberto'){
        await this.buscarTotalizadorFinanceirosAbertos();
      } else if (nomeTab == 'tabFinanceirosBaixados'){
        await this.buscarTotalizadorFinanceirosBaixados();
      } else if (nomeTab == 'tabFinanceirosUnificados'){
        await this.buscarTotalizadorFinanceirosUnificados();
      }

      this.$forceUpdate();
    },

    /* PAGINAÇÃO */
    mudarPaginaDevolu(numeroDaPagina) {
      this.paginaAtualDevolu = numeroDaPagina;
    },

    mudarPaginaAcumulados(numeroDaPagina) {
      this.paginaAtualAcumulados = numeroDaPagina;
    },

    mudarPaginaPedidos(numeroDaPagina) {
      this.paginaAtualPedidos = numeroDaPagina;
    },

    async mostrarDetalhesVendasEmpresas(empresa_id) {
      for (let i = 0; i < this.total_geral_pedidos.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(this.total_geral_pedidos.totalizadores_empresas[i].empresa_id) == Biblioteca.valorInt(empresa_id)){

          if (!this.total_geral_pedidos.totalizadores_empresas[i].buscou_dados_pedidos) {
            await this.buscarPedidos(empresa_id, false);
            await this.buscarDevolucoes(empresa_id, false);
            await this.buscarAcumulativos(empresa_id, false);
            this.total_geral_pedidos.totalizadores_empresas[i].buscou_dados_pedidos = true;
          } else {

            this.pedidos = [];
            if (this.total_geral_pedidos.totalizadores_empresas[i].pedidos){
              this.pedidos = JSON.parse(JSON.stringify(this.total_geral_pedidos.totalizadores_empresas[i].pedidos));
            }
            
            this.devolucoes = [];
            if (this.total_geral_pedidos.totalizadores_empresas[i].devolucoes){
              this.devolucoes = JSON.parse(JSON.stringify(this.total_geral_pedidos.totalizadores_empresas[i].devolucoes));
            }

            this.acumulativos = [];
            if (this.total_geral_pedidos.totalizadores_empresas[i].acumulativos){
              this.acumulativos = JSON.parse(JSON.stringify(this.total_geral_pedidos.totalizadores_empresas[i].acumulativos));
            }
          }

          this.total_geral_pedidos.totalizadores_empresas[i].visualizar = this.total_geral_pedidos.totalizadores_empresas[i].visualizar ? false : true;
        } else {
          this.total_geral_pedidos.totalizadores_empresas[i].visualizar = false;
        }
      }

      this.resetarPaginacao();
      this.setTabInterna('tabVendasPedidos');
      this.$forceUpdate();
    },

    resetarPaginacao() {
      /* PAGINAÇÃO PEDIDOS */
      this.paginaAtualPedidos = 0;
      this.totalResultadosPedidos = 0;
      this.totalDePaginasPedidos = 0;

      /* PAGINAÇÃO DEVOLUÇÕES */
      this.paginaAtualDevolu = 0;
      this.totalResultadosDevolu = 0;
      this.totalDePaginasDevolu = 0;

      /* PAGINAÇÃO ACUMULATIVOS */
      this.paginaAtualAcumulados = 0;
      this.totalResultadosAcumulados = 0;
      this.totalDePaginasAcumulados = 0;
    },

  	enderecoCompleto(acumulativo) {
			if (acumulativo != undefined) {
        let endereco_completo = '';
        
        if (acumulativo.logradouro_entrega){
          endereco_completo += acumulativo.logradouro_entrega;
        }
        
        if (acumulativo.complemento_entrega){
          endereco_completo += ' ' + acumulativo.complemento_entrega;
        }

        if (acumulativo.nome_bairro){
          endereco_completo += ' ' + acumulativo.nome_bairro;
        }

        if (acumulativo.nome_cidade){
          endereco_completo += ' ' + acumulativo.nome_cidade;
        }
        
        return endereco_completo;
			}
		},

		nomeEmpresa(acumulativo) {
			if (acumulativo != undefined) {
				let empresa_id = acumulativo.empresa_id !== undefined ? `${acumulativo.empresa_id} ` : '';
				let nome_resumido_empresa = acumulativo.nome_resumido_empresa !== undefined ? `${acumulativo.nome_resumido_empresa} ` : '';
        
        return empresa_id + nome_resumido_empresa;
			}
		},

		novoEndereco(novo_endereco_completo, nome_empresa) {
      let i = 0;
      
			for (; i < this.acumulativos_aberto_por_ender_e_emp.length; i++) {
				if (this.acumulativos_aberto_por_ender_e_emp[i].endereco_completo === novo_endereco_completo) {
					return i;
				}
      }

      if (novo_endereco_completo){
        this.acumulativos_aberto_por_ender_e_emp[i] = Object({ 'endereco_completo': novo_endereco_completo });
			  this.acumulativos_aberto_por_ender_e_emp[i].empresas = []; 
      }
      
      return i;
		},

		mudarPaginaProd(numeroDaPagina) {
			this.paginaAtualProd = numeroDaPagina;
		},

		mudarPaginaAcum(numeroDaPagina) {
			this.paginaAtualAcum = numeroDaPagina;
		},

		mostrarProdutos(empresa) {
			empresa.mostrar = !empresa.mostrar;
			this.$forceUpdate();
			return empresa;
		},
	
    iniciarAcumulativosAberto(){
      if(this.acumulativo_aberto.length == 0){
        return;
      }

      if (Object.keys(this.acumulativo_aberto).length) {
  			let index_endereco = 0;
  			this.acumulativos_items = this.acumulativo_aberto.acumulativos_aberto_itens;
  			this.acumulativos_aberto_itens_filtrados.forEach(acumulativo => {
  				acumulativo.mostrar = false;
  			});
  
  			for (let i = 0; i < this.acumulativo_aberto.acumulativos_aberto.length; i++) {
  				let acumulativo = this.acumulativo_aberto.acumulativos_aberto[i];
  				index_endereco = this.novoEndereco(this.enderecoCompleto(acumulativo), this.nomeEmpresa(acumulativo));
  				this.acumulativos_aberto_por_ender_e_emp[index_endereco].empresas.push(acumulativo);
        }
        
        let total_emp_valor_produtos = 0;
        let total_emp_frete_outros = 0;
        let total_emp_desconto = 0;
        let total_emp_valor_liquido = 0;
        let total_emp_devolvido = 0;
        let total_emp_saldo = 0;

  			for (let i = 0; i < this.acumulativos_aberto_por_ender_e_emp.length; i++) {
  				for (let y = 0; y < this.acumulativos_aberto_por_ender_e_emp[i].empresas.length; y++) {
            let empresa_nova = this.acumulativos_aberto_por_ender_e_emp[i].empresas[y];

            if 
              (
                (this.nomeEmpresa(empresa_nova) != this.nomeEmpresa(empresa_antiga)) ||
                (this.enderecoCompleto(empresa_nova) != this.enderecoCompleto(empresa_antiga))
              ) 
  					{
              empresa_nova.mostrar_nome_empresa = true;

              if (y > 0){
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].mostrar_totalizador_empresa = true;
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].totalizador = {};
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].totalizador.total_emp_valor_produtos = Biblioteca.nPadrao(total_emp_valor_produtos);
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].totalizador.total_emp_frete_outros = Biblioteca.nPadrao(total_emp_frete_outros);
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].totalizador.total_emp_desconto = Biblioteca.nPadrao(total_emp_desconto);
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].totalizador.total_emp_valor_liquido = Biblioteca.nPadrao(total_emp_valor_liquido);
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].totalizador.total_emp_devolvido = Biblioteca.nPadrao(total_emp_devolvido);
                this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].totalizador.total_emp_saldo = Biblioteca.nPadrao(total_emp_saldo);
                
                // Iniciando totalizador
                total_emp_valor_produtos = Biblioteca.valor(empresa_nova.valor_produtos);
                total_emp_frete_outros = (
                  (empresa_nova.tipo_frete != 'C' ? Biblioteca.valor(empresa_nova.valor_perc_frete) : 0) +
                  Biblioteca.valor(empresa_nova.valor_frete_terceirizado) +
                  Biblioteca.valor(empresa_nova.valor_frete_andar) + 
                  Biblioteca.valor(empresa_nova.valor_frete_adicional) + 
                  Biblioteca.valor(empresa_nova.valor_frete_extra_manual)
                );

                total_emp_desconto = Biblioteca.valor(empresa_nova.valor_desconto);
                total_emp_valor_liquido = Biblioteca.valor(empresa_nova.valor_pedido);
                total_emp_devolvido = Biblioteca.valor(empresa_nova.valor_dev_acum_aberto);
                total_emp_saldo = Biblioteca.valor(empresa_nova.valor_pedido) - Biblioteca.valor(empresa_nova.valor_dev_acum_aberto);
              }
            }

            if 
              (
                ( 
                  (y > 0) &&
                  (!this.acumulativos_aberto_por_ender_e_emp[i].empresas[y - 1].mostrar_totalizador_empresa)
                ) ||
                ( 
                  (y == 0) &&
                  (!this.acumulativos_aberto_por_ender_e_emp[i].empresas[0].mostrar_totalizador_empresa)
                )
              )
            {
              // Totalizadores
              total_emp_valor_produtos += Biblioteca.valor(empresa_nova.valor_produtos);
              total_emp_frete_outros += (
                (empresa_nova.tipo_frete != 'C' ? Biblioteca.valor(empresa_nova.valor_perc_frete) : 0) +
                Biblioteca.valor(empresa_nova.valor_frete_terceirizado) +
                Biblioteca.valor(empresa_nova.valor_frete_andar) + 
                Biblioteca.valor(empresa_nova.valor_frete_adicional) + 
                Biblioteca.valor(empresa_nova.valor_frete_extra_manual)
              );

              total_emp_desconto += Biblioteca.valor(empresa_nova.valor_desconto);
              total_emp_valor_liquido += Biblioteca.valor(empresa_nova.valor_pedido);
              total_emp_devolvido += Biblioteca.valor(empresa_nova.valor_dev_acum_aberto);
              total_emp_saldo += Biblioteca.valor(empresa_nova.valor_pedido) - Biblioteca.valor(empresa_nova.valor_dev_acum_aberto);
            }
  
  					if (this.enderecoCompleto(empresa_nova) != this.enderecoCompleto(empresa_antiga)) {
  						empresa_nova.mostrar_nome_endereco = true;
  					}
  
  					if (y == this.acumulativos_aberto_por_ender_e_emp[i].empresas.length - 1) {
              // Totalizador endereço
              empresa_nova.mostrar_totalizador = true;
              
              // Totalizador empresas
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].mostrar_totalizador_empresa = true;
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].totalizador = {};
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].totalizador.total_emp_valor_produtos = Biblioteca.nPadrao(total_emp_valor_produtos);
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].totalizador.total_emp_frete_outros = Biblioteca.nPadrao(total_emp_frete_outros);
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].totalizador.total_emp_desconto = Biblioteca.nPadrao(total_emp_desconto);
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].totalizador.total_emp_valor_liquido = Biblioteca.nPadrao(total_emp_valor_liquido);
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].totalizador.total_emp_devolvido = Biblioteca.nPadrao(total_emp_devolvido);
              this.acumulativos_aberto_por_ender_e_emp[i].empresas[y].totalizador.total_emp_saldo = Biblioteca.nPadrao(total_emp_saldo);

              total_emp_valor_produtos = 0;
              total_emp_frete_outros = 0;
              total_emp_desconto = 0;
              total_emp_valor_liquido = 0;
              total_emp_devolvido = 0;
              total_emp_saldo = 0;
  					}
  
  					let empresa_antiga = empresa_nova;
  				}
  			}
  		}
    },

    iniciarCredito(){
      if(!this.creditos){
        return;
      }

      this.valor_total_geral = 0;
      let creditos_filtrados = this.creditos;
      for (let i = 0; i < creditos_filtrados.length; i++) {
        if (creditos_filtrados[i].status == 'A') {
          this.creditos[i].status_nome = 'Em aberto'
        } else if (creditos_filtrados[i].status == 'B') {
          this.creditos[i].status_nome = 'Baixado'
        }

        this.valor_total_geral += Biblioteca.valor(creditos_filtrados[i].valor_documento);
      }
    },

    getColorStatus(status) {
      if (status == 'A') {
        return 'aberto';
      } else if (status == 'B') {
        return 'baixado';
      }
    },

    inicializarDevolucaoPedente(){
      if(!this.devolucao){
        return;
      }

      if (this.devolucao != undefined){S
        this.devolucoes_pendentes.forEach(devolucao => {
          let total_itens = 0;
          devolucao.mostrar = false;
        });
      }
    },

    mostrartItems(devolucao) {
      if(!this.devolucoes_pendentes){
        return;
      }

      for (let i = 0; i < this.devolucoes_pendentes.length; i++) {
        if (this.devolucoes_pendentes[i].requisicao_id == devolucao.requisicao_id){
          this.devolucoes_pendentes[i].mostrar = ! this.devolucoes_pendentes[i].mostrar;
        } else {
          this.devolucoes_pendentes[i].mostrar = false;
        }
      }

      this.$forceUpdate();
    },

		getClasseGerarCredito(gerrarCredito) {
			if (gerrarCredito == "S"){
				return "gerar_credito";
      }

      return 'nao_gerar_credito';
    },
    
    existeRecebimentoNaEntregaGerouDocumento(){
      if (!this.entregas_nao_recebidos){
        return false;
      }

      for (i = 0; i < this.entregas_nao_recebidos.length; i++) {

      }
    },

    carregarEntregaNaoRecebido(){
      this.cleanArray();

      if (this.orcamentos_rec_entrega_nao_recebidos !== undefined) {
        const empresa_ids = this.orcamentos_rec_entrega_nao_recebidos.map((empresa)=>{
          return empresa.empresa_id
        });
  
        const empresa_id_sem_repetir = empresa_ids.filter(function(empresa, index, self) {
          return self.indexOf(empresa) == index;
        });
  
        this.entregas_nao_recebidos = empresa_id_sem_repetir.map((empresa_id)=>{
          const entregas = this.orcamentos_rec_entrega_nao_recebidos.filter((empresa)=>{
            return empresa_id == empresa.empresa_id
          });
  
          const gerados = entregas.filter((entrega) => {
            return entrega.confirmado_caixa == 'S'
          });

          const nao_gerados = entregas.filter((entrega) => {
            return entrega.confirmado_caixa == 'N'
          }); 

          return {
            "empresa_id": empresa_id,
            "nome_empresa": `${entregas[0].empresa_id} - ${entregas[0].nome_resumido_empresa}`,
            "nao_gerou_documentos": nao_gerados,
            "gerou_documentos": gerados,
            'paginaAtual': 0,
            'itensPorPagina': 2,
            'totalResultados': 0,
            'totalDePaginas': 0,
          }
        })
      }       
    },

    mudar(elem){
      try {
        let i, x, tablinks;

        x = document.getElementsByClassName("tab");
        if(x.length == 0){
          return;
        }
        
        tablinks = document.getElementsByClassName("tab-pendencia");

        for (i = 0; i < x.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        for (i = 0; i < x.length; i++) {
          x[i].style.display = "none";
          if (x[i].dataset.aba == elem) {
            x[i].style.display = "block"
            tablinks[i].className += " active";
          }
        }
      } catch (error) {
        console.log('Metódo mudar(): ' + error.message);
      }
    },

    getNomeStatus (recebido) {
      if (recebido == 'N') {
        return 'Ag.Rec.';
      }

      return 'Ag.Imp.Cupom';
    },

    getClasseStatus (recebido) {
      if (recebido == 'N') {
        return 'status_agendamento_recebido';
      } else {
        return 'status_agendamento_nao-recebido'
      }
    },
    
    cleanArray() {
      this.entregas_nao_recebidos = [];
    },

    getNomeTipoEntrega (recebimento_na_entrega, confirmado_caixa) {
      if (recebimento_na_entrega == 'S' && confirmado_caixa == 'N') {
        return 'Gerar Documento';
      } 
        
      return 'Entregar';
    },

    getClassTipoEntrega (recebimento_na_entrega, confirmado_caixa) {
      if (recebimento_na_entrega == 'S' && confirmado_caixa == 'N') {
        return 'tipo_gerar_documento';
      } 
      
      return 'tipo_entregar';
    },

    getClasseTipoNota(tipo_nota) {
      let classe = "";

      if (tipo_nota == "N") classe += "texto_verde";
      else if (tipo_nota == "C") classe += "texto_azul";

      return classe;
    },

    getClasseNotaEmitida(tipo_nota) {
      let classe = "";

      if (tipo_nota == "S") classe += "texto_azul";
      else if (tipo_nota == "N") classe += "texto_vermelho";

      return classe;
    },

     /* PAGINAÇÃO */
    mudarPagina(numeroDaPagina) {
      this.paginaAtual = numeroDaPagina;
    },

    mudarPaginaOcorrencia(numeroDaPagina) {
      this.paginaAtualOcorrencias = numeroDaPagina;
    },

    mudarPaginaCredito(numeroDaPagina) {
      this.paginaAtualCreditos = numeroDaPagina;
    },

    mudarPaginaNotasFiscais(numeroDaPagina) {
      this.paginaAtualNotasFiscais = numeroDaPagina;
    },
   
    getClasseAcessibilidade(acessibilidade) {
      let classe = "";

      if (acessibilidade == "DEP"){
        classe += "texto_verde";
      } else if (acessibilidade == "PUB"){
        classe += "texto_azul";
      } else if (acessibilidade == "PRI"){
        classe += "texto_roxa";
      }

      return classe;
    },

    toogleItems(ocorrencia, mostrar) {
      for (let i = 0; i < this.ocorrencias.length; i++) {
        if ( this.ocorrencias[i].ocorrencia_id == ocorrencia.ocorrencia_id) {
          this.ocorrencias[i].mostrar = mostrar;
        } else {
          this.ocorrencias[i].mostrar = false;
        }
      }

      this.$forceUpdate();
    },

    verificarModalAberto(){
      const el = document.documentElement;
      if (this.verificarModal) {
        el.classList.add('modal-aberto');
      } else {
        el.classList.remove('modal-aberto');
      }
    },

    verificarCliente() {
      if (Object.keys(this.dados_cliente).length < 1) {
        toastr.error("É necessário escolher um cliente");
      }
    },

    async toogleCard(slug, mostrar) {
      for (let i of this.listaAbas) {
        if (i.slug === slug && Object.keys(this.cliente_selecionado).length != 0) {
          i.mostrar = mostrar;

          if ((i.slug === 'cadastro')){
            this.setTab('tabCadastroPrincipais')
          } else if ((i.slug === 'listanegra') && !i.buscou_dados){
            await this.buscarListaNegra();
          } else if ((i.slug === 'pedidos') && !i.buscou_dados){
            await this.buscarTotalizadorPedidos();
          } else if ((i.slug === 'acumulativos') && !i.buscou_dados){
            await this.buscarAcumulativoAberto();
          } else if (i.slug === 'resumo'){
            this.setTab('tabResumoVendas');
          } else if ((i.slug === 'creditos') && !i.buscou_dados){
            await this.buscarCreditos();
          } else if ((i.slug === 'devolucoes') && !i.buscou_dados){
            await this.buscarDevolucoesPendentes();
          } else if (i.slug === 'naorecebidos'){
            if (!i.buscou_dados){
              await this.buscarPedidoRecEntregaNaoRecebido();
            }
            
            await this.setTabInterna('tabGerouDocumento');
          } else if ((i.slug === 'notascliente') && !i.buscou_dados){
            await this.buscarNotasFiscais(false);
          } else if ((i.slug === 'ocorrencias') && !i.buscou_dados){
            await this.buscarOcorrencias();
          } else if ((i.slug === 'sociais') && !i.buscou_dados){
            await this.buscarRedesSociais();
          } else if (i.slug === 'financeiro'){
            await this.setTabInterna('tabFinanceirosAberto');
          }

          i.buscou_dados = true;
        } else {
          i.mostrar = false;
        }
      }

      this.$forceUpdate();
    },

    async alternarDetalhesVendas(id, tipo_movimento){
      if (tipo_movimento == 'PED'){
        for (let i = 0; i < this.pedidos.length; i++) {
          if (this.pedidos[i].id == id){
            await this.buscarItensPedidos(i);
            this.pedidos[i].mostrar_itens = this.pedidos[i].mostrar_itens ? false : true;
            break;
          }
        }
      } else if (tipo_movimento == 'ACU'){
        for (let i = 0; i < this.acumulativos.length; i++) {
          if (this.acumulativos[i].id == id){
            await this.buscarItensAcumulativo(i);
            this.acumulativos[i].mostrar_itens = this.acumulativos[i].mostrar_itens ? false : true;
            break;
          }
        }
      } else if (tipo_movimento == 'DEV'){
        for (let i = 0; i < this.devolucoes.length; i++) {
          if (this.devolucoes[i].id == id){
            await this.buscarItensDevolucao(i);
            this.devolucoes[i].mostrar_itens = this.devolucoes[i].mostrar_itens ? false : true;
            break;
          }
        }
      }

      this.$forceUpdate();
    },

    async confirmarCliente(cliente) {
      await this.limparDadosCliente();

      this.editando = true;
      this.abrirModalSelecionarCliente = false;
      this.proc_carregando_vida_cliente = true;
      
      // Alimentando os dados do cliente
      this.cliente_selecionado = JSON.parse(JSON.stringify(cliente));

      for (let aba of this.listaAbas) {
        aba.mostrar = false;
      }

      await this.buscarVidaCliente();
    },

    async limparDadosCliente() {
      /* Armazenando em váriaveis auxiliar, para após limpar os dados voltar as devidas autorizações*/
      let autorizacoes_aux = JSON.parse(JSON.stringify(this.autorizacoes));
      
      await Object.assign(this.$data, this.$options.data.call(this));
      await this.iniciarBuscouDados();

      /* Voltando as autorizações */
      this.autorizacoes = JSON.parse(JSON.stringify(autorizacoes_aux));
      
      // Set tela
      this.editando = false;
    },

    async buscarAutorizacoes(){
      try {
        let retorno = await RVidaCliente.buscarAutorizacoes(this.axios);
        
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }
        
        this.autorizacoes = {
          permitir_visualizar_lucratividade_mix: retorno.dados.permitir_visualizar_lucratividade_mix,
          visualizar_observacoes_cadastro_dados_cliente: retorno.dados.visualizar_observacoes_cadastro_dados_cliente,
          visualizar_ocorrencia_cadastros: retorno.dados.visualizar_ocorrencia_cadastros
        }
      } catch (error) {
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarVidaCliente() {
      try {
        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_cadastro_principais = true;

        let retorno = await RVidaCliente.buscarDadosCadastro(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }
        
        this.mostrar_accordion = true;
        this.mostrar_detalhes_spc = true;
        this.mostrar_detalhes_socios = true;
        this.mostrar_detalhes_serasa = true;
        this.mostrar_detalhes_contato = true;
        this.mostrar_detalhes_telefone = true;
        this.mostrar_detalhes_limite_credito = true;
        this.mostrar_detalhes_obs_nota_fiscal = true;
        this.mostrar_detalhes_obs_cadastro = true;
        this.mostrar_detalhes_referencia_pessoal = true;
        this.mostrar_detalhes_referencia_bancarias = true;
        this.mostrar_detalhes_referencia_comercial = true;

        this.dados_cliente = {};
        if (retorno.dados.dados_cliente){
          this.dados_cliente = JSON.parse(JSON.stringify(retorno.dados.dados_cliente));
        }

        this.contatos = [];
        if (retorno.dados.contatos){
          this.contatos = JSON.parse(JSON.stringify(retorno.dados.contatos));
        }
        
        this.telefone_cadastro = [];
        if (retorno.dados.telefone_cadastro) {
          this.telefone_cadastro = JSON.parse(JSON.stringify(retorno.dados.telefone_cadastro));
        }
        
        this.limite_credito = {};
        if (retorno.dados.limite_credito){
          this.limite_credito = JSON.parse(JSON.stringify(retorno.dados.limite_credito));
        }

        this.iniciarCadatro();
        this.toogleCard("cadastro", true);

        this.processando_cadastro_principais = false;
      } catch (e) {
        this.processando_cadastro_principais = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarObservacoesCadastro(){
      try {
        
        if (this.buscou_observacoes_cadastro){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_cadastro_observacoes = true;

        let retorno = await RVidaCliente.buscarObservacoesCadastro(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.observacoes_cadastro = '';
        if (retorno.dados.observacoes_cadastro){
          this.observacoes_cadastro = JSON.parse(JSON.stringify(retorno.dados.observacoes_cadastro));
        }

        this.processando_cadastro_observacoes = false;
        this.buscou_observacoes_cadastro = true;
      } catch (e) {
        this.processando_cadastro_observacoes = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarReferencias(){
      try {
        
        if (this.buscou_referencias){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.proc_carregando_vida_cliente = true;

        let retorno = await RVidaCliente.buscarReferencias(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.referencias_bancarias = [];
        if (retorno.dados.referencias_bancarias){
          this.referencias_bancarias = JSON.parse(JSON.stringify(retorno.dados.referencias_bancarias));
        }

        this.referencias_comerciais = [];
        if (retorno.dados.referencias_comerciais){
          this.referencias_comerciais = JSON.parse(JSON.stringify(retorno.dados.referencias_comerciais));
        }

        this.referencias_pessoais = [];
        if (retorno.dados.referencias_pessoais){
          this.referencias_pessoais = JSON.parse(JSON.stringify(retorno.dados.referencias_pessoais));
        }

        this.proc_carregando_vida_cliente = false;
        this.buscou_referencias = true;
      } catch (e) {
        this.proc_carregando_vida_cliente = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarSpcSerasa(){
      try {

        if (this.buscou_spcserasa){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_cadastro_spc_serasa = true;

        let retorno = await RVidaCliente.buscarSpcSerasa(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.consultas_serasa = [];
        if (retorno.dados.consultas_serasa){
          this.consultas_serasa = JSON.parse(JSON.stringify(retorno.dados.consultas_serasa));
        }

        this.consultas_spc = [];
        if (retorno.dados.consultas_spc){
          this.consultas_spc = JSON.parse(JSON.stringify(retorno.dados.consultas_spc));
        }

        this.processando_cadastro_spc_serasa = false;
        this.buscou_spcserasa = true;
      } catch (e) {
        this.processando_cadastro_spc_serasa = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarSocios(){
      try {

        if (this.buscou_socios){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_cadastro_socios = true;

        let retorno = await RVidaCliente.buscarSocios(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.socios = [];
        if (retorno.dados.socios){
          this.socios = JSON.parse(JSON.stringify(retorno.dados.socios));
        }

        this.processando_cadastro_socios = false;
        this.buscou_socios = true;
      } catch (e) {
        this.processando_cadastro_socios = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarListaNegra(){
      try {
        if (this.buscou_lista_negra){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_lista_negra = true;

        let retorno = await RVidaCliente.buscarListaNegra(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.lista_negra = [];
        if (retorno.dados.lista_negra){
          this.lista_negra = JSON.parse(JSON.stringify(retorno.dados.lista_negra));
        }

        this.processando_lista_negra = false;
        this.buscou_lista_negra = true;
      } catch (e) {
        this.processando_lista_negra = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarNotasFiscais(ver_mais){
      try {

        if (this.buscou_notas_fiscais && !ver_mais){
          return;
        }
        
        if (!ver_mais){
          this.notas_fiscais = [];
          this.notas_ja_mostradas_ids = [];
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id,
          notas_ja_mostradas_ids: this.notas_ja_mostradas_ids,
          qtd_max_linhas: this.qtd_max_linhas
        }

        this.processando_notas_fiscais = true;

        let retorno = await RVidaCliente.buscarNotasFiscais(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados.notas_fiscais){
          for (let i = 0; i < retorno.dados.notas_fiscais.length; i++) {
            this.notas_fiscais.push(JSON.parse(JSON.stringify(retorno.dados.notas_fiscais[i])));
            this.notas_ja_mostradas_ids.push(retorno.dados.notas_fiscais[i].nota_fiscal_id);
          }
        }

        this.mostrar_botao_ver_mais_notas_fiscais = false;
        if (retorno.dados.tem_continuacao){
          this.mostrar_botao_ver_mais_notas_fiscais = retorno.dados.tem_continuacao == 'S';
        }

        if (ver_mais) {
          this.paginaAtualNotasFiscais++;           
        } else {
          this.paginaAtualNotasFiscais = 0; 
        }

        this.processando_notas_fiscais = false;
        this.buscou_notas_fiscais = true;
      } catch (e) {
        this.processando_notas_fiscais = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarTotalizadorPedidos(){
      try {

        if (this.buscou_totalizador_pedidos){
          return;
        }
        
        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_tot_pedidos = true;

        let retorno = await RVidaCliente.buscarTotalizadorPedidos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.total_geral_pedidos = {};
        if (retorno.dados.total_geral_pedidos){
          this.total_geral_pedidos = JSON.parse(JSON.stringify(retorno.dados.total_geral_pedidos));  
        }

        this.mostrar_detalhes_empresa_total_geral = true;
        this.processando_tot_pedidos = false;
        this.buscou_totalizador_pedidos = true;
      } catch (e) {
        this.processando_tot_pedidos = false;
        Biblioteca.exclamar(e.message);
      }
    },

    posicaoEmpresaTotalizadorPedidos(empresa_id){
      let posic = -1;

      if (!empresa_id){
        return posic;
      }

      if (!this.total_geral_pedidos){
        return posic;
      }

      if (!this.total_geral_pedidos.totalizadores_empresas){
        return posic;
      }

      for (let i = 0; i < this.total_geral_pedidos.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(empresa_id) === Biblioteca.valorInt(this.total_geral_pedidos.totalizadores_empresas[i].empresa_id)){
          posic = i;
          break;  
        }
      }

      return posic;
    },

    async buscarPedidos(empresa_id, ver_mais){
      try {

        let posicEmpresa = await this.posicaoEmpresaTotalizadorPedidos(empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        if (!ver_mais){
          this.pedidos = [];
          this.pedidos_ja_mostrados_ids = [];
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].pedidos = [];
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id,
          empresa_id: empresa_id,
          tipo_movimento: 'PED',
          pedidos_ja_mostrados_ids: this.pedidos_ja_mostrados_ids,
          qtd_max_linhas: this.qtd_max_linhas
        }
        
        let retorno = await RVidaCliente.buscarPedidos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados.pedidos){
          for (let i = 0; i < retorno.dados.pedidos.length; i++) {
            this.pedidos_ja_mostrados_ids.push(retorno.dados.pedidos[i].id);
            this.pedidos.push(JSON.parse(JSON.stringify(retorno.dados.pedidos[i])));
            this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].pedidos.push(JSON.parse(JSON.stringify(retorno.dados.pedidos[i])));
          }
        }

        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_pedidos = false;
        if (retorno.dados.tem_continuacao){
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_pedidos = retorno.dados.tem_continuacao == 'S';
        }

        if (ver_mais) {
          this.paginaAtualPedidos++;           
          this.$forceUpdate();
        } else {
          this.paginaAtualPedidos = 0;
        }
      } catch (e) {
        this.proc_carregando_vida_cliente = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarAcumulativos(empresa_id, ver_mais){
      try {

        let posicEmpresa = await this.posicaoEmpresaTotalizadorPedidos(empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        if (!ver_mais){
          this.acumulativos = [];
          this.acumulativos_ja_mostrados_ids = [];
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].acumulativos = [];
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id,
          empresa_id: empresa_id,
          tipo_movimento: 'ACU',
          pedidos_ja_mostrados_ids: this.acumulativos_ja_mostrados_ids,
          qtd_max_linhas: this.qtd_max_linhas
        }

        let retorno = await RVidaCliente.buscarPedidos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados.pedidos){
          for (let i = 0; i < retorno.dados.pedidos.length; i++) {
            this.acumulativos_ja_mostrados_ids.push(retorno.dados.pedidos[i].id);
            this.acumulativos.push(JSON.parse(JSON.stringify(retorno.dados.pedidos[i])));
            this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].acumulativos.push(JSON.parse(JSON.stringify(retorno.dados.pedidos[i])));
          }
        }

        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_acumulativos = false;
        if (retorno.dados.tem_continuacao){
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_acumulativos = retorno.dados.tem_continuacao == 'S';
        }

        if (ver_mais) {
          this.paginaAtualAcumulados++;           
          this.$forceUpdate();
        }
      } catch (e) {
        this.proc_carregando_vida_cliente = false;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarDevolucoes(empresa_id, ver_mais){
      try {
        let posicEmpresa = await this.posicaoEmpresaTotalizadorPedidos(empresa_id);
        
        if (posicEmpresa == -1){
          return;
        }

        if (!ver_mais){
          this.devolucoes = [];
          this.devolucoes_ja_mostrados_ids = [];
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].devolucoes = [];
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id,
          empresa_id: empresa_id,
          tipo_movimento: 'DEV',
          pedidos_ja_mostrados_ids: this.devolucoes_ja_mostrados_ids,
          qtd_max_linhas: this.qtd_max_linhas
        }

        let retorno = await RVidaCliente.buscarPedidos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados.pedidos){
          for (let i = 0; i < retorno.dados.pedidos.length; i++) {
            this.devolucoes_ja_mostrados_ids.push(retorno.dados.pedidos[i].id);
            this.devolucoes.push(JSON.parse(JSON.stringify(retorno.dados.pedidos[i])));
            this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].devolucoes.push(JSON.parse(JSON.stringify(retorno.dados.pedidos[i])));
          }
        }

        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_devolucoes = false;
        if (retorno.dados.tem_continuacao){
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_devolucoes = retorno.dados.tem_continuacao == 'S';
        }

        if (ver_mais) {
          this.paginaAtualDevolu++;           
          this.$forceUpdate();
        }
      } catch (e) {
        this.proc_carregando_vida_cliente = false;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarItensPedidos(index){
      try {

        if (this.pedidos[index].buscou_dados){
          return;
        }

        let posicEmpresa = await this.posicaoEmpresaTotalizadorPedidos(this.pedidos[index].empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        let parametros = {
          movimento_id: this.pedidos[index].id,
          tipo_movimento: 'PED'
        }

        let retorno = await RVidaCliente.buscarItensPedidos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.pedidos[index].itens_pedido = [];
        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].pedidos[index].itens_pedido = [];
        if (retorno.dados){
          this.pedidos[index].itens_pedido = JSON.parse(JSON.stringify(retorno.dados));
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].pedidos[index].itens_pedido = JSON.parse(JSON.stringify(retorno.dados));
        }

        this.pedidos[index].buscou_dados = true;
        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].pedidos[index].buscou_dados = true;
      } catch (e) {
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarItensAcumulativo(index){
      try {

        if (this.acumulativos[index].buscou_dados){
          return;
        }

        let posicEmpresa = await this.posicaoEmpresaTotalizadorPedidos(this.acumulativos[index].empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        let parametros = {
          movimento_id: this.acumulativos[index].id,
          tipo_movimento: 'ACU'
        }

        let retorno = await RVidaCliente.buscarItensPedidos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.acumulativos[index].itens_pedido = [];
        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].acumulativos[index].itens_pedido = [];
        if (retorno.dados){
          this.acumulativos[index].itens_pedido = JSON.parse(JSON.stringify(retorno.dados));
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].acumulativos[index].itens_pedido = JSON.parse(JSON.stringify(retorno.dados));
        }

        this.acumulativos[index].buscou_dados = true;
        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].acumulativos[index].buscou_dados = true;
      } catch (e) {
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarItensDevolucao(index){
      try {

        if (this.devolucoes[index].buscou_dados){
          return;
        }

        let posicEmpresa = await this.posicaoEmpresaTotalizadorPedidos(this.devolucoes[index].empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        let parametros = {
          movimento_id: this.devolucoes[index].id,
          tipo_movimento: 'DEV'
        }

        let retorno = await RVidaCliente.buscarItensPedidos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.devolucoes[index].itens_pedido = [];
        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].devolucoes[index].itens_pedido = [];
        if (retorno.dados){
          this.devolucoes[index].itens_pedido = JSON.parse(JSON.stringify(retorno.dados));
          this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].devolucoes[index].itens_pedido = JSON.parse(JSON.stringify(retorno.dados));
        }

        this.devolucoes[index].buscou_dados = true;
        this.total_geral_pedidos.totalizadores_empresas[posicEmpresa].devolucoes[index].buscou_dados = true;
      } catch (e) {
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarAcumulativoAberto(){
      try {

        if (this.buscou_acumulativo_aberto){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_acumulativos_aberto = true;
        let retorno = await RVidaCliente.buscarAcumulativoAberto(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.acumulativo_aberto = {};
        this.totalizadores_acumulativos = {};
        if (retorno.dados.acumulativo_aberto){
          this.acumulativo_aberto = JSON.parse(JSON.stringify(retorno.dados.acumulativo_aberto));

          if (retorno.dados.acumulativo_aberto.totalizadores_acumulativos){
            this.totalizadores_acumulativos = JSON.parse(JSON.stringify(retorno.dados.acumulativo_aberto.totalizadores_acumulativos));
          }
        }

        await this.iniciarAcumulativosAberto();
        this.mostrar_detalhes_totais = true;
        this.mostrar_detalhes_totais_empresa = true;
        this.mostrar_detalhes_totais_endereco = true;
        this.processando_acumulativos_aberto = false;
        this.buscou_acumulativo_aberto = true;
      } catch (e) {
        this.processando_acumulativos_aberto = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarResumoVendas(){
      try {

        if (this.buscou_resumo_vendas){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_resumo_vendas = true;
        let retorno = await RVidaCliente.buscarResumoVendas(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.resumo_vendas = [];
        if (retorno.dados.resumo_vendas){
          this.resumo_vendas = JSON.parse(JSON.stringify(retorno.dados.resumo_vendas));
        }

        this.processando_resumo_vendas = false;

        this.mostrar_detalhes_formaspgto = false;
        this.mostrar_detalhes_ultimos90 = false;
        this.mostrar_detalhes_ultimos180 = false;
        this.mostrar_detalhes_ultimos365 = false;
        this.mostrar_detalhes_atrazos_financeiros = false;
        this.mostrar_detalhes_primeira_venda = false;
        this.mostrar_detalhes_maior_venda = false;
        this.mostrar_detalhes_ultima_venda = false;
        
        this.buscou_resumo_vendas= true;
      } catch (e) {
        this.processando_resumo_vendas = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarResumoFinanceiros(){
      try {

        if (this.buscou_resumo_financeiros){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_resumo_financeiro = true;
        let retorno = await RVidaCliente.buscarResumoFinanceiros(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.resumo_financeiros = [];
        if (retorno.dados.resumo_financeiros){
          this.resumo_financeiros = JSON.parse(JSON.stringify(retorno.dados.resumo_financeiros));
        }

        this.processando_resumo_financeiro = false;

        this.mostrar_detalhes_duplicata = true;
        this.mostrar_detalhes_boleto = true;
        this.mostrar_detalhes_cheque_vista = true;
        this.mostrar_detalhes_cheque_prazo = true;
        this.mostrar_detalhes_cheque_devolvido = true;
        this.mostrar_detalhes_cheque_devolvido2 = true;
        this.mostrar_detalhes_cartao = true;
        this.mostrar_detalhes_financeiro = true;
        this.mostrar_detalhes_limite_credito = true;
        this.mostrar_detalhes_previsao = true;
        this.mostrar_detalhes_totais = true;

        this.buscou_resumo_financeiros = true;
      } catch (e) {
        this.processando_resumo_financeiro = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarCreditos(){
      try {

        if (this.buscou_creditos){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_creditos = true;
        let retorno = await RVidaCliente.buscarCreditos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.creditos = [];
        if (retorno.dados.creditos){
          this.creditos = JSON.parse(JSON.stringify(retorno.dados.creditos));
        }

        await this.iniciarCredito();

        this.mostrar_detalhes_totais = true;
        this.processando_creditos = false;
        this.buscou_creditos = true;
      } catch (e) {
        this.processando_creditos = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarDevolucoesPendentes(){
      try {

        if (this.buscou_devolucoes_pendentes){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_devolucoes_pendentes = true;
        let retorno = await RVidaCliente.buscarDevolucoesPendentes(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.devolucoes_pendentes = [];
        if (retorno.dados.devolucoes_pendentes){
          this.devolucoes_pendentes = JSON.parse(JSON.stringify(retorno.dados.devolucoes_pendentes));
        }

        await this.inicializarDevolucaoPedente();

        this.processando_devolucoes_pendentes = false;
        this.buscou_devolucoes_pendentes = true;
      } catch (e) {
        this.processando_devolucoes_pendentes = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarPedidoRecEntregaNaoRecebido(){
      try {

        if (this.buscou_pedido_rec_entrega_nao_recebido){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_rec_entr_nao_receb = true;
        let retorno = await RVidaCliente.buscarPedidoRecEntregaNaoRecebido(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.orcamentos_rec_entrega_nao_recebidos = [];
        if (retorno.dados.orcamentos_rec_entrega_nao_recebidos){
          this.orcamentos_rec_entrega_nao_recebidos = JSON.parse(JSON.stringify(retorno.dados.orcamentos_rec_entrega_nao_recebidos));
        }

        await this.carregarEntregaNaoRecebido();

        this.processando_rec_entr_nao_receb = false;
        this.buscou_pedido_rec_entrega_nao_recebido = true;
      } catch (e) {
        this.processando_rec_entr_nao_receb = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarOcorrencias(){
      try {

        if (this.buscou_ocorrencias){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_ocorrencias = true;
        let retorno = await RVidaCliente.buscarOcorrencias(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.ocorrencias = [];
        if (retorno.dados.ocorrencias){
          this.ocorrencias = JSON.parse(JSON.stringify(retorno.dados.ocorrencias));
        }

        this.processando_ocorrencias = false;
        this.buscou_ocorrencias = true;
      } catch (e) {
        this.processando_ocorrencias = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarRedesSociais(){
      try {

        if (this.buscou_redes_sociais){
          return;
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_redes_sociais = true;
        let retorno = await RVidaCliente.buscarRedesSociais(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.redes_sociais_cliente = [];
        if (retorno.dados.redes_sociais_cliente){
          this.redes_sociais_cliente = JSON.parse(JSON.stringify(retorno.dados.redes_sociais_cliente));
        }

        this.processando_redes_sociais = false;
        this.buscou_redes_sociais = true;
      } catch (e) {
        this.processando_redes_sociais = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    posicaoEmpresaTotalizadorFinanceirosAbertos(empresa_id){
      let posic = -1;

      if (!empresa_id){
        return posic;
      }

      if (!this.total_geral_financeiros_abertos){
        return posic;
      }

      if (!this.total_geral_financeiros_abertos.totalizadores_empresas){
        return posic;
      }

      for (let i = 0; i < this.total_geral_financeiros_abertos.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(empresa_id) === Biblioteca.valorInt(this.total_geral_financeiros_abertos.totalizadores_empresas[i].empresa_id)){
          posic = i;
          break;  
        }
      }

      return posic;
    },

    async buscarTotalizadorFinanceirosAbertos(){
      try {

        if (this.buscou_totalizador_financeiros_abertos){
          return;
        }
        
        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_tot_fin_aberto = true;
        this.$forceUpdate();

        let retorno = await RVidaCliente.buscarTotalizadorFinanceirosAbertos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.total_geral_financeiros_abertos = {};
        if (retorno.dados.total_geral_financeiros_abertos){
          this.total_geral_financeiros_abertos = JSON.parse(JSON.stringify(retorno.dados.total_geral_financeiros_abertos));
        }

        this.buscou_totalizador_financeiros_abertos = true;
        this.mostrar_detalhes_empresa_total_geral = true;
        this.processando_tot_fin_aberto = false;
      } catch (e) {
        this.processando_tot_fin_aberto = false;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarFinanceirosAbertos(empresa_id, ver_mais){
      try {

        let posicEmpresa = await this.posicaoEmpresaTotalizadorFinanceirosAbertos(empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        if (!ver_mais){
          this.financeiros_abertos = [];
          this.financeiros_abertos_ja_mostrados_ids = [];
          this.total_geral_financeiros_abertos.totalizadores_empresas[posicEmpresa].financeiros_abertos = [];
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id,
          empresa_id: empresa_id,
          financeiros_abertos_ja_mostrados_ids: this.financeiros_abertos_ja_mostrados_ids,
          qtd_max_linhas: this.qtd_max_linhas
        }
        
        let retorno = await RVidaCliente.buscarFinanceirosAbertos(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados.financeiros_abertos){
          for (let i = 0; i < retorno.dados.financeiros_abertos.length; i++) {
            this.financeiros_abertos_ja_mostrados_ids.push(retorno.dados.financeiros_abertos[i].financeiro_id);
            this.financeiros_abertos.push(JSON.parse(JSON.stringify(retorno.dados.financeiros_abertos[i])));
            this.total_geral_financeiros_abertos.totalizadores_empresas[posicEmpresa].financeiros_abertos.push(JSON.parse(JSON.stringify(retorno.dados.financeiros_abertos[i])));
          }
        }

        this.total_geral_financeiros_abertos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_financeiros = false;
        if (retorno.dados.tem_continuacao){
          this.total_geral_financeiros_abertos.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_financeiros = retorno.dados.tem_continuacao == 'S';
        }

        if (ver_mais) {
          this.paginaAtualAberto++;           
          this.$forceUpdate();
        } else {
          this.paginaAtualAberto = 0;
        }
      } catch (e) {
        this.proc_carregando_vida_cliente = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    posicaoEmpresaTotalizadorFinanceirosBaixados(empresa_id){
      let posic = -1;

      if (!empresa_id){
        return posic;
      }

      if (!this.total_geral_financeiros_baixados){
        return posic;
      }

      if (!this.total_geral_financeiros_baixados.totalizadores_empresas){
        return posic;
      }

      for (let i = 0; i < this.total_geral_financeiros_baixados.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(empresa_id) === Biblioteca.valorInt(this.total_geral_financeiros_baixados.totalizadores_empresas[i].empresa_id)){
          posic = i;
          break;  
        }
      }

      return posic;
    },

    async buscarTotalizadorFinanceirosBaixados(){
      try {

        if (this.buscou_totalizador_financeiros_baixados){
          return;
        }
        
        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_tot_fin_baixado = true;

        let retorno = await RVidaCliente.buscarTotalizadorFinanceirosBaixados(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.total_geral_financeiros_baixados = {};
        if (retorno.dados.total_geral_financeiros_baixados){
          this.total_geral_financeiros_baixados = JSON.parse(JSON.stringify(retorno.dados.total_geral_financeiros_baixados));
        }

        this.buscou_totalizador_financeiros_baixados = true;
        this.mostrar_detalhes_empresa_total_geral = true;
        this.processando_tot_fin_baixado = false;
      } catch (e) {
        this.processando_tot_fin_baixado = false;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarFinanceirosBaixados(empresa_id, ver_mais){
      try {

        let posicEmpresa = await this.posicaoEmpresaTotalizadorFinanceirosBaixados(empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        if (!ver_mais){
          this.financeiros_baixados = [];
          this.financeiros_baixados_ja_mostrados_ids = [];
          this.total_geral_financeiros_baixados.totalizadores_empresas[posicEmpresa].financeiros_baixados = [];
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id,
          empresa_id: empresa_id,
          financeiros_baixados_ja_mostrados_ids: this.financeiros_baixados_ja_mostrados_ids,
          qtd_max_linhas: this.qtd_max_linhas
        }
        
        let retorno = await RVidaCliente.buscarFinanceirosBaixados(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados.financeiros_baixados){
          for (let i = 0; i < retorno.dados.financeiros_baixados.length; i++) {
            this.financeiros_baixados_ja_mostrados_ids.push(retorno.dados.financeiros_baixados[i].financeiro_id);
            this.financeiros_baixados.push(JSON.parse(JSON.stringify(retorno.dados.financeiros_baixados[i])));
            this.total_geral_financeiros_baixados.totalizadores_empresas[posicEmpresa].financeiros_baixados.push(JSON.parse(JSON.stringify(retorno.dados.financeiros_baixados[i])));
          }
        }

        this.total_geral_financeiros_baixados.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_financeiros = false;
        if (retorno.dados.tem_continuacao){
          this.total_geral_financeiros_baixados.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_financeiros = retorno.dados.tem_continuacao == 'S';
        }

        if (ver_mais) {
          this.paginaAtualBaixado++;           
          this.$forceUpdate();
        } else {
          this.paginaAtualBaixado = 0;
        }
      } catch (e) {
        this.proc_carregando_vida_cliente = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },

    posicaoEmpresaTotalizadorFinanceirosUnificados(empresa_id){
      let posic = -1;

      if (!empresa_id){
        return posic;
      }

      if (!this.total_geral_financeiros_unificados){
        return posic;
      }

      if (!this.total_geral_financeiros_unificados.totalizadores_empresas){
        return posic;
      }

      for (let i = 0; i < this.total_geral_financeiros_unificados.totalizadores_empresas.length; i++) {
        if (Biblioteca.valorInt(empresa_id) === Biblioteca.valorInt(this.total_geral_financeiros_unificados.totalizadores_empresas[i].empresa_id)){
          posic = i;
          break;  
        }
      }

      return posic;
    },

    async buscarTotalizadorFinanceirosUnificados(){
      try {

        if (this.buscou_totalizador_financeiros_unificados){
          return;
        }
        
        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id
        }

        this.processando_tot_fin_unificado = true;

        let retorno = await RVidaCliente.buscarTotalizadorFinanceirosUnificados(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        this.total_geral_financeiros_unificados = {};
        if (retorno.dados.total_geral_financeiros_unificados){
          this.total_geral_financeiros_unificados = JSON.parse(JSON.stringify(retorno.dados.total_geral_financeiros_unificados));
        }

        this.buscou_totalizador_financeiros_unificados = true;
        this.mostrar_detalhes_empresa_total_geral = true;
        this.processando_tot_fin_unificado = false;
      } catch (e) {
        this.processando_tot_fin_unificado = false;
        Biblioteca.exclamar(e.message);
      }
    },

    async buscarFinanceirosUnificados(empresa_id, ver_mais){
      try {

        let posicEmpresa = await this.posicaoEmpresaTotalizadorFinanceirosUnificados(empresa_id);

        if (posicEmpresa == -1){
          return;
        }

        if (!ver_mais){
          this.financeiros_unificados = [];
          this.financeiros_unificados_ja_mostrados_ids = [];
          this.total_geral_financeiros_unificados.totalizadores_empresas[posicEmpresa].financeiros_unificados = [];
        }

        let parametros = {
          cadastro_id: this.cliente_selecionado.cadastro_id,
          empresa_id: empresa_id,
          financeiros_unificados_ja_mostrados_ids: this.financeiros_unificados_ja_mostrados_ids,
          qtd_max_linhas: this.qtd_max_linhas
        }
        
        let retorno = await RVidaCliente.buscarFinanceirosUnificados(this.axios, parametros);
        if (retorno.houve_erro != 'N'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados.financeiros_unificados){
          for (let i = 0; i < retorno.dados.financeiros_unificados.length; i++) {
            this.financeiros_unificados_ja_mostrados_ids.push(retorno.dados.financeiros_unificados[i].financeiro_id);
            this.financeiros_unificados.push(JSON.parse(JSON.stringify(retorno.dados.financeiros_unificados[i])));
            this.total_geral_financeiros_unificados.totalizadores_empresas[posicEmpresa].financeiros_unificados.push(JSON.parse(JSON.stringify(retorno.dados.financeiros_unificados[i])));
          }
        }

        this.total_geral_financeiros_unificados.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_financeiros = false;
        if (retorno.dados.tem_continuacao){
          this.total_geral_financeiros_unificados.totalizadores_empresas[posicEmpresa].mostrar_botao_ver_mais_financeiros = retorno.dados.tem_continuacao == 'S';
        }

        if (ver_mais) {
          this.paginaAtualUnificado++;           
          this.$forceUpdate();
        } else {
          this.paginaAtualUnificado = 0;
        }
      } catch (e) {
        this.proc_carregando_vida_cliente = false;
        this.mostrar_accordion = true;
        Biblioteca.exclamar(e.message);
      }
    },
  },
}
</script>

<style scoped>
.cards-dados{
  background-color:  #ffffff;
  box-shadow: #a6a6a6 1px 2px 5px 2px;
  border-radius: 10px;
  padding: 3px!important;
  margin:5px !important;
}
#div_badge {
  padding-left: 5px;
  align-content: center;
  align-self: center;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
}

.w3-card {
  padding: 20px;
}

.chip-vencimento {
  border-radius: 25px;
  cursor: pointer;
  font-size: 0.9em;
  padding: 10px 15px;
  text-decoration: underline;
}

.card-box {
  border-left: 3px solid #9c1d1c;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  padding: 5px 10px;
}
.card-box .w3-text-theme {
  text-transform: uppercase;
}
.card-box {
  transition: 0.2s;
}
.card-box:hover {
  cursor: pointer;
  background-color: #f1f1f1;
}
th,
td {
  white-space: nowrap;
  overflow-x: auto;
}

.tr-items-ativo {
  background: #9c1d1c;
  color: white;
}

.tr-items:hover {
  background: #9c1d1cb8;
    color:#fff;
  cursor: pointer;
}

.mapa-financeiro-card {
  padding-left: 8px !important;
  margin: 10px !important;
}

.tr-subitems {
  border: 1px solid #f1f1f1;
  background: white;
}

.w3-bordered {
  border-top: 0px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.btn.active{
  background-color: gray;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

tr {
  transition: 0.3s;
}

.w3-vermelho {
  background: #9c1d1c;
}

.table-interior {
  border: 1px solid #b1b1b1 !important;
}

.card-informacoes {
  float: left;
  padding: 7px;
  width: 100%;
}

.card-ativo {
  border-left-color: #9c1d1c !important;
  cursor: default;
}

.card-interno {
  background: white;
}

.w3-card {
  padding: 0;
}

.clienteAtivo {
  color: #4caf50;
}

.clienteInativo {
  color: #9c1d1c;
}

.clienteInativoBagdet {
  color: #fff;
  background-color: #8d1007;
}

.inativo {
  opacity: 0.6;
  cursor: not-allowed;
}

.card-ativo {
  background: white;
  border-left-color: #9c1d1c !important;
}

@media screen and (max-width: 768px) {
  .drop-down-left {
    right: -22%;
  }
}
/*estilo ocorrencias*/

.texto_verde {
  color: #1e824c;
  font-weight: bold;
}

.texto_azul {
  color: #175aa6;
  font-weight: bold;
}

.texto_roxa {
  color: #8e44ad;
  font-weight: bold;
}

.tr-items:hover {
  background: #9c1d1cb8;
  color:#fff;
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.tr-items-ativo:hover {
  background: #9c1d1c;
  color: white;
}

.tr-items-ativo {
  background: #9c1d1c;
  color: white;
}

.tabale-aberta {
  background: #9c1d1c;
  color: white;
}

.tr-titulo, .resultado-titulo {
  padding: 10px !important;
  background: #565454b8;
  color:white
}

.pesquisar-titulo {
  margin: auto;
  text-align: center;
  cursor: pointer;
  border: #636363 1px solid;
  padding: 10px;
  transition: 0.1s;
  background: #9c1d1c;
  color: white;
}

.pesquisar-titulo:hover {
  background: white;
  color: black
}

.label-info {
  line-height: 35px;
  border-bottom: 1px solid black
}

.line-label {
  line-height: 35px;
  text-align: right;
  border-bottom: 1px solid black
}
/* fim ocorrencias*/
/* card notas*/
.alinhamento-numero {
  text-align: right;
}
.alinhamento-string {
  text-align: left;
}
.alinhamento-geral {
  text-align: center;
}

.texto_vermelho {
  color: #cf000f;
  font-weight: bold;
}

/*fim*/
/* entrega não recebido*/
.tipo_entregar {
  color: #f62459;
  font-weight: bold;
}

.tipo_gerar_documento {
  color: #d91e18;
  font-weight: bold;
}

.status_agendamento_recebido {
  color:#1e824c;
  font-weight: bold;
}

.status_agendamento_nao-recebido {
  color:#d91e18;
  font-weight: bold;
}

.inativo {
  opacity: 0.6;
  background: #f1f1f1;
  cursor: not-allowed;
}

.tablink:hover{
  color:  gray !important;
  font-weight: bold !important;
}
.tablink:active{
  color:  gray !important;
  font-weight: bold !important;
}


.label-info {
  line-height: 35px; 
  border-bottom: 1px solid black
}

.line-label {
  line-height: 35px;
  text-align: right; 
  border-bottom: 1px solid black
}

/* credito */

.credito {
  font-weight: bold;
  color: #4d13d1
}
.aberto {
  font-weight: bold;
  color: #2980b9
}
.baixado {
  font-weight: bold;
  color: #1e824c
}
/* Acumulativos Aberto8*/
.label-vermelha {
	color: #9c1d1c;
}

.tr-items:hover {
	background: #9c1d1cb8;
	color:#fff;
	cursor: pointer;
}
.tr-items-ativo:hover {
  background: #9c1d1c;
  color: white;
}
.tr-items-ativo {
  background: #9c1d1c;
  color: white;
}

.total_geral {
  font-weight: bold;
  color: #049372
}
/* pedidos*/

.total_pedidos {
  font-weight: bold;
  color: #252595;
}

.total_devolucao {
  font-weight: bold;
  color: #cf000f
}

.total_acumulativos {
  font-weight: bold;
  color: #1e824c
}

.total_geral {
  font-weight: bold;
  color: #049372
}

.left-border {
  border-left-style: solid;
  border-left-color: #9c1d1c !important;
}

.accordion {
  color: #8d1007 ;
}

.accordion-button:hover {
  background-color: #8d1007  !important;
  color: #fff !important;
}

.accordion-selected {
  background-color: #8d1007  !important;
  color: #fff !important;
}

.tr-items:hover {
  background: #9c1d1cb8;
  color:#fff;
  cursor: pointer;
}

.fundo-cabecalho {
  background-color: gray !important;
  color: white;
  margin-left: 2px;
  border-radius: 5px;
  font-size: 14px;
}

/*lista negra*/

.text-observacao {
  width: 100%;
  height: 10vw;
}

.impedido {
  font-weight: bold;
  color: #d91e18
}

.nao_impedido {
  font-weight: bold;
  color: #4d13d1
}

.tr-items:hover {
  background: #9c1d1cb8;
  color:#fff;
  cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.tr-items-ativo:hover {
  background: #9c1d1c;
  color: white;
}
.tr-items-ativo {
  background: #9c1d1c;
  color: white;
}
.tabale-aberta {
  background: #9c1d1c;
  color: white;
}

.tr-titulo, .resultado-titulo {
  padding: 10px !important;
  background: #565454b8;
  color:white
}
.pesquisar-titulo {
  margin: auto;
  text-align: center;
  cursor: pointer;
  border: #636363 1px solid;
  padding: 10px;
  transition: 0.1s;
  background: #9c1d1c;
  color: white;
}
.pesquisar-titulo:hover {
  background: white;
  color: black
}

/*financeiro*/
.sem-margem {
  margin: 0
}
td, th {
  white-space: nowrap;
}

.titulo-vermelho {
  color: #8d1007
}

.fundo-cinza {
  background-color: #f1f1f1;
}

.fundo-branco {
  background-color: #fff !important;
}

.texto-preto {
  color: #000;
}

.boleto {
  font-weight: bold;
  color: #9a12b3;
}

.credito {
  font-weight: bold;
  color: #89c4f4
}

.cartao {
  font-weight: bold;
  color: #f7ca18
}

.duplicata {
  color: #34495e;
  font-weight: bold;
}

.previsao {
  font-weight: bold;
  color: #27ae60
}

.financeiro {
  font-weight: bold;
  color: #e17055;
}

.total_geral {
  font-weight: bold;
  color: #049372
}

.cheve_a_vista {
  font-weight: bold;
  color: #192a56;
}
.cheve_a_prazo {
  font-weight: bold;
  color: #2d3436
}

.envia_cartorio {
  color: #c29700
}

.protesto_serasa {
  color: #ff8000
}

.protesto_rejeitado {
  color: #ad0000
}

.envia_em_processo {
  color: #ad0080
}

.teve_contato {
  color: #4d13d1
}

.label-info {
  line-height: 35px;
  border-bottom: 1px solid black
}

.line-label {
  line-height: 35px;
  text-align: right;
  border-bottom: 1px solid black
}

.atencao-clean {
  clear: both;
}

.atencao-titulo {
  background-color: #0ba764;
  padding: 5px;
  font-size: 14px;
  margin-right: 14px;
  border-radius: 5px;

  color: #f1f1f1;
  font-weight: bold;
  text-align: center;
  letter-spacing: .5px;
}

@media screen and (max-width: 990px) and (min-width: 602px){
  .label-card {
    padding: 5px
  }
}

@media screen and (max-width: 768px){
  .no-padding {
    padding: 0 !important;
  }
}

.w3-text-pink {
  color: #e01d53;
}

/* resumo */
.label-boleto {
  color: #800080;
}

.label-duplicata {
  color: #008080;
}

.label-vista {
  color: #0000FE;
}

.label-prazo {
  color: #0000AB;
}

.label-devolvido {
  color: #EA0000;
}

.label-cartao {
  color: #808000;
}

.label-financeiro {
    color: #800000;
}

.label-credito {
  color: #A6CAF0;
}

.label-previsao {
  color: #008000;
}

.margem-espacamento {
  margin-left: 0;
  padding-left: 0px;
  padding-right: 0px;
}

.tabela-atraso-financeiros td {
  white-space: normal;
}

.fundo-cabecalho {
  background-color: #9c1d1c;
  color: white;
  margin-left: 2px;
  border-radius: 5px;
  font-size: 14px!important;
}

/* cadastro*/
.w3-card {
    padding: 10px;
    box-shadow: none !important;
}

.w3-row {
    padding-top: 0px;
    padding-bottom: 00px;
}

.w3-container {
    margin-bottom: 20px
}
.limite-mensal {
  min-height: 40px;
  position: relative;
}
.sem-margem {
  margin: 0;
}
.limite-mensal label {
  margin: 0;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, 50%);
  float: left;
}

.text-observacao {
  width: 100%;
  height: 30vw;
}

.label-vermelha {
  color: #9c1d1c;
  text-align: center;
  border: #d4d4d4 solid 1px;
  background-color: white;
}

.block-label-vermelha {
  border: #9c1d1c solid 1px;
  color: #9c1d1c;
  background-color: white;
}

th, td {
  white-space: nowrap !important;
}

.alinhamento-numero {
  text-align: right;
}

.alinhamento-string {
  text-align: left;
}

.alinhamento-geral {
  text-align: center;
}

.texto_azul {
   color: #4d13d1;
  font-weight: bold
}

.texto_vermelho {
  color: #9c1d1c;
  font-weight: bold;
}
.margem-espacamento {
  margin-left: 0;
  padding-left: 0px;
  padding-right: 0px;
}


.accordion-button:hover {
  background-color: #8d1007  !important;
  color: #fff !important;
}

.item-pai {
  display: -webkit-flex !important;
  display: flex !important;
  align-content: flex-end !important;
}

.item {
  align-content: flex-end !important;
}

.item-style {
  margin-top: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 2px 20px #00000050;
  min-height: 76px;
}

.item h5 {
  font-size: 16px;
}

.bloco{
  padding: 5px 16px
}

.table-scroll {
  overflow-y:scroll;
  height:190px;
  display:block;
}
.margin{
  margin-top: 5px;
  padding-right: 12px;
  padding-left: 0px!important;
}
.w3-row-padding{
padding: 0 0px;
}

.card-item {
  background: white;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 5px !important;
  border: 2px solid #ccc;
}

</style>



// WEBPACK FOOTER //
// src/components/VidaCliente.vue